import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { Col, DatePicker, theme, Drawer, Row, Select } from "antd";
import dayjs from "dayjs";
import type { RadioChangeEvent } from "antd";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
// import { Typography } as TypographyAnt from 'antd';

// import { Button, Steps } from "antd";

import { Avatar, Switch } from "antd";
import { Card } from "antd";
import Typography from "@mui/material/Typography";
// import { Button, CardActionArea, CardActions } from '@mui/material';

import type { Dayjs } from "dayjs";
import type { TimeRangePickerProps } from "antd";
import customParseFormat from "dayjs/plugin/customParseFormat";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import type { DatePickerProps } from "antd";
import type { CellRenderInfo } from "rc-picker/es/interface";
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import { Radio } from "antd";

import SettingsIcon from "@mui/icons-material/Settings";
import type { TableProps } from "antd/es/table";
import { Dropdown, Form, Modal, message } from "antd";
import { AppstoreOutlined, SearchOutlined } from "@ant-design/icons";
import { Skeleton } from "antd";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import type { MenuProps } from "antd";

import type { FilterValue, SorterResult } from "antd/es/table/interface";

import Highlighter from "react-highlight-words";
import type { InputRef } from "antd";
import { Input, Space, Table } from "antd";
import type { ColumnType, ColumnsType } from "antd/es/table";
import type { FilterConfirmProps } from "antd/es/table/interface";
import {} from "@mui/x-data-grid";
import { notification } from "antd";

import axios from "axios";

import Globais, {
  AlterarFormatoData,
  CalcularDiferencaDias,
  InativarTokenPeriodoUsuario,
  adicionarDiasData,
  atualizarPeriodoUsuario,
  definirFasePeriodoUsuario,
  enviarEmail,
  exibirMoeda,
  formatarData,
  formatarDataDayJs,
  logout,
  naoFracione,
  qualSituacao,
  tratamentoValoresInput,
  validateDataCheckOutMaior,
  validatePeriodoFracionado,
  validateSegundaDataEMaior,
  validateToken,
  venderCota,
} from "../../components/Globais";

import MenuItem from "@mui/material/MenuItem";
import { NumberParam, StringParam, useQueryParams } from "use-query-params";
import TextArea from "antd/es/input/TextArea";
import warning from "antd/es/_util/warning";
import { Alert, Collapse, Tooltip } from "@mui/material";
import { light } from "@mui/material/styles/createPalette";
import ConfirmarPeriodoUsuario from "../../screens/ConfirmarPeriodoUsuario";
import { isBuffer } from "util";

type NotificationType = "success" | "info" | "warning" | "error";

const Container = styled.section`
  width: 100%;
  height: 100%;
  background-color: #ecf0f1;

  display: grid;
`;
const ContainerSucess = styled.div`
  display: flex;
  margin-top: 5rem;
  justify-content: center;
  align-items: center;
`;

const defaultPeriodoUsuarioData = {
  alugar: 0,
  trocar: 0,
  utilizar: 0,
  concluido: 0,
  divulgado: 0,
  fracionamento: 0,
  dataSugestao: "",
  valorMin: "",
  valorSugerido: "",
  id: 0,
  status: "",
  idPE: 0,
  checkIn: "",
  checkOut: "",
  idCota: 0,
  numeroCota: 0,
  idApto: 0,
  idEmpreend: 0,
  situacaoAnterior: "",
  statusAnterior: "",
  nome: "",
};

export default function ViewConfirmarPeriodoUsuario() {
  //variavies
  const [nIdPEU, setNidPEU] = useQueryParams({
    idPEU: NumberParam,
  });
  const [api, contextHolder] = notification.useNotification();
  const [nTipoEmail, setNtipoEmail] = useQueryParams({
    tipoEmail: NumberParam,
  });
  const [nToken, setToken] = useQueryParams({ token: StringParam });
  const [periodoUsuarioData, setPeriodoUsuarioData] = useState(
    defaultPeriodoUsuarioData
  );
  const [
    periodoUsuarioDataPrimeiroPeriodo,
    setPeriodoUsuarioDataPrimeiroPeriodo,
  ] = useState(defaultPeriodoUsuarioData);
  const [
    periodoUsuarioDataSegundoPeriodo,
    setPeriodoUsuarioDataSegundoPeriodo,
  ] = useState(defaultPeriodoUsuarioData);

  const [messageApi, contextHolder2] = message.useMessage();
  const { token } = theme.useToken();
  const [current, setCurrent] = useState(0);

  const [inputNovoValorPeriodoUnico, setInputNovoValorPeriodoUnico] =
    useState("");
  const [inputReservaPeriodoUnico, setInputReservaPeriodoUnico] = useState("");
  const [inputReservaPeriodoPrincipal, setInputReservaPeriodoPrincipal] =
    useState("");
  const [inputNovoValorPeriodoPrincipal, setInputNovoValorPeriodoPrincipal] =
    useState("");
  const [inputReserva1Fracao, setInputReserva1Fracao] = useState("");
  const [inputNovoValor1Fracao, setInputNovoValor1Fracao] = useState("");
  const [inputReserva2Fracao, setInputReserva2Fracao] = useState("");
  const [inputNovoValor2Fracao, setInputNovoValor2Fracao] = useState("");

  const [isLoading, setIsLoading] = useState(true);
  const [valueRadioPeriodoUnico, setValueRadioPeriodoUnico] = useState(1);
  const [valueRadioPeriodoPrincipal, setValueRadioPeriodoPrincipal] =
    useState(1);
  const [valueRadio1Fracao, setValueRadio1Fracao] = useState(1);
  const [valueRadio2Fracao, setValueRadio2Fracao] = useState(1);
  const [openErrorFase1, setOpenErrorFase1] = useState(false);
  const [openErrorFase2, setOpenErrorFase2] = useState(false);
  const [openErrorFase3, setOpenErrorFase3] = useState(false);
  const [openSucess, setOpenSucess] = useState(false);

  const [fase1Ok, setFase1Ok] = useState(false);
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set<number>());
  const contador = useRef(0);
  const codErro = useRef(0);
  const textoMensagem = useRef("");
  const emPreparo = useRef(true);

  const cotaUsuarioId = useRef(0);
  // const { Text } = TypographyAnt;

  useEffect(() => {
    const fetch = async () => {
      try {
        const URL = `${Globais.DOMINIOBACK}/auth/validarToken/confirmacaoperiodo/validar/${nIdPEU.idPEU}/${nToken.token}`;

        const response = await axios.get(URL);
        if (response) {
          localStorage.setItem("accessToken", response.data.accessToken);

          const URLPEU = `${Globais.DOMINIOBACK}/periodo-usuario/informacoesCompletas/${nIdPEU.idPEU}`;
          // const URLPEU = `${Globais.DOMINIOBACK}/periodo-usuario/informacoesCompletas/757`;
          const Token = `Bearer ${localStorage.getItem("accessToken")}`;
          if (Token) {
            const responsePEU = await axios.get(URLPEU, {
              headers: { Authorization: Token },
            });

            if (responsePEU) {
              setPeriodoUsuarioData((prevState) => ({
                ...prevState,
                alugar: responsePEU.data.alugar,
                trocar: responsePEU.data.trocar,
                utilizar: responsePEU.data.utilizar,
                concluido: responsePEU.data.concluido,
                divulgado: responsePEU.data.divulgado,
                fracionamento: responsePEU.data.fracionamento,
                dataSugestao: responsePEU.data.dataSugestao,
                valorMin: responsePEU.data.valorMin,
                valorSugerido: responsePEU.data.valorSugerido,
                id: responsePEU.data.id,
                status: responsePEU.data.status,
                situacaoAnterior: responsePEU.data.situacaoAnterior,
                statusAnterior: responsePEU.data.statusAnterior,
                idPE: responsePEU.data.PeriodoTable.id,
                checkIn: responsePEU.data.PeriodoTable.checkIn,
                checkOut: responsePEU.data.PeriodoTable.checkOut,
                idCota: responsePEU.data.PeriodoTable.CotaTable.id,
                numeroCota: responsePEU.data.PeriodoTable.CotaTable.numeroCota,
                idApto: responsePEU.data.PeriodoTable.CotaTable.AptoTable.id,
                idEmpreend:
                  responsePEU.data.PeriodoTable.CotaTable.AptoTable
                    .EmpreendimentoTable.id,
                nome: responsePEU.data.PeriodoTable.CotaTable.AptoTable
                  .EmpreendimentoTable.nome,
              }));
              if (!(nTipoEmail.tipoEmail === 3 || nTipoEmail.tipoEmail === 4)) {
                const URLPEUFrac = `${Globais.DOMINIOBACK}/periodo-usuario/fracionados/${nIdPEU.idPEU}`;
                const responsePEUFrac = await axios.get(URLPEUFrac, {
                  headers: { Authorization: Token },
                });
                if (responsePEUFrac.data.length > 0) {
                  let counter = 0;
                  responsePEUFrac.data.filter(async (p: any) => {
                    let ArrayNovo = responsePEUFrac.data.filter(
                      async (p: any) => {
                        p.key = p.id;

                        const URLPEUFrac1 = `${Globais.DOMINIOBACK}/periodo-usuario/informacoesCompletas/${p.id}`;
                        const responsePEUFrac1 = await axios.get(URLPEUFrac1, {
                          headers: { Authorization: Token },
                        });
                        if (
                          responsePEU.data.PeriodoTable.checkIn ===
                          responsePEUFrac1.data.PeriodoTable.checkIn
                        ) {
                          setPeriodoUsuarioDataPrimeiroPeriodo((prevState) => ({
                            ...prevState,
                            alugar: responsePEUFrac1.data.alugar,
                            trocar: responsePEUFrac1.data.trocar,
                            utilizar: responsePEUFrac1.data.utilizar,
                            concluido: responsePEUFrac1.data.concluido,
                            divulgado: responsePEUFrac1.data.divulgado,
                            fracionamento: responsePEUFrac1.data.fracionamento,
                            valorMin: responsePEUFrac1.data.valorMin,
                            valorSugerido: responsePEUFrac1.data.valorSugerido,
                            dataSugestao: responsePEUFrac1.data.dataSugestao,
                            situacaoAnterior: responsePEU.data.situacaoAnterior,
                            statusAnterior: responsePEU.data.statusAnterior,
                            id: responsePEUFrac1.data.id,
                            status: responsePEUFrac1.data.status,
                            idPE: responsePEUFrac1.data.PeriodoTable.id,
                            checkIn: responsePEUFrac1.data.PeriodoTable.checkIn,
                            checkOut:
                              responsePEUFrac1.data.PeriodoTable.checkOut,
                            idCota:
                              responsePEUFrac1.data.PeriodoTable.CotaTable.id,
                            numeroCota:
                              responsePEUFrac1.data.PeriodoTable.CotaTable
                                .numeroCota,
                            idApto:
                              responsePEUFrac1.data.PeriodoTable.CotaTable
                                .AptoTable.id,
                            idEmpreend:
                              responsePEUFrac1.data.PeriodoTable.CotaTable
                                .AptoTable.EmpreendimentoTable.id,
                            nome: responsePEUFrac1.data.PeriodoTable.CotaTable
                              .AptoTable.EmpreendimentoTable.nome,
                          }));
                          return p;
                        } else {
                          const URLPEUFrac2 = `${Globais.DOMINIOBACK}/periodo-usuario/informacoesCompletas/${p.id}`;
                          const responsePEUFrac2 = await axios.get(
                            URLPEUFrac2,
                            {
                              headers: { Authorization: Token },
                            }
                          );
                          setPeriodoUsuarioDataSegundoPeriodo((prevState) => ({
                            ...prevState,
                            alugar: responsePEUFrac2.data.alugar,
                            trocar: responsePEUFrac2.data.trocar,
                            utilizar: responsePEUFrac2.data.utilizar,
                            concluido: responsePEUFrac2.data.concluido,
                            divulgado: responsePEUFrac2.data.divulgado,
                            fracionamento: responsePEUFrac2.data.fracionamento,
                            valorMin: responsePEUFrac2.data.valorMin,
                            valorSugerido: responsePEUFrac2.data.valorSugerido,
                            situacaoAnterior: responsePEU.data.situacaoAnterior,
                            statusAnterior: responsePEU.data.statusAnterior,
                            id: responsePEUFrac2.data.id,
                            dataSugestao: responsePEUFrac2.data.dataSugestao,
                            status: responsePEUFrac2.data.status,
                            idPE: responsePEUFrac2.data.PeriodoTable.id,
                            checkIn: responsePEUFrac2.data.PeriodoTable.checkIn,
                            checkOut:
                              responsePEUFrac2.data.PeriodoTable.checkOut,
                            idCota:
                              responsePEUFrac2.data.PeriodoTable.CotaTable.id,
                            numeroCota:
                              responsePEUFrac2.data.PeriodoTable.CotaTable
                                .numeroCota,
                            idApto:
                              responsePEUFrac2.data.PeriodoTable.CotaTable
                                .AptoTable.id,
                            idEmpreend:
                              responsePEUFrac2.data.PeriodoTable.CotaTable
                                .AptoTable.EmpreendimentoTable.id,
                            nome: responsePEUFrac2.data.PeriodoTable.CotaTable
                              .AptoTable.EmpreendimentoTable.nome,
                          }));
                          // setPeriodoUsuarioDataSegundoPeriodo(p);
                          return p;
                        }

                        // setPeriodoUsuarioDataPrimeiroPeriodo(p);
                      }
                    );
                  });
                }
              }

              setIsLoading(false);
            }
          }
        }
      } catch (error) {
        console.log(error);
        switch (error.response.status) {
          case 504:
            document.location.href = "/linkexpirado";
            break;
          case 406:
            document.location.href = "/algodeuerrado";
            break;
        }
      }
    };
    fetch();
  }, []);

  const openNotificationWithIcon = (type: NotificationType, texto: string) => {
    switch (texto) {
      case "EscolherOpcao":
        textoMensagem.current = "Favor selecionar uma opção";
        break;
      case "IndicarValor":
        textoMensagem.current =
          "Como este período não tem um valor registrado ainda, favor escolher a opção 'Gostaria de incluir um novo valor' para alterar o valor sugerido.";
        break;
      case "PeriodoPrincipalDelegado":
        textoMensagem.current =
          "No período principal você delegou à Multicotas as próximas decisões sobre alterações de preço. Dessa forma os períodos fracionados também deverão estar dessa maneira.";
        break;
      case "SelecionarReservadoUtilizadoEmParte":
        textoMensagem.current =
          "Favor selecionar no período principal a opção 'Já utilizei ou reservei apenas uma parte do período'.";
        break;
      case "FracioneNaPrimeiraFracao":
        textoMensagem.current =
          "Caso não deseje fracionar o período, volte a primeira fração e selecione a opção 'Não gostaria de fracionar...'. O sistema não permite ter apenas uma parte do período para aluguel.";
        break;
      case "SelecionarDelegadoNoPrincipal":
        textoMensagem.current =
          "Caso queira delegar à Multicotas as próximas decisões sobre os preços de um período fracionado, deverá voltar no período principal e selecionar a mesma opção. Ou seja, tanto o principal quanto os fracionados deverão estar na mesma opção.";
        break;
      case "SelecionarNaoPertubeNoPrincipal":
        textoMensagem.current =
          "Caso não queira mais receber sugestões desse período fracionado, deverá voltar no período principal e selecionar a mesma opção. Ou seja, tanto o principal quanto os fracionados deverão estar na mesma opção.";
        break;
      case "DeveFracionar":
        textoMensagem.current =
          "Se você reservou ou utilizou apenas parte do período, ele deve, necessariamente, estar fracionado. Caso a fração do período não esteja correta favor entrar em contato conosco.";
        break;
      case "UmPeriodoAoMenosReservadoOuUtilizado":
        textoMensagem.current =
          "Como você indicou no período principal, que reservou ou utilizou parte do período, você deverá indicar ao menos uma fração como utilizada ou reservada.";
        break;
      case "PreencherValor":
        textoMensagem.current =
          "Para fins de registro, favor preencher o valor reservado.";
        break;
      case "ErroNoValor":
        textoMensagem.current =
          "Ops.Parece que tem algo errado com o valor. Certifique-se de que seja somente números.";
        break;
      case "ErrosGerais":
        textoMensagem.current =
          "Ops. Encotramos um problema ao atualizar as informações. Favor entrar em contato conosco.";

        break;
      case "PrincipalNaoPertube":
        textoMensagem.current =
          "Caso o período principal esteja marcado para não receber mais sugestões, todas as frações deverão estar na mesma opção.";

        break;

      default:
        textoMensagem.current = "Algo deu errado!";
        break;
    }
    api[type]({
      message: "Atenção!",
      description: textoMensagem.current,
      duration: 8,
    });
  };

  const isStepOptional = (step: number) => {
    return step === 1;
  };

  const isStepSkipped = (step: number) => {
    return skipped.has(step);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const mensagem = (tipo: number) => {
    switch (tipo) {
    }
  };

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const success = (texto: string) => {
    messageApi.open({
      type: "success",
      content: texto,
    });
  };
  const warning = (texto: string) => {
    messageApi.open({
      type: "warning",
      content: texto,
    });
  };
  const error = (texto: string) => {
    messageApi.open({
      type: "error",
      content: texto,
    });
  };

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const contentStyle: React.CSSProperties = {
    // lineHeight: "260px",
    textAlign: "center",
    color: token.colorTextTertiary,
    backgroundColor: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
    border: `1px dashed ${token.colorBorder}`,
    marginTop: 0,
  };
  const stepsStyle: React.CSSProperties = {
    // lineHeight: "100px",
    textAlign: "center",
    alignItems: "center",
    color: token.colorTextTertiary,
    maxWidth: 800,
    backgroundColor: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
    border: `1px dashed ${token.colorBorder}`,
  };

  const onChangePeriodoUnico = (e: RadioChangeEvent) => {
    if (e.target.value === 5 || e.target.value === 6) {
      if (
        periodoUsuarioData.valorMin === "0" ||
        periodoUsuarioData.valorMin === null
      ) {
        openNotificationWithIcon("warning", "IndicarValor");
      } else {
        setValueRadioPeriodoUnico(e.target.value);
      }
    } else {
      setValueRadioPeriodoUnico(e.target.value);
    }
  };
  const onChangePeriodoPrincipal = (e: RadioChangeEvent) => {
    switch (e.target.value) {
      case 2:
      case 3:
      case 4:
      case 7:
        setValueRadioPeriodoPrincipal(e.target.value);
        break;
      case 9:
        console.log("chama o submit");
        setValueRadioPeriodoPrincipal(e.target.value);
        break;
      case 10:
        // emPreparo.current = false;
        console.log("chama o submit");
        setValueRadioPeriodoPrincipal(e.target.value);
        break;
      case 5:
        if (
          periodoUsuarioData.valorMin === "0" ||
          periodoUsuarioData.valorMin === null
        ) {
          openNotificationWithIcon("warning", "IndicarValor");
        } else {
          setValueRadioPeriodoPrincipal(e.target.value);
        }
        break;
      case 6:
        if (
          periodoUsuarioData.valorMin === "0" ||
          periodoUsuarioData.valorMin === null
        ) {
          openNotificationWithIcon("warning", "IndicarValor");
        } else {
          setValueRadioPeriodoPrincipal(e.target.value);
        }

        break;
      case 8:
        console.log("chama o submit");

        setValueRadioPeriodoPrincipal(e.target.value);
        break;
    }
  };
  const onChange1Fracao = (e: RadioChangeEvent) => {
    switch (valueRadioPeriodoPrincipal) {
      case 2:
        //confirmar e delegar principal
        switch (e.target.value) {
          case 2:
            //confirmar e delegar 1 fracao
            // emPreparo.current = false;
            setValueRadio1Fracao(e.target.value);
            break;
          case 3:
          case 4:
          case 6:
          case 7:
            openNotificationWithIcon("warning", "PeriodoPrincipalDelegado");
            break;
          case 5:
            //não fracione
            console.log("chama submit");
            setValueRadio1Fracao(e.target.value);
            break;
          case 8:
            //reservado
            openNotificationWithIcon(
              "warning",
              "SelecionarReservadoUtilizadoEmParte"
            );
            break;
          case 9:
            //utilizar
            openNotificationWithIcon(
              "warning",
              "SelecionarReservadoUtilizadoEmParte"
            );
            break;
        }

        break;
      case 3:
        switch (e.target.value) {
          case 2:
            openNotificationWithIcon(
              "warning",
              "SelecionarDelegadoNoPrincipal"
            );
            break;
          case 3:
            setValueRadio1Fracao(e.target.value);
            break;
          case 4:
            setValueRadio1Fracao(e.target.value);
            break;
          case 6:
            if (
              periodoUsuarioDataPrimeiroPeriodo.valorMin === "0" ||
              periodoUsuarioDataPrimeiroPeriodo.valorMin === null
            ) {
              openNotificationWithIcon("warning", "IndicarValor");
            } else {
              setValueRadio1Fracao(e.target.value);
            }
            break;
          case 7:
            openNotificationWithIcon(
              "warning",
              "SelecionarNaoPertubeNoPrincipal"
            );
            break;
          case 5:
            //não fracione
            console.log("chama submit");
            setValueRadio1Fracao(e.target.value);
            break;
          case 8:
            //reservado
            openNotificationWithIcon(
              "warning",
              "SelecionarReservadoUtilizadoEmParte"
            );
            break;
          case 9:
            //utilizar
            openNotificationWithIcon(
              "warning",
              "SelecionarReservadoUtilizadoEmParte"
            );
            break;
        }
        break;
      case 4:
        switch (e.target.value) {
          case 2:
            openNotificationWithIcon(
              "warning",
              "SelecionarDelegadoNoPrincipal"
            );
            break;
          case 3:
            setValueRadio1Fracao(e.target.value);
            break;
          case 4:
            setValueRadio1Fracao(e.target.value);
            break;
          case 6:
            if (
              periodoUsuarioDataPrimeiroPeriodo.valorMin === "0" ||
              periodoUsuarioDataPrimeiroPeriodo.valorMin === null
            ) {
              openNotificationWithIcon("warning", "IndicarValor");
            } else {
              setValueRadio1Fracao(e.target.value);
            }
            break;
          case 7:
            openNotificationWithIcon(
              "warning",
              "SelecionarNaoPertubeNoPrincipal"
            );
            break;
          case 5:
            //não fracione
            console.log("chama submit");
            setValueRadio1Fracao(e.target.value);
            break;
          case 8:
            //reservado
            openNotificationWithIcon(
              "warning",
              "SelecionarReservadoUtilizadoEmParte"
            );
            break;
          case 9:
            //utilizar
            openNotificationWithIcon(
              "warning",
              "SelecionarReservadoUtilizadoEmParte"
            );
            break;
        }
        break;
      case 5:
        switch (e.target.value) {
          case 2:
            openNotificationWithIcon(
              "warning",
              "SelecionarDelegadoNoPrincipal"
            );
            break;
          case 3:
            setValueRadio1Fracao(e.target.value);
            break;
          case 4:
            setValueRadio1Fracao(e.target.value);
            break;
          case 6:
            if (
              periodoUsuarioDataPrimeiroPeriodo.valorMin === "0" ||
              periodoUsuarioDataPrimeiroPeriodo.valorMin === null
            ) {
              openNotificationWithIcon("warning", "IndicarValor");
            } else {
              setValueRadio1Fracao(e.target.value);
            }
            break;
          case 7:
            openNotificationWithIcon(
              "warning",
              "SelecionarNaoPertubeNoPrincipal"
            );
            break;
          case 5:
            //não fracione
            console.log("chama submit");
            setValueRadio1Fracao(e.target.value);
            break;
          case 8:
            //reservado
            openNotificationWithIcon(
              "warning",
              "SelecionarReservadoUtilizadoEmParte"
            );
            break;
          case 9:
            //utilizar
            openNotificationWithIcon(
              "warning",
              "SelecionarReservadoUtilizadoEmParte"
            );
            break;
        }
        break;
      case 6:
        switch (e.target.value) {
          case 2:
            openNotificationWithIcon(
              "warning",
              "SelecionarDelegadoNoPrincipal"
            );
            break;
          case 3:
            openNotificationWithIcon("warning", "PrincipalNaoPertube");
            break;
          case 4:
            openNotificationWithIcon("warning", "PrincipalNaoPertube");
            break;
          case 6:
            openNotificationWithIcon("warning", "PrincipalNaoPertube");
            break;
          case 7:
            if (
              periodoUsuarioDataPrimeiroPeriodo.valorMin === "0" ||
              periodoUsuarioDataPrimeiroPeriodo.valorMin === null
            ) {
              openNotificationWithIcon("warning", "IndicarValor");
            } else {
              setValueRadio1Fracao(e.target.value);
            }
            break;
          case 5:
            //não fracione
            console.log("chama submit");
            setValueRadio1Fracao(e.target.value);
            break;
          case 8:
            //reservado
            openNotificationWithIcon(
              "warning",
              "SelecionarReservadoUtilizadoEmParte"
            );
            break;
          case 9:
            //utilizar
            openNotificationWithIcon(
              "warning",
              "SelecionarReservadoUtilizadoEmParte"
            );
            break;
        }
        break;
      case 7:
        switch (e.target.value) {
          case 2:
            setValueRadio1Fracao(e.target.value);
            break;
          case 3:
            setValueRadio1Fracao(e.target.value);
            break;
          case 4:
            setValueRadio1Fracao(e.target.value);
            break;
          case 6:
            if (
              periodoUsuarioDataPrimeiroPeriodo.valorMin === "0" ||
              periodoUsuarioDataPrimeiroPeriodo.valorMin === null
            ) {
              openNotificationWithIcon("warning", "IndicarValor");
            } else {
              setValueRadio1Fracao(e.target.value);
            }
            break;
          case 7:
            if (
              periodoUsuarioDataPrimeiroPeriodo.valorMin === "0" ||
              periodoUsuarioDataPrimeiroPeriodo.valorMin === null
            ) {
              openNotificationWithIcon("warning", "IndicarValor");
            } else {
              setValueRadio1Fracao(e.target.value);
            }
            break;
          case 5:
            openNotificationWithIcon("warning", "DeveFracionar");
            break;
          case 8:
            //reservado
            setValueRadio1Fracao(e.target.value);
            break;
          case 9:
            //utilizar
            setValueRadio1Fracao(e.target.value);
            break;
        }
        break;
    }
  };
  const onChange2Fracao = (e: RadioChangeEvent) => {
    switch (valueRadioPeriodoPrincipal) {
      case 2:
        //confirmo e delego principal
        switch (valueRadio1Fracao) {
          case 2:
            // confirmo e delego 1 fracao
            switch (e.target.value) {
              case 2:
                //confirmo e delego principal - // confirmo e delego 1 fracao - // confirmo e delego 2 fracao
                // emPreparo.current = false;
                setValueRadio2Fracao(e.target.value);
                break;
              case 3:
              case 4:
              case 6:
              case 7:
                openNotificationWithIcon("warning", "PeriodoPrincipalDelegado");
                break;
              case 5:
                openNotificationWithIcon("warning", "FracioneNaPrimeiraFracao");
                break;
              case 8:
                //reservado
                openNotificationWithIcon(
                  "warning",
                  "SelecionarReservadoUtilizadoEmParte"
                );
                break;
              case 9:
                //utilizar
                openNotificationWithIcon(
                  "warning",
                  "SelecionarReservadoUtilizadoEmParte"
                );
                break;
            }
        }
        break;
      case 3:
        //confirmo principal
        switch (valueRadio1Fracao) {
          case 2:
            //confirmo e delego 1 fracao
            switch (e.target.value) {
              case 2:
                //confirmo e delego 2 fracao
                // emPreparo.current = false;
                openNotificationWithIcon("warning", "PeriodoPrincipalDelegado");
                break;
              case 3:
                //confirmo 2 fracao
                setValueRadio2Fracao(e.target.value);
                break;
              case 4:
                //novo valor 2 fracao
                setValueRadio2Fracao(e.target.value);
                break;
              case 6:
                //rejeito 2 fracao
                if (
                  periodoUsuarioDataSegundoPeriodo.valorMin === "0" ||
                  periodoUsuarioDataSegundoPeriodo.valorMin === null
                ) {
                  openNotificationWithIcon("warning", "IndicarValor");
                } else {
                  setValueRadio2Fracao(e.target.value);
                }
                break;
              case 7:
                //rejeito e nao pertube 2 fracao
                openNotificationWithIcon(
                  "warning",
                  "SelecionarNaoPertubeNoPrincipal"
                );
                break;
              case 5:
                //nao fracione 2 fracao
                openNotificationWithIcon("warning", "FracioneNaPrimeiraFracao");
                break;
              case 8:
                //reservado 2 fracao
                openNotificationWithIcon(
                  "warning",
                  "SelecionarReservadoUtilizadoEmParte"
                );
                break;
              case 9:
                //utilizar 2 fracao
                openNotificationWithIcon(
                  "warning",
                  "SelecionarReservadoUtilizadoEmParte"
                );
                break;
            }
            break;
          case 3:
            //confimo 1 fracao
            switch (e.target.value) {
              case 2:
                //confirmo e delego 2 fracao
                // emPreparo.current = false;
                openNotificationWithIcon(
                  "warning",
                  "SelecionarDelegadoNoPrincipal"
                );
                break;
              case 3:
                //confirmo 2 fracai
                setValueRadio2Fracao(e.target.value);
                break;
              case 4:
                //novo 2 fracao
                setValueRadio2Fracao(e.target.value);
                break;
              case 6:
                if (
                  periodoUsuarioDataSegundoPeriodo.valorMin === "0" ||
                  periodoUsuarioDataSegundoPeriodo.valorMin === null
                ) {
                  openNotificationWithIcon("warning", "IndicarValor");
                } else {
                  setValueRadio2Fracao(e.target.value);
                }
                break;
              case 7:
                openNotificationWithIcon(
                  "warning",
                  "SelecionarNaoPertubeNoPrincipal"
                );
                break;
              case 5:
                openNotificationWithIcon("warning", "FracioneNaPrimeiraFracao");
                break;
              case 8:
                //reservado
                openNotificationWithIcon(
                  "warning",
                  "SelecionarReservadoUtilizadoEmParte"
                );
                break;
              case 9:
                //utilizar
                openNotificationWithIcon(
                  "warning",
                  "SelecionarReservadoUtilizadoEmParte"
                );
                break;
            }
            break;

          case 4:
            switch (e.target.value) {
              case 2:
                //confirmo e delego 2 fracao
                // emPreparo.current = false;
                openNotificationWithIcon(
                  "warning",
                  "SelecionarDelegadoNoPrincipal"
                );
                break;
              case 3:
                //confirmo 2 fracai
                setValueRadio2Fracao(e.target.value);
                break;
              case 4:
                //novo 2 fracao
                setValueRadio2Fracao(e.target.value);
                break;
              case 6:
                if (
                  periodoUsuarioData.valorMin === "0" ||
                  periodoUsuarioData.valorMin === null
                ) {
                  openNotificationWithIcon("warning", "IndicarValor");
                } else {
                  setValueRadio2Fracao(e.target.value);
                }
                break;
              case 7:
                openNotificationWithIcon(
                  "warning",
                  "SelecionarNaoPertubeNoPrincipal"
                );
                break;
              case 5:
                openNotificationWithIcon("warning", "FracioneNaPrimeiraFracao");
                break;
              case 8:
                //reservado
                openNotificationWithIcon(
                  "warning",
                  "SelecionarReservadoUtilizadoEmParte"
                );
                break;
              case 9:
                //utilizar
                openNotificationWithIcon(
                  "warning",
                  "SelecionarReservadoUtilizadoEmParte"
                );
                break;
            }
            break;
          case 5:
            break;
          case 6:
            switch (e.target.value) {
              case 2:
                //confirmo e delego 2 fracao
                // emPreparo.current = false;
                openNotificationWithIcon(
                  "warning",
                  "SelecionarDelegadoNoPrincipal"
                );
                break;
              case 3:
                //confirmo 2 fracai
                setValueRadio2Fracao(e.target.value);
                break;
              case 4:
                //novo 2 fracao
                setValueRadio2Fracao(e.target.value);
                break;
              case 6:
                if (
                  periodoUsuarioData.valorMin === "0" ||
                  periodoUsuarioData.valorMin === null
                ) {
                  openNotificationWithIcon("warning", "IndicarValor");
                } else {
                  setValueRadio2Fracao(e.target.value);
                }
                break;
              case 7:
                openNotificationWithIcon(
                  "warning",
                  "SelecionarNaoPertubeNoPrincipal"
                );
                break;
              case 5:
                openNotificationWithIcon("warning", "FracioneNaPrimeiraFracao");
                break;
              case 8:
                //reservado
                openNotificationWithIcon(
                  "warning",
                  "SelecionarReservadoUtilizadoEmParte"
                );
                break;
              case 9:
                //utilizar
                openNotificationWithIcon(
                  "warning",
                  "SelecionarReservadoUtilizadoEmParte"
                );
                break;
            }
            break;
        }
        break;
      case 4:
        //novo valor principal
        switch (valueRadio1Fracao) {
          case 3:
            //confimo 1 fracao
            switch (e.target.value) {
              case 2:
                //confirmo e delego 2 fracao
                // emPreparo.current = false;
                openNotificationWithIcon(
                  "warning",
                  "SelecionarDelegadoNoPrincipal"
                );
                break;
              case 3:
                //confirmo 2 fracai
                setValueRadio2Fracao(e.target.value);
                break;
              case 4:
                //novo 2 fracao
                setValueRadio2Fracao(e.target.value);
                break;
              case 6:
                if (
                  periodoUsuarioDataSegundoPeriodo.valorMin === "0" ||
                  periodoUsuarioDataSegundoPeriodo.valorMin === null
                ) {
                  openNotificationWithIcon("warning", "IndicarValor");
                } else {
                  setValueRadio2Fracao(e.target.value);
                }
                break;

              case 5:
                openNotificationWithIcon("warning", "FracioneNaPrimeiraFracao");
                break;
              case 7:
                openNotificationWithIcon(
                  "warning",
                  "SelecionarNaoPertubeNoPrincipal"
                );
                break;
              case 8:
                //reservado
                openNotificationWithIcon(
                  "warning",
                  "SelecionarReservadoUtilizadoEmParte"
                );
                break;
              case 9:
                //utilizar
                openNotificationWithIcon(
                  "warning",
                  "SelecionarReservadoUtilizadoEmParte"
                );
                break;
            }
            break;

          case 4:
            switch (e.target.value) {
              case 2:
                //confirmo e delego 2 fracao
                // emPreparo.current = false;
                openNotificationWithIcon(
                  "warning",
                  "SelecionarDelegadoNoPrincipal"
                );
                break;
              case 3:
                //confirmo 2 fracai
                setValueRadio2Fracao(e.target.value);
                break;
              case 4:
                //novo 2 fracao
                setValueRadio2Fracao(e.target.value);
                break;
              case 6:
                if (
                  periodoUsuarioDataSegundoPeriodo.valorMin === "0" ||
                  periodoUsuarioDataSegundoPeriodo.valorMin === null
                ) {
                  openNotificationWithIcon("warning", "IndicarValor");
                } else {
                  setValueRadio2Fracao(e.target.value);
                }
                break;
              case 7:
                openNotificationWithIcon(
                  "warning",
                  "SelecionarNaoPertubeNoPrincipal"
                );
                break;
              case 5:
                openNotificationWithIcon("warning", "FracioneNaPrimeiraFracao");
                break;
              case 8:
                //reservado
                openNotificationWithIcon(
                  "warning",
                  "SelecionarReservadoUtilizadoEmParte"
                );
                break;
              case 9:
                //utilizar
                openNotificationWithIcon(
                  "warning",
                  "SelecionarReservadoUtilizadoEmParte"
                );
                break;
            }
            break;
          case 5:
            break;
          case 6:
            switch (e.target.value) {
              case 2:
                //confirmo e delego 2 fracao
                // emPreparo.current = false;
                openNotificationWithIcon(
                  "warning",
                  "SelecionarDelegadoNoPrincipal"
                );
                break;
              case 3:
                //confirmo 2 fracai
                setValueRadio2Fracao(e.target.value);
                break;
              case 4:
                //novo 2 fracao
                setValueRadio2Fracao(e.target.value);
                break;
              case 6:
                if (
                  periodoUsuarioDataSegundoPeriodo.valorMin === "0" ||
                  periodoUsuarioDataSegundoPeriodo.valorMin === null
                ) {
                  openNotificationWithIcon("warning", "IndicarValor");
                } else {
                  setValueRadio2Fracao(e.target.value);
                }
                break;
              case 7:
                openNotificationWithIcon(
                  "warning",
                  "SelecionarNaoPertubeNoPrincipal"
                );
                break;
              case 5:
                openNotificationWithIcon("warning", "FracioneNaPrimeiraFracao");
                break;
              case 8:
                //reservado
                openNotificationWithIcon(
                  "warning",
                  "SelecionarReservadoUtilizadoEmParte"
                );
                break;
              case 9:
                //utilizar
                openNotificationWithIcon(
                  "warning",
                  "SelecionarReservadoUtilizadoEmParte"
                );
                break;
            }
            break;
        }
        break;
      case 5:
        switch (valueRadio1Fracao) {
          case 3:
            //confimo 1 fracao
            switch (e.target.value) {
              case 2:
                //confirmo e delego 2 fracao
                // emPreparo.current = false;
                openNotificationWithIcon(
                  "warning",
                  "SelecionarDelegadoNoPrincipal"
                );
                break;
              case 3:
                //confirmo 2 fracai
                setValueRadio2Fracao(e.target.value);
                break;
              case 4:
                //novo 2 fracao
                setValueRadio2Fracao(e.target.value);
                break;
              case 6:
                if (
                  periodoUsuarioDataSegundoPeriodo.valorMin === "0" ||
                  periodoUsuarioDataSegundoPeriodo.valorMin === null
                ) {
                  openNotificationWithIcon("warning", "IndicarValor");
                } else {
                  setValueRadio2Fracao(e.target.value);
                }
                break;

              case 5:
                openNotificationWithIcon("warning", "FracioneNaPrimeiraFracao");
                break;
              case 7:
                openNotificationWithIcon(
                  "warning",
                  "SelecionarNaoPertubeNoPrincipal"
                );
                break;
              case 8:
                //reservado
                openNotificationWithIcon(
                  "warning",
                  "SelecionarReservadoUtilizadoEmParte"
                );
                break;
              case 9:
                //utilizar
                openNotificationWithIcon(
                  "warning",
                  "SelecionarReservadoUtilizadoEmParte"
                );
                break;
            }
            break;

          case 4:
            switch (e.target.value) {
              case 2:
                //confirmo e delego 2 fracao
                // emPreparo.current = false;
                openNotificationWithIcon(
                  "warning",
                  "SelecionarDelegadoNoPrincipal"
                );
                break;
              case 3:
                //confirmo 2 fracai
                setValueRadio2Fracao(e.target.value);
                break;
              case 4:
                //novo 2 fracao
                setValueRadio2Fracao(e.target.value);
                break;
              case 6:
                if (
                  periodoUsuarioDataSegundoPeriodo.valorMin === "0" ||
                  periodoUsuarioDataSegundoPeriodo.valorMin === null
                ) {
                  openNotificationWithIcon("warning", "IndicarValor");
                } else {
                  setValueRadio2Fracao(e.target.value);
                }
                break;
              case 7:
                openNotificationWithIcon(
                  "warning",
                  "SelecionarNaoPertubeNoPrincipal"
                );
                break;
              case 5:
                openNotificationWithIcon("warning", "FracioneNaPrimeiraFracao");
                break;
              case 8:
                //reservado
                openNotificationWithIcon(
                  "warning",
                  "SelecionarReservadoUtilizadoEmParte"
                );
                break;
              case 9:
                //utilizar
                openNotificationWithIcon(
                  "warning",
                  "SelecionarReservadoUtilizadoEmParte"
                );
                break;
            }
            break;

          case 6:
            switch (e.target.value) {
              case 2:
                //confirmo e delego 2 fracao
                // emPreparo.current = false;
                openNotificationWithIcon(
                  "warning",
                  "SelecionarDelegadoNoPrincipal"
                );
                break;
              case 3:
                //confirmo 2 fracai
                setValueRadio2Fracao(e.target.value);
                break;
              case 4:
                //novo 2 fracao
                setValueRadio2Fracao(e.target.value);
                break;
              case 6:
                if (
                  periodoUsuarioDataSegundoPeriodo.valorMin === "0" ||
                  periodoUsuarioDataSegundoPeriodo.valorMin === null
                ) {
                  openNotificationWithIcon("warning", "IndicarValor");
                } else {
                  setValueRadio2Fracao(e.target.value);
                }
                break;
              case 7:
                openNotificationWithIcon(
                  "warning",
                  "SelecionarNaoPertubeNoPrincipal"
                );
                break;
              case 5:
                openNotificationWithIcon("warning", "FracioneNaPrimeiraFracao");
                break;
              case 8:
                //reservado
                openNotificationWithIcon(
                  "warning",
                  "SelecionarReservadoUtilizadoEmParte"
                );
                break;
              case 9:
                //utilizar
                openNotificationWithIcon(
                  "warning",
                  "SelecionarReservadoUtilizadoEmParte"
                );
                break;
            }
            break;
        }
        break;
      case 6:
        switch (valueRadio1Fracao) {
          case 3:
            //confimo 1 fracao
            switch (e.target.value) {
              case 2:
                //confirmo e delego 2 fracao
                // emPreparo.current = false;
                openNotificationWithIcon(
                  "warning",
                  "SelecionarDelegadoNoPrincipal"
                );
                break;
              case 3:
                //confirmo 2 fracai
                setValueRadio2Fracao(e.target.value);
                break;
              case 4:
                //novo 2 fracao
                setValueRadio2Fracao(e.target.value);
                break;
              case 6:
                if (
                  periodoUsuarioDataSegundoPeriodo.valorMin === "0" ||
                  periodoUsuarioDataSegundoPeriodo.valorMin === null
                ) {
                  openNotificationWithIcon("warning", "IndicarValor");
                } else {
                  setValueRadio2Fracao(e.target.value);
                }
                break;

              case 5:
                openNotificationWithIcon("warning", "FracioneNaPrimeiraFracao");
                break;
              case 7:
                setValueRadio2Fracao(e.target.value);
                break;
              case 8:
                //reservado
                openNotificationWithIcon(
                  "warning",
                  "SelecionarReservadoUtilizadoEmParte"
                );
                break;
              case 9:
                //utilizar
                openNotificationWithIcon(
                  "warning",
                  "SelecionarReservadoUtilizadoEmParte"
                );
                break;
            }
            break;

          case 4:
            switch (e.target.value) {
              case 2:
                //confirmo e delego 2 fracao
                // emPreparo.current = false;
                openNotificationWithIcon(
                  "warning",
                  "SelecionarDelegadoNoPrincipal"
                );
                break;
              case 3:
                //confirmo 2 fracai
                setValueRadio2Fracao(e.target.value);
                break;
              case 4:
                //novo 2 fracao
                setValueRadio2Fracao(e.target.value);
                break;
              case 6:
                if (
                  periodoUsuarioDataSegundoPeriodo.valorMin === "0" ||
                  periodoUsuarioDataSegundoPeriodo.valorMin === null
                ) {
                  openNotificationWithIcon("warning", "IndicarValor");
                } else {
                  setValueRadio2Fracao(e.target.value);
                }
                break;
              case 7:
                setValueRadio2Fracao(e.target.value);
                break;
              case 5:
                openNotificationWithIcon("warning", "FracioneNaPrimeiraFracao");
                break;
              case 8:
                //reservado
                openNotificationWithIcon(
                  "warning",
                  "SelecionarReservadoUtilizadoEmParte"
                );
                break;
              case 9:
                //utilizar
                openNotificationWithIcon(
                  "warning",
                  "SelecionarReservadoUtilizadoEmParte"
                );
                break;
            }
            break;

          case 6:
            switch (e.target.value) {
              case 2:
                //confirmo e delego 2 fracao
                // emPreparo.current = false;
                openNotificationWithIcon(
                  "warning",
                  "SelecionarDelegadoNoPrincipal"
                );
                break;
              case 3:
                //confirmo 2 fracai
                setValueRadio2Fracao(e.target.value);
                break;
              case 4:
                //novo 2 fracao
                setValueRadio2Fracao(e.target.value);
                break;
              case 6:
                if (
                  periodoUsuarioDataSegundoPeriodo.valorMin === "0" ||
                  periodoUsuarioDataSegundoPeriodo.valorMin === null
                ) {
                  openNotificationWithIcon("warning", "IndicarValor");
                } else {
                  setValueRadio2Fracao(e.target.value);
                }
                break;
              case 7:
                setValueRadio2Fracao(e.target.value);
                break;
              case 5:
                openNotificationWithIcon("warning", "FracioneNaPrimeiraFracao");
                break;
              case 8:
                //reservado
                openNotificationWithIcon(
                  "warning",
                  "SelecionarReservadoUtilizadoEmParte"
                );
                break;
              case 9:
                //utilizar
                openNotificationWithIcon(
                  "warning",
                  "SelecionarReservadoUtilizadoEmParte"
                );
                break;
            }
            break;
          case 7:
            switch (e.target.value) {
              case 2:
                //confirmo e delego 2 fracao
                // emPreparo.current = false;
                openNotificationWithIcon(
                  "warning",
                  "SelecionarDelegadoNoPrincipal"
                );
                break;
              case 3:
                //confirmo 2 fracai
                openNotificationWithIcon("warning", "PrincipalNaoPertube");
                break;
              case 4:
                //novo 2 fracao
                openNotificationWithIcon("warning", "PrincipalNaoPertube");
                break;
              case 6:
                openNotificationWithIcon("warning", "PrincipalNaoPertube");
                break;
              case 7:
                if (
                  periodoUsuarioDataSegundoPeriodo.valorMin === "0" ||
                  periodoUsuarioDataSegundoPeriodo.valorMin === null
                ) {
                  openNotificationWithIcon("warning", "IndicarValor");
                } else {
                  setValueRadio2Fracao(e.target.value);
                }
                break;
              case 5:
                openNotificationWithIcon("warning", "FracioneNaPrimeiraFracao");
                break;
              case 8:
                //reservado
                openNotificationWithIcon(
                  "warning",
                  "SelecionarReservadoUtilizadoEmParte"
                );
                break;
              case 9:
                //utilizar
                openNotificationWithIcon(
                  "warning",
                  "SelecionarReservadoUtilizadoEmParte"
                );
                break;
            }

            break;
        }
        break;
      case 7:
        switch (valueRadio1Fracao) {
          case 2:
            switch (e.target.value) {
              case 2:
                //confirmo e delego 2 fracao
                // emPreparo.current = false;
                openNotificationWithIcon(
                  "warning",
                  "UmPeriodoAoMenosReservadoOuUtilizado"
                );
                break;
              case 3:
                //confirmo 2 fracai
                openNotificationWithIcon(
                  "warning",
                  "UmPeriodoAoMenosReservadoOuUtilizado"
                );
                break;
              case 4:
                //novo 2 fracao
                openNotificationWithIcon(
                  "warning",
                  "UmPeriodoAoMenosReservadoOuUtilizado"
                );
                break;
              case 6:
                openNotificationWithIcon(
                  "warning",
                  "UmPeriodoAoMenosReservadoOuUtilizado"
                );
                break;

              case 5:
                openNotificationWithIcon(
                  "warning",
                  "UmPeriodoAoMenosReservadoOuUtilizado"
                );
                break;
              case 7:
                openNotificationWithIcon(
                  "warning",
                  "UmPeriodoAoMenosReservadoOuUtilizado"
                );
                break;
              case 8:
                //reservado
                setValueRadio2Fracao(e.target.value);
                break;
              case 9:
                //utilizar
                setValueRadio2Fracao(e.target.value);
                break;
            }
            break;
          case 3:
            //confimo 1 fracao
            switch (e.target.value) {
              case 2:
                //confirmo e delego 2 fracao
                // emPreparo.current = false;
                openNotificationWithIcon(
                  "warning",
                  "UmPeriodoAoMenosReservadoOuUtilizado"
                );
                break;
              case 3:
                //confirmo 2 fracai
                openNotificationWithIcon(
                  "warning",
                  "UmPeriodoAoMenosReservadoOuUtilizado"
                );
                break;
              case 4:
                //novo 2 fracao
                openNotificationWithIcon(
                  "warning",
                  "UmPeriodoAoMenosReservadoOuUtilizado"
                );
                break;
              case 6:
                openNotificationWithIcon(
                  "warning",
                  "UmPeriodoAoMenosReservadoOuUtilizado"
                );
                break;

              case 5:
                openNotificationWithIcon(
                  "warning",
                  "UmPeriodoAoMenosReservadoOuUtilizado"
                );
                break;
              case 7:
                openNotificationWithIcon(
                  "warning",
                  "UmPeriodoAoMenosReservadoOuUtilizado"
                );
                break;
              case 8:
                //reservado
                setValueRadio2Fracao(e.target.value);
                break;
              case 9:
                //utilizar
                setValueRadio2Fracao(e.target.value);
                break;
            }
            break;

          case 4:
            switch (e.target.value) {
              case 2:
                //confirmo e delego 2 fracao
                // emPreparo.current = false;
                openNotificationWithIcon(
                  "warning",
                  "UmPeriodoAoMenosReservadoOuUtilizado"
                );
                break;
              case 3:
                //confirmo 2 fracai
                openNotificationWithIcon(
                  "warning",
                  "UmPeriodoAoMenosReservadoOuUtilizado"
                );
                break;
              case 4:
                //novo 2 fracao
                openNotificationWithIcon(
                  "warning",
                  "UmPeriodoAoMenosReservadoOuUtilizado"
                );
                break;
              case 6:
                openNotificationWithIcon(
                  "warning",
                  "UmPeriodoAoMenosReservadoOuUtilizado"
                );
                break;

              case 5:
                openNotificationWithIcon(
                  "warning",
                  "UmPeriodoAoMenosReservadoOuUtilizado"
                );
                break;
              case 7:
                openNotificationWithIcon(
                  "warning",
                  "UmPeriodoAoMenosReservadoOuUtilizado"
                );
                break;
              case 8:
                //reservado
                setValueRadio2Fracao(e.target.value);
                break;
              case 9:
                //utilizar
                setValueRadio2Fracao(e.target.value);
                break;
            }
            break;

          case 6:
            switch (e.target.value) {
              case 2:
                //confirmo e delego 2 fracao
                // emPreparo.current = false;
                openNotificationWithIcon(
                  "warning",
                  "UmPeriodoAoMenosReservadoOuUtilizado"
                );
                break;
              case 3:
                //confirmo 2 fracai
                openNotificationWithIcon(
                  "warning",
                  "UmPeriodoAoMenosReservadoOuUtilizado"
                );
                break;
              case 4:
                //novo 2 fracao
                openNotificationWithIcon(
                  "warning",
                  "UmPeriodoAoMenosReservadoOuUtilizado"
                );
                break;
              case 6:
                openNotificationWithIcon(
                  "warning",
                  "UmPeriodoAoMenosReservadoOuUtilizado"
                );
                break;

              case 5:
                openNotificationWithIcon(
                  "warning",
                  "UmPeriodoAoMenosReservadoOuUtilizado"
                );
                break;
              case 7:
                openNotificationWithIcon(
                  "warning",
                  "UmPeriodoAoMenosReservadoOuUtilizado"
                );
                break;
              case 8:
                //reservado
                setValueRadio2Fracao(e.target.value);
                break;
              case 9:
                //utilizar
                setValueRadio2Fracao(e.target.value);
                break;
            }
            break;
          case 7:
            switch (e.target.value) {
              case 2:
                //confirmo e delego 2 fracao
                // emPreparo.current = false;
                openNotificationWithIcon(
                  "warning",
                  "UmPeriodoAoMenosReservadoOuUtilizado"
                );
                break;
              case 3:
                //confirmo 2 fracai
                openNotificationWithIcon(
                  "warning",
                  "UmPeriodoAoMenosReservadoOuUtilizado"
                );
                break;
              case 4:
                //novo 2 fracao
                openNotificationWithIcon(
                  "warning",
                  "UmPeriodoAoMenosReservadoOuUtilizado"
                );
                break;
              case 6:
                openNotificationWithIcon(
                  "warning",
                  "UmPeriodoAoMenosReservadoOuUtilizado"
                );
                break;

              case 5:
                openNotificationWithIcon(
                  "warning",
                  "UmPeriodoAoMenosReservadoOuUtilizado"
                );
                break;
              case 7:
                openNotificationWithIcon(
                  "warning",
                  "UmPeriodoAoMenosReservadoOuUtilizado"
                );
                break;
              case 8:
                //reservado
                setValueRadio2Fracao(e.target.value);
                break;
              case 9:
                //utilizar
                setValueRadio2Fracao(e.target.value);
                break;
            }
            break;
          case 8:
            switch (e.target.value) {
              case 2:
                //confirmo e delego 2 fracao
                // emPreparo.current = false;
                setValueRadio2Fracao(e.target.value);
                break;
              case 3:
                //confirmo 2 fracai
                setValueRadio2Fracao(e.target.value);
                break;
              case 4:
                //novo 2 fracao
                setValueRadio2Fracao(e.target.value);
                break;
              case 6:
                if (
                  periodoUsuarioDataSegundoPeriodo.valorMin === "0" ||
                  periodoUsuarioDataSegundoPeriodo.valorMin === null
                ) {
                  openNotificationWithIcon("warning", "IndicarValor");
                } else {
                  setValueRadio2Fracao(e.target.value);
                }
                break;

              case 5:
                openNotificationWithIcon("warning", "DeveFracionar");

                break;
              case 7:
                if (
                  periodoUsuarioDataSegundoPeriodo.valorMin === "0" ||
                  periodoUsuarioDataSegundoPeriodo.valorMin === null
                ) {
                  openNotificationWithIcon("warning", "IndicarValor");
                } else {
                  setValueRadio2Fracao(e.target.value);
                }
                break;

              case 8:
                //reservado
                setValueRadio2Fracao(e.target.value);
                break;

              case 9:
                //utilizar
                setValueRadio2Fracao(e.target.value);
                break;
            }
            break;
          case 9:
            switch (e.target.value) {
              case 2:
                //confirmo e delego 2 fracao
                // emPreparo.current = false;
                setValueRadio2Fracao(e.target.value);
                break;
              case 3:
                //confirmo 2 fracai
                setValueRadio2Fracao(e.target.value);
                break;
              case 4:
                //novo 2 fracao
                setValueRadio2Fracao(e.target.value);
                break;
              case 6:
                if (
                  periodoUsuarioDataSegundoPeriodo.valorMin === "0" ||
                  periodoUsuarioDataSegundoPeriodo.valorMin === null
                ) {
                  openNotificationWithIcon("warning", "IndicarValor");
                } else {
                  setValueRadio2Fracao(e.target.value);
                }
                break;

              case 5:
                openNotificationWithIcon("warning", "DeveFracionar");

                break;
              case 7:
                setValueRadio2Fracao(e.target.value);
                break;
              case 8:
                //reservado
                setValueRadio2Fracao(e.target.value);
                break;

              case 9:
                //utilizar
                setValueRadio2Fracao(e.target.value);
                break;
            }
            break;
        }
        break;
    }
  };
  const onChangeInputNovoValorPeriodoUnico = (e: any) => {
    setInputNovoValorPeriodoUnico(e.target.value);
  };
  const onChangeInputReservaPeriodoUnico = (e: any) => {
    setInputReservaPeriodoUnico(e.target.value);
  };
  const onChangeInputNovoValorPeriodoPrincipal = (e: any) => {
    console.log(e.target.value);
    setInputNovoValorPeriodoPrincipal(e.target.value);
  };
  const onChangeInputReservaPeriodoPrincipal = (e: any) => {
    console.log(e.target.value);
    setInputReservaPeriodoPrincipal(e.target.value);
  };
  const onChangeInputNovoValor1Fracao = (e: any) => {
    console.log(e.target.value);
    setInputNovoValor1Fracao(e.target.value);
  };
  const onChangeInputReserva1Fracao = (e: any) => {
    console.log(e.target.value);
    setInputReserva1Fracao(e.target.value);
  };
  const onChangeInputNovoValor2Fracao = (e: any) => {
    console.log(e.target.value);
    setInputNovoValor2Fracao(e.target.value);
  };
  const onChangeInputReserva2Fracao = (e: any) => {
    console.log(e.target.value);
    setInputReserva2Fracao(e.target.value);
  };

  const onSubmit = async () => {
    if (
      (nTipoEmail.tipoEmail === 3 || nTipoEmail.tipoEmail === 4) &&
      valueRadioPeriodoPrincipal === 1
    ) {
      openNotificationWithIcon("warning", "EscolherOpcao");
    } else {
      if (nTipoEmail.tipoEmail) {
        atualizarPeriodoUsuarioPeloTipo(
          nTipoEmail.tipoEmail,
          false,
          valueRadioPeriodoPrincipal,
          valueRadio1Fracao,
          valueRadio2Fracao
        );
      }
    }
  };
  const handleNext = () => {
    let newSkipped = skipped;
    if (nTipoEmail.tipoEmail === 7 || nTipoEmail.tipoEmail === 8) {
      if (
        (valueRadio1Fracao === 1 && activeStep === 0) ||
        (valueRadio2Fracao === 1 && activeStep === 1)
      ) {
        openNotificationWithIcon("warning", "EscolherOpcao");
      } else {
        console.log("eu");
        // if (isStepSkipped(activeStep)) {
        //   newSkipped = new Set(newSkipped.values());
        //   newSkipped.delete(activeStep);
        // }

        // setActiveStep((prevActiveStep) => prevActiveStep + 1);
        // setSkipped(newSkipped);
        // if(activeStep === steps.length){
        //   console.log("Aqui fracionado");
        // }
      }
    } else {
      if (
        (valueRadioPeriodoPrincipal === 1 && activeStep === 0) ||
        (valueRadio1Fracao === 1 && activeStep === 1) ||
        (valueRadio2Fracao === 1 && activeStep === 2)
      ) {
        openNotificationWithIcon("warning", "EscolherOpcao");
      } else {
        if (isStepSkipped(activeStep)) {
          newSkipped = new Set(newSkipped.values());
          newSkipped.delete(activeStep);
        }
        if (activeStep === 0) {
          if (valueRadioPeriodoPrincipal === 4) {
            let valor = tratamentoValoresInput(inputNovoValorPeriodoPrincipal);
            if (valor) {
              setActiveStep((prevActiveStep) => prevActiveStep + 1);
              setSkipped(newSkipped);
            } else {
              openNotificationWithIcon("error", "ErroNoValor");
            }
          } else {
            if (valueRadioPeriodoPrincipal === 8) {
              let valor = tratamentoValoresInput(inputReservaPeriodoPrincipal);
              if (valor) {
                onSubmit();
              } else {
                openNotificationWithIcon("error", "ErroNoValor");
              }
            } else {
              if (
                valueRadioPeriodoPrincipal === 9 ||
                valueRadioPeriodoPrincipal === 10
              ) {
                onSubmit();
              } else {
                setActiveStep((prevActiveStep) => prevActiveStep + 1);
                setSkipped(newSkipped);
              }
            }
          }
        } else {
          if (activeStep === 1) {
            if (valueRadio1Fracao === 4) {
              let valor = tratamentoValoresInput(inputNovoValor1Fracao);
              if (valor) {
                setActiveStep((prevActiveStep) => prevActiveStep + 1);
                setSkipped(newSkipped);
              } else {
                openNotificationWithIcon("error", "ErroNoValor");
              }
            } else {
              if (valueRadio1Fracao === 8) {
                let valor = tratamentoValoresInput(inputReserva1Fracao);
                if (valor) {
                  setActiveStep((prevActiveStep) => prevActiveStep + 1);
                  setSkipped(newSkipped);
                } else {
                  openNotificationWithIcon("error", "ErroNoValor");
                }
              } else {
                if (valueRadio1Fracao === 5) {
                  onSubmit();
                } else {
                  setActiveStep((prevActiveStep) => prevActiveStep + 1);
                  setSkipped(newSkipped);
                }
              }
            }
          } else {
            if (activeStep === 2) {
              if (valueRadio2Fracao === 4) {
                let valor = tratamentoValoresInput(inputNovoValor2Fracao);
                if (valor) {
                  onSubmit();
                } else {
                  openNotificationWithIcon("error", "ErroNoValor");
                }
              } else {
                if (valueRadio2Fracao === 8) {
                  let valor = tratamentoValoresInput(inputReserva2Fracao);
                  if (valor) {
                    onSubmit();
                  } else {
                    openNotificationWithIcon("error", "ErroNoValor");
                  }
                } else {
                  onSubmit();
                }
              }
            }
          }
        }
      }
    }
  };

  const atualizarSituacao = async (
    situacao: number,
    periodoUsuarioId: number,
    alterando: boolean
  ) => {
    // 1 - já utilizei ou aluguei em parte - alugar =2
    // 2 - utilizei o periodo
    // 3 - reservei por conta propria
    // 4 - rejeição
    //5 - rejeição e não pertube
    let formData;
    let resultado;

    let situacaoAnteriorPrincipal;
    let situacaoAnterior1Fracao;
    let situacaoAnterior2Fracao;

    let periodoSendoUsado;
    if (periodoUsuarioId === periodoUsuarioData.id) {
      periodoSendoUsado = 1;

      if (periodoUsuarioData.alugar === 1 && periodoUsuarioData.trocar === 1) {
        situacaoAnteriorPrincipal = "ALUGAR_TROCAR";
      } else {
        if (
          periodoUsuarioData.alugar === 1 &&
          periodoUsuarioData.trocar === 0
        ) {
          situacaoAnteriorPrincipal = "ALUGAR";
        } else {
          if (periodoUsuarioData.concluido === 2) {
            situacaoAnteriorPrincipal = "CONCLUIDO_PELO_PROPRIO";
          } else {
            if (periodoUsuarioData.utilizar === 1) {
              situacaoAnteriorPrincipal = "UTILIZADO";
            } else {
              console.log("Tem algo errado com os períodos");
            }
          }
        }
      }
    } else {
      if (periodoUsuarioId === periodoUsuarioDataPrimeiroPeriodo.id) {
        periodoSendoUsado = 2;
        if (
          periodoUsuarioDataPrimeiroPeriodo.alugar === 1 &&
          periodoUsuarioDataPrimeiroPeriodo.trocar === 1
        ) {
          situacaoAnterior1Fracao = "ALUGAR_TROCAR";
        } else {
          if (
            periodoUsuarioDataPrimeiroPeriodo.alugar === 1 &&
            periodoUsuarioDataPrimeiroPeriodo.trocar === 0
          ) {
            situacaoAnterior1Fracao = "ALUGAR";
          } else {
            if (periodoUsuarioDataPrimeiroPeriodo.concluido === 2) {
              situacaoAnterior1Fracao = "CONCLUIDO_PELO_PROPRIO";
            } else {
              if (periodoUsuarioDataPrimeiroPeriodo.utilizar === 1) {
                situacaoAnterior1Fracao = "UTILIZADO";
              } else {
                console.log("Tem algo errado com os períodos");
              }
            }
          }
        }
      } else {
        if (periodoUsuarioId === periodoUsuarioDataSegundoPeriodo.id) {
          periodoSendoUsado = 3;
          if (
            periodoUsuarioDataSegundoPeriodo.alugar === 1 &&
            periodoUsuarioDataSegundoPeriodo.trocar === 1
          ) {
            situacaoAnterior2Fracao = "ALUGAR_TROCAR";
          } else {
            if (
              periodoUsuarioDataSegundoPeriodo.alugar === 1 &&
              periodoUsuarioDataSegundoPeriodo.trocar === 0
            ) {
              situacaoAnterior2Fracao = "ALUGAR";
            } else {
              if (periodoUsuarioDataSegundoPeriodo.concluido === 2) {
                situacaoAnterior2Fracao = "CONCLUIDO_PELO_PROPRIO";
              } else {
                if (periodoUsuarioDataSegundoPeriodo.utilizar === 1) {
                  situacaoAnterior2Fracao = "UTILIZADO";
                } else {
                  console.log("Tem algo errado com os períodos");
                }
              }
            }
          }
        }
      }
    }
    // console.log(
    //   periodoUsuarioData.divulgado,
    //   periodoUsuarioDataPrimeiroPeriodo.divulgado,
    //   periodoUsuarioDataSegundoPeriodo.divulgado
    // );

    switch (situacao) {
      case 1:
        if (
          periodoUsuarioData.divulgado === 1 ||
          periodoUsuarioDataPrimeiroPeriodo.divulgado === 1 ||
          periodoUsuarioDataSegundoPeriodo.divulgado === 1 ||
          alterando
        ) {
          formData = {
            situacaoAnterior: situacaoAnteriorPrincipal,
            status: "ALTERANDO",
            statusAnterior: "FRACAO_FINALIZADA",
            caso: 2,
            periodoUsuario: periodoUsuarioId,
            dataSugestao: periodoUsuarioData.dataSugestao,
          };
        } else {
          formData = {
            status: "FRACAO_FINALIZADA",
            caso: 2,
            dataSugestao: null,
            periodoUsuario: periodoUsuarioId,
          };
        }

        resultado = atualizarPeriodoUsuario(formData);

        if ((await resultado) === 1) {
          return true;
        } else {
          alert("Há algo de errado. Por favor, entre em contato conosco 6.");
          return false;
        }

      case 2:
        if (periodoSendoUsado === 1) {
          if (
            periodoUsuarioData.divulgado === 1 ||
            periodoUsuarioDataPrimeiroPeriodo.divulgado === 1 ||
            periodoUsuarioDataSegundoPeriodo.divulgado === 1 ||
            alterando
          ) {
            formData = {
              situacaoAnterior: situacaoAnteriorPrincipal,
              status: "ALTERANDO",
              caso: 2,
              alugar: 0,
              trocar: 0,
              concluido: 0,
              utilizar: 1,

              dataSugestao: null,
              periodoUsuario: periodoUsuarioId,
            };
          } else {
            formData = {
              alugar: 0,
              trocar: 0,
              concluido: 0,
              utilizar: 1,
              status: "FINALIZADO",
              caso: 2,
              dataSugestao: null,
              periodoUsuario: periodoUsuarioId,
            };
          }
        } else {
          if (periodoSendoUsado === 2) {
            if (
              periodoUsuarioData.divulgado === 1 ||
              periodoUsuarioDataPrimeiroPeriodo.divulgado === 1 ||
              periodoUsuarioDataSegundoPeriodo.divulgado === 1 ||
              alterando
            ) {
              formData = {
                situacaoAnterior: situacaoAnterior1Fracao,
                status: "ALTERANDO",
                alugar: 0,
                trocar: 0,
                concluido: 0,
                utilizar: 1,

                caso: 2,
                dataSugestao: null,
                periodoUsuario: periodoUsuarioId,
              };
            } else {
              formData = {
                alugar: 0,
                trocar: 0,
                concluido: 0,
                utilizar: 1,
                status: "FINALIZADO",
                caso: 2,
                dataSugestao: null,
                periodoUsuario: periodoUsuarioId,
              };
            }
          } else {
            if (periodoSendoUsado === 3) {
              if (
                periodoUsuarioData.divulgado === 1 ||
                periodoUsuarioDataPrimeiroPeriodo.divulgado === 1 ||
                periodoUsuarioDataSegundoPeriodo.divulgado === 1 ||
                alterando
              ) {
                formData = {
                  situacaoAnterior: situacaoAnterior2Fracao,
                  status: "ALTERANDO",
                  caso: 2,
                  dataSugestao: null,
                  alugar: 0,
                  trocar: 0,
                  concluido: 0,
                  utilizar: 1,

                  periodoUsuario: periodoUsuarioId,
                };
              } else {
                formData = {
                  alugar: 0,
                  trocar: 0,
                  concluido: 0,
                  utilizar: 1,
                  status: "FINALIZADO",
                  caso: 2,
                  dataSugestao: null,
                  periodoUsuario: periodoUsuarioId,
                };
              }
            }
          }
        }

        resultado = atualizarPeriodoUsuario(formData);

        if ((await resultado) === 1) {
          return true;
        } else {
          alert("Há algo de errado. Por favor, entre em contato conosco 6.");
          return false;
        }

      case 3:
        if (periodoSendoUsado === 1) {
          if (
            periodoUsuarioData.divulgado === 1 ||
            periodoUsuarioDataPrimeiroPeriodo.divulgado === 1 ||
            periodoUsuarioDataSegundoPeriodo.divulgado === 1 ||
            alterando
          ) {
            formData = {
              situacaoAnterior: situacaoAnteriorPrincipal,

              status: "ALTERANDO",
              alugar: 0,
              trocar: 0,
              concluido: 1,
              utilizar: 0,
              valorSugerido: inputReservaPeriodoPrincipal,
              caso: 2,
              dataSugestao: null,
              periodoUsuario: periodoUsuarioId,
            };
          } else {
            formData = {
              alugar: 0,
              trocar: 0,
              concluido: 1,
              utilizar: 0,
              status: "FINALIZADO",
              valorMin: inputReservaPeriodoPrincipal,
              caso: 2,
              dataSugestao: null,
              periodoUsuario: periodoUsuarioId,
            };
          }
        } else {
          if (periodoSendoUsado === 2) {
            if (
              periodoUsuarioData.divulgado === 1 ||
              periodoUsuarioDataPrimeiroPeriodo.divulgado === 1 ||
              periodoUsuarioDataSegundoPeriodo.divulgado === 1 ||
              alterando
            ) {
              formData = {
                situacaoAnterior: situacaoAnterior1Fracao,

                status: "ALTERANDO",
                alugar: 0,
                trocar: 0,
                concluido: 1,
                valorSugerido: inputReserva1Fracao,
                utilizar: 0,
                caso: 2,
                dataSugestao: null,
                periodoUsuario: periodoUsuarioId,
              };
            } else {
              formData = {
                alugar: 0,
                trocar: 0,
                concluido: 1,
                utilizar: 0,
                status: "FINALIZADO",
                caso: 2,
                valorMin: inputReserva1Fracao,
                dataSugestao: null,
                periodoUsuario: periodoUsuarioId,
              };
            }
          } else {
            if (periodoSendoUsado === 3) {
              if (
                periodoUsuarioData.divulgado === 1 ||
                periodoUsuarioDataPrimeiroPeriodo.divulgado === 1 ||
                periodoUsuarioDataSegundoPeriodo.divulgado === 1 ||
                alterando
              ) {
                formData = {
                  situacaoAnterior: situacaoAnterior2Fracao,

                  status: "ALTERANDO",
                  alugar: 0,
                  trocar: 0,
                  concluido: 1,
                  valorSugerido: inputReserva2Fracao,
                  utilizar: 0,
                  caso: 2,
                  dataSugestao: null,
                  periodoUsuario: periodoUsuarioId,
                };
              } else {
                formData = {
                  alugar: 0,
                  trocar: 0,
                  concluido: 1,
                  utilizar: 0,
                  status: "FINALIZADO",
                  valorMin: inputReserva2Fracao,
                  caso: 2,
                  dataSugestao: null,
                  periodoUsuario: periodoUsuarioId,
                };
              }
            }
          }
        }

        resultado = atualizarPeriodoUsuario(formData);

        if ((await resultado) === 1) {
          return true;
        } else {
          alert("Há algo de errado. Por favor, entre em contato conosco 6.");
          return false;
        }
    }
  };

  const atualizarConfirmo = async (
    tipoEmail: number,
    tipo: string,
    periodoUsuario: number,
    alterando: number
  ) => {
    //alterando: 0 - não deve ficar em alterando a não ser que tenha periodo divulgado, 1 - deve ficar em alterando independente se tiver periodo divulgado, - 2 não deve ficar em alterando independente se tiver periodo divulgado
    //tipos: delegado, confirmado, rejeitado, naoPertube

    let formData3 = {};
    let checkIn = periodoUsuarioData.checkIn;
    let novaFase;
    let fase = definirFasePeriodoUsuario({ confirmando: false, checkIn });
    switch (await fase) {
      case "FASE0":
        novaFase = "FASE0";
        break;
      case "FASE1":
        novaFase = "FASE1";
        break;
      case "FASE2":
        novaFase = "FASE2";
        break;
      case "FASE3":
        novaFase = "FASE3";
        break;
      case "FASE4":
        novaFase = "FASE4";
        break;
      case "FASE5":
        novaFase = "FASE5";
        break;
    }

    if (await fase) {
      if (tipoEmail === 3 || tipoEmail === 5) {
        if (tipo === "delegado") {
          formData3 = {
            statusAnterior: "DELEGADO",
            status: "ALTERANDO",
            caso: 2,
            periodoUsuario: periodoUsuario,
          };
        } else {
          if (tipo === "confirmado") {
            formData3 = {
              status: "ALTERANDO",
              caso: 2,
              periodoUsuario: periodoUsuario,
              alterado: 1,
            };
          } else {
            if (tipo === "rejeitado") {
              if (
                (periodoUsuarioData.divulgado === 1 ||
                  periodoUsuarioDataPrimeiroPeriodo.divulgado === 1 ||
                  periodoUsuarioDataSegundoPeriodo.divulgado === 1 ||
                  alterando === 1) &&
                alterando !== 2
              ) {
                formData3 = {
                  status: "ALTERANDO",
                  caso: 2,
                  statusAnterior: "REJEITADO",
                  periodoUsuario: periodoUsuario,
                };
              } else {
                formData3 = {
                  status: "SEM_STATUS",
                  caso: 2,

                  periodoUsuario: periodoUsuario,
                };
              }
            } else {
              if (tipo === "naoPertube") {
                if (
                  (periodoUsuarioData.divulgado === 1 ||
                    periodoUsuarioDataPrimeiroPeriodo.divulgado === 1 ||
                    periodoUsuarioDataSegundoPeriodo.divulgado === 1 ||
                    alterando === 1) &&
                  alterando !== 2
                ) {
                  formData3 = {
                    status: "ALTERANDO",
                    statusAnterior: "NAO_PERTUBE",
                    caso: 2,

                    periodoUsuario: periodoUsuario,
                  };
                } else {
                  formData3 = {
                    status: "NAO_PERTUBE",
                    caso: 2,

                    periodoUsuario: periodoUsuario,
                  };
                }
              }
            }
          }
        }
      } else {
        if (tipoEmail === 4 || tipoEmail === 6) {
          if (tipo === "delegado") {
            formData3 = {
              statusAnterior: "DELEGADO",
              status: "ALTERANDO",
              caso: 2,
              periodoUsuario: periodoUsuario,
              dataSugestao: periodoUsuarioData.dataSugestao,
            };
          } else {
            if (tipo === "confirmado") {
              formData3 = {
                status: "ALTERANDO",
                caso: 2,
                periodoUsuario: periodoUsuario,
                dataSugestao: periodoUsuarioData.dataSugestao,
              };
            } else {
              if (tipo === "rejeitado") {
                if (
                  (periodoUsuarioData.divulgado === 1 ||
                    periodoUsuarioDataPrimeiroPeriodo.divulgado === 1 ||
                    periodoUsuarioDataSegundoPeriodo.divulgado === 1 ||
                    alterando === 1) &&
                  alterando !== 2
                ) {
                  formData3 = {
                    status: "ALTERANDO",
                    caso: 2,
                    statusAnterior: "REJEITADO",
                    periodoUsuario: periodoUsuario,
                    dataSugestao: periodoUsuarioData.dataSugestao,
                  };
                } else {
                  formData3 = {
                    status: "SEM_STATUS",
                    caso: 2,
                    fase: novaFase,
                    periodoUsuario: periodoUsuario,
                    dataSugestao: null,
                  };
                }
              } else {
                if (tipo === "naoPertube") {
                  if (
                    (periodoUsuarioData.divulgado === 1 ||
                      periodoUsuarioDataPrimeiroPeriodo.divulgado === 1 ||
                      periodoUsuarioDataSegundoPeriodo.divulgado === 1 ||
                      alterando === 1) &&
                    alterando !== 2
                  ) {
                    formData3 = {
                      statusAnterior: "NAO_PERTUBE",
                      status: "ALTERANDO",
                      caso: 2,
                      fase: novaFase,
                      periodoUsuario: periodoUsuario,
                      dataSugestao: null,
                    };
                  } else {
                    formData3 = {
                      status: "NAO_PERTUBE",
                      caso: 2,
                      fase: novaFase,
                      periodoUsuario: periodoUsuario,
                      dataSugestao: null,
                    };
                  }
                }
              }
            }
          }
        }
      }
    }

    let result3 = atualizarPeriodoUsuario(formData3);

    if ((await result3) === 1) {
      return true;
    } else {
      alert("Há algo de errado. Por favor, entre em contato conosco 6.");
      return false;
    }
  };

  const desativarToken = () => {
    if (nIdPEU.idPEU && nToken.token) {
      let resultToken = InativarTokenPeriodoUsuario(
        +nIdPEU.idPEU,
        nToken.token
      );
      return resultToken;
    }
  };

  const atualizarNovoValor = async (
    tipoEmail: number,
    inputData: any,
    periodoUsuario: number
  ) => {
    let formData4 = {};
    if (tipoEmail === 3 || tipoEmail === 5) {
      formData4 = {
        status: "ALTERANDO",
        caso: 2,
        periodoUsuario: periodoUsuario,
        valorSugerido: inputData,
      };
    } else {
      if (tipoEmail === 4 || tipoEmail === 6) {
        formData4 = {
          status: "ALTERANDO",
          caso: 2,
          periodoUsuario: periodoUsuario,
          dataSugestao: periodoUsuarioData.dataSugestao,
          valorSugerido: inputData,
        };
      }
    }

    let result4 = atualizarPeriodoUsuario(formData4);

    if ((await result4) === 1) {
      return true;
    } else {
      alert("Há algo de errado. Por favor, entre em contato conosco 2.");
    }
  };

  const rejeitoValor = async (
    tipoEmail: number,
    naoPertube: boolean,
    periodoUsuario: number
  ) => {
    let alugar;
    let trocar;
    let status;

    if (naoPertube) {
      status = "NAO_PERTUBE";
    } else {
      status = "SEM_STATUS";
    }

    let formData5 = {};

    // let status;

    switch (periodoUsuarioData.situacaoAnterior) {
      case "NAO_DEFINIDO":
        alugar = 0;
        trocar = 0;
        break;
      case "ALUGAR":
        alugar = 1;
        trocar = 0;
        break;
      case "ALUGAR_TROCAR":
        alugar = 1;
        trocar = 1;
        break;
    }

    if (tipoEmail === 3) {
      formData5 = {
        status: status,
        caso: 5,
        periodoUsuario: periodoUsuario,
        valorSugerido: "0",
        alugar: alugar,
        trocar: trocar,
      };
    } else {
      if (tipoEmail === 4) {
        const checkIn = periodoUsuarioData.checkIn;

        let fase = definirFasePeriodoUsuario({ confirmando: false, checkIn });
        let novaFase;

        switch (await fase) {
          case "FASE0":
            novaFase = "FASE0";
            break;
          case "FASE1":
            novaFase = "FASE1";
            break;
          case "FASE2":
            novaFase = "FASE2";
            break;
          case "FASE3":
            novaFase = "FASE3";
            break;
          case "FASE4":
            novaFase = "FASE4";
            break;
          case "FASE5":
            novaFase = "FASE5";
            break;
        }
        if (await fase) {
          formData5 = {
            status: status,
            caso: 5,
            periodoUsuario: periodoUsuario,
            dataSugestao: null,
            valorSugerido: "0",
            alugar: alugar,
            trocar: trocar,
            fase: novaFase,
          };
        }
      }
    }

    let result5 = atualizarPeriodoUsuario(formData5);

    if ((await result5) === 1) {
      return true;
    } else {
      alert("Há algo de errado. Por favor, entre em contato conosco 3.");
      return false;
    }
  };

  const atualizarReservadoOuUtilizado = async (
    situacao: string,
    divulgado: number,

    periodoUsuario: number
  ) => {
    let concluido;
    let utilizado;
    if (situacao === "RESERVADO") {
      concluido = 1;
      utilizado = 0;
    } else {
      if (situacao === "SERÁ UTILIZADO") {
        concluido = 0;
        utilizado = 1;
      }
    }
    let valorReservado = tratamentoValoresInput(inputReservaPeriodoUnico);
    if (divulgado === 0) {
      let formData7 = {};
      formData7 = {
        caso: 7,
        periodoUsuario: periodoUsuario,
        valorSugerido: "0",
        valorMin: valorReservado,
        alugar: 0,
        trocar: 0,
        utilizar: utilizado,
        concluido: concluido,
        status: "FINALIZADO",
        dataSugestao: null,
      };

      let result7 = atualizarPeriodoUsuario(formData7);

      if ((await result7) === 1) {
        return true;
      } else {
        alert("Há algo de errado. Por favor, entre em contato conosco 4.");
        return false;
      }
    } else {
      if (divulgado === 1) {
        let situacaoAnterior;
        if (
          periodoUsuarioData.alugar === 1 &&
          periodoUsuarioData.trocar === 1
        ) {
          situacaoAnterior = "ALUGAR_TROCAR";
        } else {
          if (
            periodoUsuarioData.alugar === 1 &&
            periodoUsuarioData.trocar === 0
          ) {
            situacaoAnterior = "ALUGAR";
          } else {
            console.log("Tem algo errado com os períodos");
          }
        }
        let formData7 = {};
        formData7 = {
          caso: 7,
          valorSugerido: valorReservado,
          periodoUsuario: periodoUsuario,
          status: "ALTERANDO",

          situacaoAnterior: situacaoAnterior,
          dataSugestao: null,
          alugar: 0,
          trocar: 0,
          utilizar: utilizado,
          concluido: concluido,
        };

        let result7 = atualizarPeriodoUsuario(formData7);

        if ((await result7) === 1) {
          return true;
        } else {
          alert("Há algo de errado. Por favor, entre em contato conosco 5.");
        }
      } else {
        console.log("Divulgado não está definido");
      }
    }
  };

  const atualizarPeriodoUsuarioPeloTipo = async (
    tipoEmail: number,
    unico: boolean,
    valorPrincipal: number,
    valor1Fracao: number,
    valor2Fracao: number
  ) => {
    const periodoUsuarioIdPrincipal = periodoUsuarioData.id;
    const periodoUsuarioId1Fracao = periodoUsuarioDataPrimeiroPeriodo.id;
    const periodoUsuarioId2Fracao = periodoUsuarioDataSegundoPeriodo.id;

    if (unico) {
      switch (valorPrincipal) {
        case 2:
          // "confirmo e delego"
          let result1 = atualizarConfirmo(
            tipoEmail,
            "delegado",
            periodoUsuarioIdPrincipal,
            0
          );
          if (await result1) {
            let result1_1 = desativarToken();
            if (result1_1) {
              document.location.href = "/sucessoprocedimento";
            } else {
              document.location.href = "/algodeuerrado";
            }
          }

          break;
        case 3:
          //"Confirmo"
          let result3 = atualizarConfirmo(
            tipoEmail,
            "confirmado",
            periodoUsuarioIdPrincipal,
            0
          );
          if (await result3) {
            let result3_1 = desativarToken();
            if (result3_1) {
              document.location.href = "/sucessoprocedimento";
            } else {
              document.location.href = "/algodeuerrado";
            }
          }
          break;
        case 4:
          //novo valor
          let valor = tratamentoValoresInput(inputNovoValorPeriodoUnico);
          if (valor) {
            let result4 = atualizarNovoValor(
              tipoEmail,
              valor,
              periodoUsuarioIdPrincipal
            );

            if (await result4) {
              let result4_1 = desativarToken();
              if (result4_1) {
                document.location.href = "/sucessoprocedimento";
              } else {
                document.location.href = "/algodeuerrado";
              }
            }
          } else {
            openNotificationWithIcon("error", "ErroNoValor");
          }

          break;

        case 5:
          //Rejeito
          let result5 = rejeitoValor(
            tipoEmail,
            false,
            periodoUsuarioIdPrincipal
          );

          if (await result5) {
            let result5_1 = desativarToken();
            if (await result5_1) {
              let formDataEmail = {
                tipoEmail: 11,
                periodoUsuarioId: periodoUsuarioData.id,
                valorSugerido: periodoUsuarioData.valorSugerido,
              };

              let resultEmail = enviarEmail(formDataEmail);
              if (await resultEmail) {
                document.location.href = "/sucessoprocedimento";
              } else {
                document.location.href = "/algodeuerrado";
              }
            } else {
              document.location.href = "/algodeuerrado";
            }
          }

          break;

        case 6:
          //Rejeito e não pertube
          let result6 = rejeitoValor(
            tipoEmail,
            true,
            periodoUsuarioIdPrincipal
          );

          if (await result6) {
            let result6_1 = desativarToken();
            if (await result6_1) {
              let formDataEmail = {
                tipoEmail: 12,
                periodoUsuarioId: periodoUsuarioData.id,
                valorSugerido: periodoUsuarioData.valorSugerido,
              };

              let resultEmail = enviarEmail(formDataEmail);
              if (await resultEmail) {
                document.location.href = "/sucessoprocedimento";
              } else {
                document.location.href = "/algodeuerrado";
              }
            } else {
              document.location.href = "/algodeuerrado";
            }
          }
          break;

        case 7:
          //reservado pelo proprio
          let valorReservado = tratamentoValoresInput(inputReservaPeriodoUnico);

          if (valorReservado) {
            let result7_1 = atualizarReservadoOuUtilizado(
              "RESERVADO",
              periodoUsuarioData.divulgado,
              periodoUsuarioIdPrincipal
            );
            if (await result7_1) {
              if (periodoUsuarioData.divulgado === 0) {
                if (periodoUsuarioIdPrincipal && nToken.token) {
                  let resultToken = InativarTokenPeriodoUsuario(
                    +periodoUsuarioIdPrincipal,
                    nToken.token
                  );
                  if ((await resultToken) === 1) {
                    let formDataEmail = {
                      tipoEmail: 13,
                      situacao: "RESERVADO",
                      periodoUsuarioId: periodoUsuarioIdPrincipal,
                    };

                    let resultEmail = enviarEmail(formDataEmail);
                    if (await resultEmail) {
                      document.location.href = "/sucessoprocedimento";
                    } else {
                      document.location.href = "/algodeuerrado";
                    }
                  } else {
                    document.location.href = "/algodeuerrado";
                  }
                }
              } else {
                if (periodoUsuarioData.divulgado === 1) {
                  if (periodoUsuarioIdPrincipal && nToken.token) {
                    let resultToken = InativarTokenPeriodoUsuario(
                      +periodoUsuarioIdPrincipal,
                      nToken.token
                    );
                    if (await resultToken) {
                      document.location.href = "/sucessoprocedimento";
                    } else {
                      document.location.href = "/algodeuerrado";
                    }
                  }
                }
              }
            } else {
            }
          } else {
            openNotificationWithIcon("error", "ErroNoValor");
          }

          break;
        case 8:
          //utilizado
          atualizarReservadoOuUtilizado(
            "SERÁ UTILIZADO",
            periodoUsuarioData.divulgado,
            periodoUsuarioIdPrincipal
          );
          if (periodoUsuarioData.divulgado === 0) {
            if (periodoUsuarioIdPrincipal && nToken.token) {
              let resultToken = InativarTokenPeriodoUsuario(
                +periodoUsuarioIdPrincipal,
                nToken.token
              );
              if ((await resultToken) === 1) {
                let formDataEmail = {
                  tipoEmail: 13,
                  situacao: "SERÁ UTILIZADO",
                  periodoUsuarioId: periodoUsuarioIdPrincipal,
                };

                let resultEmail = enviarEmail(formDataEmail);
                if (await resultEmail) {
                  document.location.href = "/sucessoprocedimento";
                } else {
                  document.location.href = "/algodeuerrado";
                }
              } else {
                document.location.href = "/algodeuerrado";
              }
            }
          } else {
            if (periodoUsuarioData.divulgado === 1) {
              if (periodoUsuarioIdPrincipal && nToken.token) {
                let resultToken = InativarTokenPeriodoUsuario(
                  +periodoUsuarioIdPrincipal,
                  nToken.token
                );
                if (await resultToken) {
                  document.location.href = "/sucessoprocedimento";
                } else {
                  document.location.href = "/algodeuerrado";
                }
              }
            }
          }
          break;

        case 9:
          // vendi a cota
          let resultToken = desativarToken();
          if (resultToken) {
            let resultCota = venderCota(false, periodoUsuarioData.id, 0);
            if ((await resultCota) === 1) {
              document.location.href = "/sucessoprocedimento";
            } else {
              document.location.href = "/algodeuerrado";
            }
          } else {
            openNotificationWithIcon("error", "ErrosGerais");
          }

          break;
      }
    } else {
      switch (valorPrincipal) {
        case 2:
          //confirmo e delego
          switch (valor1Fracao) {
            case 2:
              //confirmo e delego
              switch (valor2Fracao) {
                case 2:
                  //confirmo e delego
                  let resultado = atualizarConfirmo(
                    tipoEmail,
                    "delegado",
                    periodoUsuarioIdPrincipal,
                    0
                  );
                  if (await resultado) {
                    let resultado1 = atualizarConfirmo(
                      tipoEmail,
                      "delegado",
                      periodoUsuarioId1Fracao,
                      0
                    );
                    if (await resultado1) {
                      let resultado2 = atualizarConfirmo(
                        tipoEmail,
                        "delegado",
                        periodoUsuarioId2Fracao,
                        0
                      );
                      if (await resultado2) {
                        let resultToken = desativarToken();

                        if (await resultToken) {
                          document.location.href = "/sucessoprocedimento";
                        } else {
                          document.location.href = "/algodeuerrado";
                        }
                      }
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }

                  break;
                case 3:
                  //confirmo
                  openNotificationWithIcon("error", "PeriodoPrincipalDelegado");

                  break;
                case 4:
                  //novo valor
                  openNotificationWithIcon("error", "PeriodoPrincipalDelegado");
                  break;
                case 5:
                  //fracione
                  openNotificationWithIcon("error", "PeriodoPrincipalDelegado");
                  break;
                case 6:
                  //rejeito
                  openNotificationWithIcon("error", "PeriodoPrincipalDelegado");
                  break;
                case 7:
                  //rejeito e não pertube
                  openNotificationWithIcon("error", "PeriodoPrincipalDelegado");
                  break;
                case 8:
                  //já reservei
                  openNotificationWithIcon("error", "PeriodoPrincipalDelegado");
                  break;
                case 9:
                  //já utilizei
                  openNotificationWithIcon("error", "PeriodoPrincipalDelegado");
                  break;
              }
              break;
            case 3:
              //confirmo
              openNotificationWithIcon("error", "PeriodoPrincipalDelegado");
              break;
            case 4:
              //novo valor
              openNotificationWithIcon("error", "PeriodoPrincipalDelegado");
              break;
            case 5:
              //fracione
              let resultado = atualizarConfirmo(
                tipoEmail,
                "delegado",
                periodoUsuarioIdPrincipal,
                0
              );
              if (await resultado) {
                let result35 = naoFracione(
                  periodoUsuarioIdPrincipal,
                  periodoUsuarioData.divulgado,
                  periodoUsuarioDataPrimeiroPeriodo.divulgado,
                  periodoUsuarioDataSegundoPeriodo.divulgado,
                  true
                );

                switch (await result35) {
                  case 1:
                    let resultToken = desativarToken();

                    if (await resultToken) {
                      document.location.href = "/sucessoprocedimento";
                    } else {
                      document.location.href = "/algodeuerrado";
                    }
                    break;
                  case 2:
                  case 3:
                  case 4:
                    openNotificationWithIcon("error", "ErrosGerais");
                    break;
                }
              }

              break;
            case 6:
              //rejeito
              openNotificationWithIcon("error", "PeriodoPrincipalDelegado");
              break;
            case 7:
              //rejeito e não pertube
              openNotificationWithIcon("error", "PeriodoPrincipalDelegado");
              break;
            case 8:
              //já reservei
              openNotificationWithIcon("error", "PeriodoPrincipalDelegado");
              break;
            case 9:
              //já utilizei
              openNotificationWithIcon("error", "PeriodoPrincipalDelegado");
              break;
          }
          break;
        case 3:
          //confirmo
          switch (valueRadio1Fracao) {
            case 2:
              //confirmo e delego
              openNotificationWithIcon(
                "error",
                "SelecionarDelegadoNoPrincipal"
              );
              break;
            case 3:
              //confirmo
              switch (valueRadio2Fracao) {
                case 2:
                  //confirmo e delego
                  openNotificationWithIcon(
                    "error",
                    "SelecionarDelegadoNoPrincipal"
                  );
                  break;
                case 3:
                  //confirmo
                  let resultado = atualizarConfirmo(
                    tipoEmail,
                    "confirmado",
                    periodoUsuarioIdPrincipal,
                    0
                  );
                  if (await resultado) {
                    let resultado1 = atualizarConfirmo(
                      tipoEmail,
                      "confirmado",
                      periodoUsuarioId1Fracao,
                      0
                    );
                    if (await resultado1) {
                      let resultado2 = atualizarConfirmo(
                        tipoEmail,
                        "confirmado",
                        periodoUsuarioId2Fracao,
                        0
                      );
                      if (await resultado2) {
                        let resultToken = desativarToken();

                        if (await resultToken) {
                          document.location.href = "/sucessoprocedimento";
                        } else {
                          document.location.href = "/algodeuerrado";
                        }
                      }
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }
                  break;
                case 4:
                  //confirmo - confirmo - novo valor
                  let resultado334 = atualizarConfirmo(
                    tipoEmail,
                    "confirmado",
                    periodoUsuarioIdPrincipal,
                    0
                  );
                  if (await resultado334) {
                    let resultado1 = atualizarConfirmo(
                      tipoEmail,
                      "confirmado",
                      periodoUsuarioId1Fracao,
                      0
                    );
                    if (await resultado1) {
                      let valor = tratamentoValoresInput(inputNovoValor2Fracao);
                      if (valor) {
                        let resultado2 = atualizarNovoValor(
                          tipoEmail,
                          valor,
                          periodoUsuarioId2Fracao
                        );
                        if (await resultado2) {
                          let resultToken = desativarToken();

                          if (await resultToken) {
                            document.location.href = "/sucessoprocedimento";
                          } else {
                            document.location.href = "/algodeuerrado";
                          }
                        } else {
                          openNotificationWithIcon("error", "ErrosGerais");
                        }
                      } else {
                        openNotificationWithIcon("error", "ErroNoValor");
                      }
                    } else {
                      openNotificationWithIcon("error", "ErrosGerais");
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }
                  break;
                case 5:
                  //fracione
                  openNotificationWithIcon("error", "FracioneNaPrimeiraFracao");
                  break;
                case 6:
                  //rejeito
                  let resultado336 = atualizarConfirmo(
                    tipoEmail,
                    "confirmado",
                    periodoUsuarioIdPrincipal,
                    1
                  );
                  if (await resultado336) {
                    let resultado1 = atualizarConfirmo(
                      tipoEmail,
                      "confirmado",
                      periodoUsuarioId1Fracao,
                      1
                    );
                    if (await resultado1) {
                      let resultado2 = atualizarConfirmo(
                        tipoEmail,
                        "rejeitado",
                        periodoUsuarioId2Fracao,
                        1
                      );
                      if (await resultado2) {
                        let resultToken = desativarToken();

                        if (await resultToken) {
                          document.location.href = "/sucessoprocedimento";
                        } else {
                          document.location.href = "/algodeuerrado";
                        }
                      }
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }
                  break;
                case 7:
                  //rejeito e não pertube
                  openNotificationWithIcon(
                    "error",
                    "SelecionarNaoPertubeNoPrincipal"
                  );
                  break;
                case 8:
                  //já reservei
                  openNotificationWithIcon(
                    "error",
                    "SelecionarReservadoUtilizadoEmParte"
                  );
                  break;
                case 9:
                  //já utilizei
                  openNotificationWithIcon(
                    "error",
                    "SelecionarReservadoUtilizadoEmParte"
                  );
                  break;
              }
              break;
            case 4:
              //novo valor
              switch (valueRadio2Fracao) {
                case 2:
                  //confirmo e delego
                  openNotificationWithIcon(
                    "error",
                    "SelecionarDelegadoNoPrincipal"
                  );
                  break;
                case 3:
                  //confirmo - novo valor - confirmo

                  let resultado343 = atualizarConfirmo(
                    tipoEmail,
                    "confirmado",
                    periodoUsuarioIdPrincipal,
                    0
                  );
                  if (await resultado343) {
                    let valor = tratamentoValoresInput(inputNovoValor1Fracao);
                    if (valor) {
                      let resultado2 = atualizarNovoValor(
                        tipoEmail,
                        valor,
                        periodoUsuarioId1Fracao
                      );
                      if (await resultado2) {
                        let resultado1 = atualizarConfirmo(
                          tipoEmail,
                          "confirmado",
                          periodoUsuarioId2Fracao,
                          0
                        );
                        if (await resultado1) {
                          let resultToken = desativarToken();

                          if (await resultToken) {
                            document.location.href = "/sucessoprocedimento";
                          } else {
                            document.location.href = "/algodeuerrado";
                          }
                        } else {
                          openNotificationWithIcon("error", "ErrosGerais");
                        }
                      } else {
                        openNotificationWithIcon("error", "ErrosGerais");
                      }
                    } else {
                      openNotificationWithIcon("error", "ErroNoValor");
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }
                  break;
                case 4:
                  //confirmo - novo valor - novo valor
                  let resultado344 = atualizarConfirmo(
                    tipoEmail,
                    "confirmado",
                    periodoUsuarioIdPrincipal,
                    0
                  );
                  if (await resultado344) {
                    let valor = tratamentoValoresInput(inputNovoValor1Fracao);
                    if (valor) {
                      let resultado2 = atualizarNovoValor(
                        tipoEmail,
                        valor,
                        periodoUsuarioId1Fracao
                      );
                      if (await resultado2) {
                        let valor2 = tratamentoValoresInput(
                          inputNovoValor2Fracao
                        );
                        let resultado1 = atualizarNovoValor(
                          tipoEmail,
                          valor2,
                          periodoUsuarioId2Fracao
                        );
                        if (await resultado1) {
                          let resultToken = desativarToken();

                          if (await resultToken) {
                            document.location.href = "/sucessoprocedimento";
                          } else {
                            document.location.href = "/algodeuerrado";
                          }
                        } else {
                          openNotificationWithIcon("error", "ErrosGerais");
                        }
                      } else {
                        openNotificationWithIcon("error", "ErrosGerais");
                      }
                    } else {
                      openNotificationWithIcon("error", "ErroNoValor");
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }
                  break;
                case 5:
                  //fracione
                  openNotificationWithIcon("error", "FracioneNaPrimeiraFracao");
                  break;
                case 6:
                  //rejeito
                  let resultado346 = atualizarConfirmo(
                    tipoEmail,
                    "confirmado",
                    periodoUsuarioIdPrincipal,
                    1
                  );
                  if (await resultado346) {
                    let resultado1 = atualizarNovoValor(
                      tipoEmail,
                      inputNovoValor1Fracao,
                      periodoUsuarioId1Fracao
                    );
                    if (await resultado1) {
                      let resultado2 = atualizarConfirmo(
                        tipoEmail,
                        "rejeitado",
                        periodoUsuarioId2Fracao,
                        1
                      );
                      if (await resultado2) {
                        let resultToken = desativarToken();

                        if (await resultToken) {
                          document.location.href = "/sucessoprocedimento";
                        } else {
                          document.location.href = "/algodeuerrado";
                        }
                      }
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }
                  break;
                case 7:
                  //rejeito e não pertube
                  openNotificationWithIcon(
                    "error",
                    "SelecionarNaoPertubeNoPrincipal"
                  );
                  break;
                case 8:
                  //já reservei
                  openNotificationWithIcon(
                    "error",
                    "SelecionarReservadoUtilizadoEmParte"
                  );
                  break;
                case 9:
                  //já utilizei
                  openNotificationWithIcon(
                    "error",
                    "SelecionarReservadoUtilizadoEmParte"
                  );
                  break;
              }
              break;
            case 5:
              //fracione

              let resultado = atualizarConfirmo(
                tipoEmail,
                "confirmado",
                periodoUsuarioIdPrincipal,
                1
              );
              if (await resultado) {
                let result35 = naoFracione(
                  periodoUsuarioIdPrincipal,
                  periodoUsuarioData.divulgado,
                  periodoUsuarioDataPrimeiroPeriodo.divulgado,
                  periodoUsuarioDataSegundoPeriodo.divulgado,
                  true
                );

                switch (await result35) {
                  case 1:
                    let resultToken = desativarToken();

                    if (await resultToken) {
                      document.location.href = "/sucessoprocedimento";
                    } else {
                      document.location.href = "/algodeuerrado";
                    }
                    break;
                  case 2:
                  case 3:
                  case 4:
                    openNotificationWithIcon("error", "ErrosGerais");
                    break;
                }
              }

              break;
            case 6:
              //rejeito
              switch (valueRadio2Fracao) {
                case 2:
                  //confirmo e delego
                  openNotificationWithIcon(
                    "error",
                    "SelecionarDelegadoNoPrincipal"
                  );
                  break;
                case 3:
                  //confirmo
                  let resultado363 = atualizarConfirmo(
                    tipoEmail,
                    "confirmado",
                    periodoUsuarioIdPrincipal,
                    1
                  );
                  if (await resultado363) {
                    let resultado1 = atualizarConfirmo(
                      tipoEmail,
                      "rejeitado",
                      periodoUsuarioId1Fracao,
                      1
                    );
                    if (await resultado1) {
                      let resultado2 = atualizarConfirmo(
                        tipoEmail,
                        "confirmado",
                        periodoUsuarioId2Fracao,
                        1
                      );
                      if (await resultado2) {
                        let resultToken = desativarToken();
                        if (await resultToken) {
                          document.location.href = "/sucessoprocedimento";
                        } else {
                          document.location.href = "/algodeuerrado";
                        }
                      }
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }
                  break;
                case 4:
                  //novo valor
                  let resultado364 = atualizarConfirmo(
                    tipoEmail,
                    "confirmado",
                    periodoUsuarioIdPrincipal,
                    1
                  );
                  if (await resultado364) {
                    let resultado1 = atualizarConfirmo(
                      tipoEmail,
                      "rejeitado",
                      periodoUsuarioId1Fracao,
                      1
                    );
                    if (await resultado1) {
                      let valor = tratamentoValoresInput(inputNovoValor2Fracao);
                      if (valor) {
                        let resultado2 = atualizarNovoValor(
                          tipoEmail,
                          valor,
                          periodoUsuarioId2Fracao
                        );

                        if (await resultado2) {
                          let resultToken = desativarToken();
                          if (await resultToken) {
                            document.location.href = "/sucessoprocedimento";
                          } else {
                            document.location.href = "/algodeuerrado";
                          }
                        }
                      } else {
                        openNotificationWithIcon("error", "ErrosGerais");
                      }
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }
                  break;
                case 5:
                  //fracione
                  openNotificationWithIcon("error", "FracioneNaPrimeiraFracao");
                  break;
                case 6:
                  //rejeito
                  let resultado366 = atualizarConfirmo(
                    tipoEmail,
                    "confirmado",
                    periodoUsuarioIdPrincipal,
                    1
                  );
                  if (await resultado366) {
                    let resultado1 = atualizarConfirmo(
                      tipoEmail,
                      "rejeitado",
                      periodoUsuarioId1Fracao,
                      1
                    );
                    if (await resultado1) {
                      let resultado2 = atualizarConfirmo(
                        tipoEmail,
                        "rejeitado",
                        periodoUsuarioId2Fracao,
                        1
                      );
                      if (await resultado2) {
                        let resultToken = desativarToken();
                        if (await resultToken) {
                          document.location.href = "/sucessoprocedimento";
                        } else {
                          document.location.href = "/algodeuerrado";
                        }
                      }
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }
                  break;
                case 7:
                  //rejeito e não pertube
                  openNotificationWithIcon(
                    "error",
                    "SelecionarNaoPertubeNoPrincipal"
                  );
                  break;
                case 8:
                  //já reservei
                  openNotificationWithIcon(
                    "error",
                    "SelecionarReservadoUtilizadoEmParte"
                  );
                  break;
                case 9:
                  //já utilizei
                  openNotificationWithIcon(
                    "error",
                    "SelecionarReservadoUtilizadoEmParte"
                  );
                  break;
              }
              break;
            case 7:
              //rejeito e não pertube
              openNotificationWithIcon(
                "error",
                "SelecionarNaoPertubeNoPrincipal"
              );
              break;
            case 8:
              //já reservei
              openNotificationWithIcon(
                "error",
                "SelecionarReservadoUtilizadoEmParte"
              );
              break;
            case 9:
              //já utilizei
              openNotificationWithIcon(
                "error",
                "SelecionarReservadoUtilizadoEmParte"
              );
              break;
          }
          break;
        case 4:
          //novo valor
          switch (valueRadio1Fracao) {
            case 2:
              //confirmo e delego
              openNotificationWithIcon(
                "error",
                "SelecionarDelegadoNoPrincipal"
              );
              break;
            case 3:
              //confirmo
              switch (valueRadio2Fracao) {
                case 2:
                  //confirmo e delego
                  openNotificationWithIcon(
                    "error",
                    "SelecionarDelegadoNoPrincipal"
                  );
                  break;
                case 3:
                  //novo valor - confirma - confirma
                  let valor433 = tratamentoValoresInput(
                    inputNovoValorPeriodoPrincipal
                  );
                  if (valor433) {
                    let resultado433 = atualizarNovoValor(
                      tipoEmail,
                      valor433,
                      periodoUsuarioIdPrincipal
                    );
                    if (await resultado433) {
                      let resultado2 = atualizarConfirmo(
                        tipoEmail,
                        "confirmado",
                        periodoUsuarioId1Fracao,
                        0
                      );
                      if (await resultado2) {
                        let resultado1 = atualizarConfirmo(
                          tipoEmail,
                          "confirmado",
                          periodoUsuarioId2Fracao,
                          0
                        );

                        if (await resultado1) {
                          let resultToken = desativarToken();

                          if (await resultToken) {
                            document.location.href = "/sucessoprocedimento";
                          } else {
                            document.location.href = "/algodeuerrado";
                          }
                        } else {
                          openNotificationWithIcon("error", "ErrosGerais");
                        }
                      } else {
                        openNotificationWithIcon("error", "ErrosGerais");
                      }
                    } else {
                      openNotificationWithIcon("error", "ErrosGerais");
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }
                  break;
                case 4:
                  //novo valor - confirmo - novo valor
                  let valor434 = tratamentoValoresInput(
                    inputNovoValorPeriodoPrincipal
                  );
                  if (valor434) {
                    let resultado434 = atualizarNovoValor(
                      tipoEmail,
                      valor434,
                      periodoUsuarioIdPrincipal
                    );
                    if (await resultado434) {
                      let resultado2 = atualizarConfirmo(
                        tipoEmail,
                        "confirmado",
                        periodoUsuarioId1Fracao,
                        0
                      );
                      if (await resultado2) {
                        let valor2 = tratamentoValoresInput(
                          inputNovoValor2Fracao
                        );
                        if (valor2) {
                          let resultado1 = atualizarNovoValor(
                            tipoEmail,
                            valor2,
                            periodoUsuarioId2Fracao
                          );
                          if (await resultado1) {
                            let resultToken = desativarToken();

                            if (await resultToken) {
                              document.location.href = "/sucessoprocedimento";
                            } else {
                              document.location.href = "/algodeuerrado";
                            }
                          } else {
                            openNotificationWithIcon("error", "ErrosGerais");
                          }
                        } else {
                          openNotificationWithIcon("error", "ErrosGerais");
                        }
                      } else {
                        openNotificationWithIcon("error", "ErrosGerais");
                      }
                    } else {
                      openNotificationWithIcon("error", "ErrosGerais");
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }

                  break;
                case 5:
                  //fracione
                  openNotificationWithIcon("error", "FracioneNaPrimeiraFracao");
                  break;
                case 6:
                  //rejeito
                  let valor = tratamentoValoresInput(
                    inputNovoValorPeriodoPrincipal
                  );
                  let resultado436 = atualizarNovoValor(
                    tipoEmail,
                    valor,
                    periodoUsuarioIdPrincipal
                  );
                  if (await resultado436) {
                    let resultado1 = atualizarConfirmo(
                      tipoEmail,
                      "confirmado",
                      periodoUsuarioId1Fracao,
                      1
                    );
                    if (await resultado1) {
                      let resultado2 = atualizarConfirmo(
                        tipoEmail,
                        "rejeitado",
                        periodoUsuarioId2Fracao,
                        1
                      );

                      if (await resultado2) {
                        let resultToken = desativarToken();
                        if (await resultToken) {
                          document.location.href = "/sucessoprocedimento";
                        } else {
                          document.location.href = "/algodeuerrado";
                        }
                      }
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }
                  break;
                case 7:
                  //rejeito e não pertube
                  openNotificationWithIcon(
                    "error",
                    "SelecionarNaoPertubeNoPrincipal"
                  );

                  break;
                case 8:
                  //já reservei
                  openNotificationWithIcon(
                    "error",
                    "SelecionarReservadoUtilizadoEmParte"
                  );
                  break;
                case 9:
                  //já utilizei
                  openNotificationWithIcon(
                    "error",
                    "SelecionarReservadoUtilizadoEmParte"
                  );
                  break;
              }
              break;
            case 4:
              //novo valor
              switch (valueRadio2Fracao) {
                case 2:
                  //confirmo e delego
                  openNotificationWithIcon(
                    "error",
                    "SelecionarDelegadoNoPrincipal"
                  );
                  break;
                case 3:
                  //novo valor - novo valor - confirma
                  let valor443 = tratamentoValoresInput(
                    inputNovoValorPeriodoPrincipal
                  );
                  if (valor443) {
                    let resultado443 = atualizarNovoValor(
                      tipoEmail,
                      valor443,
                      periodoUsuarioIdPrincipal
                    );
                    if (await resultado443) {
                      let valor2 = tratamentoValoresInput(
                        inputNovoValor1Fracao
                      );
                      if (valor2) {
                        let resultado2 = atualizarNovoValor(
                          tipoEmail,
                          valor2,
                          periodoUsuarioId1Fracao
                        );

                        if (await resultado2) {
                          let resultado1 = atualizarConfirmo(
                            tipoEmail,
                            "confirmado",
                            periodoUsuarioId2Fracao,
                            0
                          );

                          if (await resultado1) {
                            let resultToken = desativarToken();

                            if (await resultToken) {
                              document.location.href = "/sucessoprocedimento";
                            } else {
                              document.location.href = "/algodeuerrado";
                            }
                          } else {
                            openNotificationWithIcon("error", "ErrosGerais");
                          }
                        } else {
                          openNotificationWithIcon("error", "ErrosGerais");
                        }
                      } else {
                        openNotificationWithIcon("error", "ErrosGerais");
                      }
                    } else {
                      openNotificationWithIcon("error", "ErrosGerais");
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }
                  break;
                case 4:
                  //novo valor - novo valor - novo valor
                  let valor444 = tratamentoValoresInput(
                    inputNovoValorPeriodoPrincipal
                  );
                  if (valor444) {
                    let resultado444 = atualizarNovoValor(
                      tipoEmail,
                      valor444,
                      periodoUsuarioIdPrincipal
                    );
                    if (await resultado444) {
                      let valor3 = tratamentoValoresInput(
                        inputNovoValor1Fracao
                      );
                      if (valor3) {
                        let resultado2 = atualizarNovoValor(
                          tipoEmail,
                          valor3,
                          periodoUsuarioId1Fracao
                        );
                        if (await resultado2) {
                          let valor2 = tratamentoValoresInput(
                            inputNovoValor2Fracao
                          );
                          if (valor2) {
                            let resultado1 = atualizarNovoValor(
                              tipoEmail,
                              valor2,
                              periodoUsuarioId2Fracao
                            );
                            if (await resultado1) {
                              let resultToken = desativarToken();

                              if (await resultToken) {
                                document.location.href = "/sucessoprocedimento";
                              } else {
                                document.location.href = "/algodeuerrado";
                              }
                            } else {
                              openNotificationWithIcon("error", "ErrosGerais");
                            }
                          } else {
                            openNotificationWithIcon("error", "ErrosGerais");
                          }
                        } else {
                          openNotificationWithIcon("error", "ErrosGerais");
                        }
                      } else {
                        openNotificationWithIcon("error", "ErrosGerais");
                      }
                    } else {
                      openNotificationWithIcon("error", "ErrosGerais");
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }
                  break;
                case 5:
                  //fracione
                  openNotificationWithIcon("error", "FracioneNaPrimeiraFracao");

                  break;
                case 6:
                  //rejeito
                  let valor = tratamentoValoresInput(
                    inputNovoValorPeriodoPrincipal
                  );
                  let resultado446 = atualizarNovoValor(
                    tipoEmail,
                    valor,
                    periodoUsuarioIdPrincipal
                  );
                  if (await resultado446) {
                    let valor446 = tratamentoValoresInput(
                      inputNovoValor1Fracao
                    );
                    let resultado1 = atualizarNovoValor(
                      tipoEmail,
                      valor446,
                      periodoUsuarioId1Fracao
                    );
                    if (await resultado1) {
                      let resultado2 = atualizarConfirmo(
                        tipoEmail,
                        "rejeitado",
                        periodoUsuarioId2Fracao,
                        1
                      );

                      if (await resultado2) {
                        let resultToken = desativarToken();
                        if (await resultToken) {
                          document.location.href = "/sucessoprocedimento";
                        } else {
                          document.location.href = "/algodeuerrado";
                        }
                      }
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }
                  break;
                case 7:
                  //rejeito e não pertube
                  openNotificationWithIcon(
                    "error",
                    "SelecionarNaoPertubeNoPrincipal"
                  );

                  break;
                case 8:
                  //já reservei
                  openNotificationWithIcon(
                    "error",
                    "SelecionarReservadoUtilizadoEmParte"
                  );
                  break;
                case 9:
                  //já utilizei
                  openNotificationWithIcon(
                    "error",
                    "SelecionarReservadoUtilizadoEmParte"
                  );
                  break;
              }
              break;
            case 5:
              //fracione
              let resultado = atualizarNovoValor(
                tipoEmail,
                inputNovoValorPeriodoPrincipal,
                periodoUsuarioIdPrincipal
              );
              if (await resultado) {
                let result35 = naoFracione(
                  periodoUsuarioIdPrincipal,
                  periodoUsuarioData.divulgado,
                  periodoUsuarioDataPrimeiroPeriodo.divulgado,
                  periodoUsuarioDataSegundoPeriodo.divulgado,
                  true
                );

                switch (await result35) {
                  case 1:
                    let resultToken = desativarToken();

                    if (await resultToken) {
                      document.location.href = "/sucessoprocedimento";
                    } else {
                      document.location.href = "/algodeuerrado";
                    }
                    break;
                  case 2:
                  case 3:
                  case 4:
                    openNotificationWithIcon("error", "ErrosGerais");
                    break;
                }
              }

              break;
            case 6:
              //rejeito
              switch (valueRadio2Fracao) {
                case 2:
                  //confirmo e delego
                  openNotificationWithIcon(
                    "error",
                    "SelecionarDelegadoNoPrincipal"
                  );
                  break;
                case 3:
                  //confirmo
                  let valor = tratamentoValoresInput(
                    inputNovoValorPeriodoPrincipal
                  );
                  let resultado463 = atualizarNovoValor(
                    tipoEmail,
                    valor,
                    periodoUsuarioIdPrincipal
                  );
                  if (await resultado463) {
                    let resultado1 = atualizarConfirmo(
                      tipoEmail,
                      "rejeitado",
                      periodoUsuarioId1Fracao,
                      1
                    );
                    if (await resultado1) {
                      let resultado2 = atualizarConfirmo(
                        tipoEmail,
                        "confirmado",
                        periodoUsuarioId2Fracao,
                        1
                      );

                      if (await resultado2) {
                        let resultToken = desativarToken();
                        if (await resultToken) {
                          document.location.href = "/sucessoprocedimento";
                        } else {
                          document.location.href = "/algodeuerrado";
                        }
                      }
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }
                  break;
                case 4:
                  //novo valor
                  let valor464 = tratamentoValoresInput(
                    inputNovoValorPeriodoPrincipal
                  );
                  let resultado464 = atualizarNovoValor(
                    tipoEmail,
                    valor464,
                    periodoUsuarioIdPrincipal
                  );
                  if (await resultado464) {
                    let resultado1 = atualizarConfirmo(
                      tipoEmail,
                      "rejeitado",
                      periodoUsuarioId1Fracao,
                      1
                    );
                    if (await resultado1) {
                      let valor4641 = tratamentoValoresInput(
                        inputNovoValor2Fracao
                      );
                      let resultado2 = atualizarNovoValor(
                        tipoEmail,
                        valor4641,
                        periodoUsuarioId2Fracao
                      );
                      if (await resultado2) {
                        let resultToken = desativarToken();
                        if (await resultToken) {
                          document.location.href = "/sucessoprocedimento";
                        } else {
                          document.location.href = "/algodeuerrado";
                        }
                      }
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }
                  break;
                case 5:
                  //fracione
                  openNotificationWithIcon("error", "FracioneNaPrimeiraFracao");
                  break;
                case 6:
                  //rejeito
                  let valor466 = tratamentoValoresInput(
                    inputNovoValorPeriodoPrincipal
                  );
                  let resultado466 = atualizarNovoValor(
                    tipoEmail,
                    valor466,
                    periodoUsuarioIdPrincipal
                  );
                  if (await resultado466) {
                    let resultado1 = atualizarConfirmo(
                      tipoEmail,
                      "rejeitado",
                      periodoUsuarioId1Fracao,
                      1
                    );
                    if (await resultado1) {
                      let resultado2 = atualizarConfirmo(
                        tipoEmail,
                        "rejeitado",
                        periodoUsuarioId2Fracao,
                        1
                      );

                      if (await resultado2) {
                        let resultToken = desativarToken();
                        if (await resultToken) {
                          document.location.href = "/sucessoprocedimento";
                        } else {
                          document.location.href = "/algodeuerrado";
                        }
                      }
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }
                  break;
                case 7:
                  //rejeito e não pertube
                  openNotificationWithIcon(
                    "error",
                    "SelecionarNaoPertubeNoPrincipal"
                  );
                  break;
                case 8:
                  //já reservei
                  openNotificationWithIcon(
                    "error",
                    "SelecionarReservadoUtilizadoEmParte"
                  );
                  break;
                case 9:
                  //já utilizei
                  openNotificationWithIcon(
                    "error",
                    "SelecionarReservadoUtilizadoEmParte"
                  );
                  break;
              }
              break;
            case 7:
              //rejeito e não pertube
              openNotificationWithIcon(
                "error",
                "SelecionarNaoPertubeNoPrincipal"
              );
              break;
            case 8:
              //já reservei
              openNotificationWithIcon(
                "error",
                "SelecionarReservadoUtilizadoEmParte"
              );
              break;
            case 9:
              //já utilizei
              openNotificationWithIcon(
                "error",
                "SelecionarReservadoUtilizadoEmParte"
              );
              break;
          }
          break;
        case 5:
          //rejeito
          switch (valueRadio1Fracao) {
            case 2:
              //confirmo e delego
              openNotificationWithIcon(
                "error",
                "SelecionarDelegadoNoPrincipal"
              );

              break;
            case 3:
              //confirmo

              switch (valueRadio2Fracao) {
                case 2:
                  //confirmo e delego
                  openNotificationWithIcon(
                    "error",
                    "SelecionarDelegadoNoPrincipal"
                  );
                  break;
                case 3:
                  //confirmo
                  let resultado533 = atualizarConfirmo(
                    tipoEmail,
                    "rejeitado",
                    periodoUsuarioIdPrincipal,
                    1
                  );
                  if (await resultado533) {
                    let resultado1 = atualizarConfirmo(
                      tipoEmail,
                      "confirmado",
                      periodoUsuarioId1Fracao,
                      1
                    );
                    if (await resultado1) {
                      let resultado2 = atualizarConfirmo(
                        tipoEmail,
                        "confirmado",
                        periodoUsuarioId2Fracao,
                        1
                      );
                      if (await resultado2) {
                        let resultToken = desativarToken();
                        if (await resultToken) {
                          document.location.href = "/sucessoprocedimento";
                        } else {
                          document.location.href = "/algodeuerrado";
                        }
                      }
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }
                  break;
                case 4:
                  //novo valor

                  let resultado534 = atualizarConfirmo(
                    tipoEmail,
                    "rejeitado",
                    periodoUsuarioIdPrincipal,
                    1
                  );
                  if (await resultado534) {
                    let resultado1 = atualizarConfirmo(
                      tipoEmail,
                      "confirmado",
                      periodoUsuarioId1Fracao,
                      1
                    );
                    if (await resultado1) {
                      let valor534 = tratamentoValoresInput(
                        inputNovoValor2Fracao
                      );
                      let resultado2 = atualizarNovoValor(
                        tipoEmail,
                        valor534,
                        periodoUsuarioId2Fracao
                      );

                      if (await resultado2) {
                        let resultToken = desativarToken();
                        if (await resultToken) {
                          document.location.href = "/sucessoprocedimento";
                        } else {
                          document.location.href = "/algodeuerrado";
                        }
                      }
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }
                  break;
                case 5:
                  //fracione
                  openNotificationWithIcon("error", "FracioneNaPrimeiraFracao");
                  break;
                case 6:
                  //rejeito
                  let resultado336 = atualizarConfirmo(
                    tipoEmail,
                    "rejeitado",
                    periodoUsuarioIdPrincipal,
                    1
                  );
                  if (await resultado336) {
                    let resultado1 = atualizarConfirmo(
                      tipoEmail,
                      "confirmado",
                      periodoUsuarioId1Fracao,
                      1
                    );
                    if (await resultado1) {
                      let resultado2 = atualizarConfirmo(
                        tipoEmail,
                        "rejeitado",
                        periodoUsuarioId2Fracao,
                        1
                      );
                      if (await resultado2) {
                        let resultToken = desativarToken();
                        if (await resultToken) {
                          document.location.href = "/sucessoprocedimento";
                        } else {
                          document.location.href = "/algodeuerrado";
                        }
                      }
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }
                  break;
                case 7:
                  //rejeito e não pertube
                  openNotificationWithIcon(
                    "error",
                    "SelecionarNaoPertubeNoPrincipal"
                  );
                  break;
                case 8:
                  //já reservei
                  openNotificationWithIcon(
                    "error",
                    "SelecionarReservadoUtilizadoEmParte"
                  );
                  break;
                case 9:
                  //já utilizei
                  openNotificationWithIcon(
                    "error",
                    "SelecionarReservadoUtilizadoEmParte"
                  );
                  break;
              }
              break;
            case 4:
              //novo valor
              switch (valueRadio2Fracao) {
                case 2:
                  //confirmo e delego
                  openNotificationWithIcon(
                    "error",
                    "SelecionarDelegadoNoPrincipal"
                  );
                  break;
                case 3:
                  //confirmo
                  let resultado543 = atualizarConfirmo(
                    tipoEmail,
                    "rejeitado",
                    periodoUsuarioIdPrincipal,
                    1
                  );
                  if (await resultado543) {
                    let valor543 = tratamentoValoresInput(
                      inputNovoValor1Fracao
                    );
                    let resultado2 = atualizarNovoValor(
                      tipoEmail,
                      valor543,
                      periodoUsuarioId1Fracao
                    );

                    if (await resultado2) {
                      let resultado1 = atualizarConfirmo(
                        tipoEmail,
                        "confirmado",
                        periodoUsuarioId2Fracao,
                        1
                      );

                      if (await resultado1) {
                        let resultToken = desativarToken();
                        if (await resultToken) {
                          document.location.href = "/sucessoprocedimento";
                        } else {
                          document.location.href = "/algodeuerrado";
                        }
                      }
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }
                  break;
                case 4:
                  //novo valor
                  let resultado544 = atualizarConfirmo(
                    tipoEmail,
                    "rejeitado",
                    periodoUsuarioIdPrincipal,
                    1
                  );
                  if (await resultado544) {
                    let valor544 = tratamentoValoresInput(
                      inputNovoValor1Fracao
                    );
                    let resultado2 = atualizarNovoValor(
                      tipoEmail,
                      valor544,
                      periodoUsuarioId1Fracao
                    );

                    if (await resultado2) {
                      let valor5441 = tratamentoValoresInput(
                        inputNovoValor2Fracao
                      );
                      let resultado2 = atualizarNovoValor(
                        tipoEmail,
                        valor5441,
                        periodoUsuarioId2Fracao
                      );

                      if (await resultado2) {
                        let resultToken = desativarToken();
                        if (await resultToken) {
                          document.location.href = "/sucessoprocedimento";
                        } else {
                          document.location.href = "/algodeuerrado";
                        }
                      }
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }
                  break;
                case 5:
                  //fracione
                  openNotificationWithIcon("error", "FracioneNaPrimeiraFracao");
                  break;
                case 6:
                  //rejeito
                  let resultado546 = atualizarConfirmo(
                    tipoEmail,
                    "rejeitado",
                    periodoUsuarioIdPrincipal,
                    1
                  );
                  if (await resultado546) {
                    let valor546 = tratamentoValoresInput(
                      inputNovoValor1Fracao
                    );
                    let resultado2 = atualizarNovoValor(
                      tipoEmail,
                      valor546,
                      periodoUsuarioId1Fracao
                    );

                    if (await resultado2) {
                      let resultado1 = atualizarConfirmo(
                        tipoEmail,
                        "rejeitado",
                        periodoUsuarioId2Fracao,
                        1
                      );

                      if (await resultado1) {
                        let resultToken = desativarToken();
                        if (await resultToken) {
                          document.location.href = "/sucessoprocedimento";
                        } else {
                          document.location.href = "/algodeuerrado";
                        }
                      }
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }
                  break;
                case 7:
                  //rejeito e não pertube
                  openNotificationWithIcon(
                    "error",
                    "SelecionarNaoPertubeNoPrincipal"
                  );
                  break;
                case 8:
                  //já reservei
                  openNotificationWithIcon(
                    "error",
                    "SelecionarReservadoUtilizadoEmParte"
                  );
                  break;
                case 9:
                  //já utilizei
                  openNotificationWithIcon(
                    "error",
                    "SelecionarReservadoUtilizadoEmParte"
                  );
                  break;
              }
              break;
            case 5:
              //fracione
              let resultado = atualizarConfirmo(
                tipoEmail,
                "rejeitado",
                periodoUsuarioIdPrincipal,
                0
              );
              if (await resultado) {
                let result35 = naoFracione(
                  periodoUsuarioIdPrincipal,
                  periodoUsuarioData.divulgado,
                  periodoUsuarioDataPrimeiroPeriodo.divulgado,
                  periodoUsuarioDataSegundoPeriodo.divulgado,
                  false
                );

                switch (await result35) {
                  case 1:
                    let resultToken = desativarToken();
                    if (
                      periodoUsuarioData.divulgado === 1 ||
                      periodoUsuarioDataPrimeiroPeriodo.divulgado === 1 ||
                      periodoUsuarioDataSegundoPeriodo.divulgado === 1
                    ) {
                      if (await resultToken) {
                        document.location.href = "/sucessoprocedimento";
                      } else {
                        document.location.href = "/algodeuerrado";
                      }
                    } else {
                      if (await resultToken) {
                        let formDataEmail = {
                          tipoEmail: 15,
                          valorPrincipal: 5,
                          valor1Fracao: 5,
                          valor2Fracao: 0,
                          periodoUsuarioId: periodoUsuarioIdPrincipal,
                          valorSugeridoPrincipal:
                            periodoUsuarioData.valorSugerido,
                        };
                        console.log(formDataEmail);
                        let resultEmail = enviarEmail(formDataEmail);
                        if (await resultEmail) {
                          document.location.href = "/sucessoprocedimento";
                        } else {
                          document.location.href = "/algodeuerrado";
                        }
                      } else {
                        document.location.href = "/algodeuerrado";
                      }
                    }

                    break;
                  case 2:
                  case 3:
                  case 4:
                    openNotificationWithIcon("error", "ErrosGerais");
                    break;
                }
              }
              break;
            case 6:
              //rejeito
              switch (valueRadio2Fracao) {
                case 2:
                  //confirmo e delego
                  openNotificationWithIcon(
                    "error",
                    "SelecionarDelegadoNoPrincipal"
                  );
                  break;
                case 3:
                  //confirmo
                  let resultado563 = atualizarConfirmo(
                    tipoEmail,
                    "rejeitado",
                    periodoUsuarioIdPrincipal,
                    1
                  );
                  if (await resultado563) {
                    let resultado1 = atualizarConfirmo(
                      tipoEmail,
                      "rejeitado",
                      periodoUsuarioId1Fracao,
                      1
                    );
                    if (await resultado1) {
                      let resultado2 = atualizarConfirmo(
                        tipoEmail,
                        "confirmado",
                        periodoUsuarioId2Fracao,
                        1
                      );
                      if (await resultado2) {
                        let resultToken = desativarToken();
                        if (await resultToken) {
                          document.location.href = "/sucessoprocedimento";
                        } else {
                          document.location.href = "/algodeuerrado";
                        }
                      }
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }
                  break;
                case 4:
                  //novo valor
                  let resultado564 = atualizarConfirmo(
                    tipoEmail,
                    "rejeitado",
                    periodoUsuarioIdPrincipal,
                    1
                  );
                  if (await resultado564) {
                    let resultado1 = atualizarConfirmo(
                      tipoEmail,
                      "rejeitado",
                      periodoUsuarioId1Fracao,
                      1
                    );

                    if (await resultado1) {
                      let valor564 = tratamentoValoresInput(
                        inputNovoValor2Fracao
                      );
                      let resultado2 = atualizarNovoValor(
                        tipoEmail,
                        valor564,
                        periodoUsuarioId2Fracao
                      );

                      if (await resultado2) {
                        let resultToken = desativarToken();
                        if (await resultToken) {
                          document.location.href = "/sucessoprocedimento";
                        } else {
                          document.location.href = "/algodeuerrado";
                        }
                      }
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }
                  break;
                case 5:
                  //fracione
                  openNotificationWithIcon("error", "FracioneNaPrimeiraFracao");
                  break;
                case 6:
                  //rejeito
                  let resultado566 = atualizarConfirmo(
                    tipoEmail,
                    "rejeitado",
                    periodoUsuarioIdPrincipal,
                    2
                  );
                  if (await resultado566) {
                    let resultado1 = atualizarConfirmo(
                      tipoEmail,
                      "rejeitado",
                      periodoUsuarioId1Fracao,
                      2
                    );
                    if (await resultado1) {
                      let resultado2 = atualizarConfirmo(
                        tipoEmail,
                        "rejeitado",
                        periodoUsuarioId2Fracao,
                        2
                      );
                      if (await resultado2) {
                        let resultToken = desativarToken();
                        if (await resultToken) {
                          let formDataEmail = {
                            tipoEmail: 15,
                            valorPrincipal: valorPrincipal,
                            valor1Fracao: valor1Fracao,
                            valor2Fracao: valor2Fracao,
                            periodoUsuarioId: periodoUsuarioIdPrincipal,
                            periodoUsuarioId1Fracao: periodoUsuarioId1Fracao,
                            periodoUsuarioId2Fracao: periodoUsuarioId2Fracao,
                            valorSugeridoPrincipal:
                              periodoUsuarioData.valorSugerido,
                            valorSugerido1Fracao:
                              periodoUsuarioDataPrimeiroPeriodo.valorSugerido,
                            valorSugerido2Fracao:
                              periodoUsuarioDataSegundoPeriodo.valorSugerido,
                          };
                          let resultEmail = enviarEmail(formDataEmail);
                          if (await resultEmail) {
                            document.location.href = "/sucessoprocedimento";
                          } else {
                            document.location.href = "/algodeuerrado";
                          }
                        }
                      }
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }
                  break;
                case 7:
                  //rejeito e não pertube
                  openNotificationWithIcon(
                    "error",
                    "SelecionarNaoPertubeNoPrincipal"
                  );
                  break;
                case 8:
                  //já reservei
                  openNotificationWithIcon(
                    "error",
                    "SelecionarReservadoUtilizadoEmParte"
                  );
                  break;
                case 9:
                  //já utilizei
                  openNotificationWithIcon(
                    "error",
                    "SelecionarReservadoUtilizadoEmParte"
                  );
                  break;
              }
              break;
            case 7:
              //rejeito e não pertube
              openNotificationWithIcon(
                "error",
                "SelecionarNaoPertubeNoPrincipal"
              );

              break;
            case 8:
              //já reservei
              openNotificationWithIcon(
                "error",
                "SelecionarReservadoUtilizadoEmParte"
              );

              break;
            case 9:
              //já utilizei
              openNotificationWithIcon(
                "error",
                "SelecionarReservadoUtilizadoEmParte"
              );

              break;
          }
          break;
        case 6:
          //rejeito e não pertube
          switch (valueRadio1Fracao) {
            case 2:
              //confirmo e delego
              openNotificationWithIcon(
                "error",
                "SelecionarDelegadoNoPrincipal"
              );

              break;
            case 3:
              //confirmo
              openNotificationWithIcon("error", "PrincipalNaoPertube");

              break;
            case 4:
              //novo valor
              openNotificationWithIcon("error", "PrincipalNaoPertube");
              break;
            case 5:
              //fracione
              let resultado = atualizarConfirmo(
                tipoEmail,
                "naoPertube",
                periodoUsuarioIdPrincipal,
                0
              );
              if (await resultado) {
                let result35 = naoFracione(
                  periodoUsuarioIdPrincipal,
                  periodoUsuarioData.divulgado,
                  periodoUsuarioDataPrimeiroPeriodo.divulgado,
                  periodoUsuarioDataSegundoPeriodo.divulgado,
                  false
                );

                switch (await result35) {
                  case 1:
                    let resultToken = desativarToken();
                    if (
                      periodoUsuarioData.divulgado === 1 ||
                      periodoUsuarioDataPrimeiroPeriodo.divulgado === 1 ||
                      periodoUsuarioDataSegundoPeriodo.divulgado === 1
                    ) {
                      if (await resultToken) {
                        document.location.href = "/sucessoprocedimento";
                      } else {
                        document.location.href = "/algodeuerrado";
                      }
                    } else {
                      let formDataEmail = {
                        tipoEmail: 15,
                        valorPrincipal: valorPrincipal,
                        valor1Fracao: valor1Fracao,
                        valor2Fracao: valor2Fracao,
                        periodoUsuarioId: periodoUsuarioIdPrincipal,
                        valorSugeridoPrincipal:
                          periodoUsuarioData.valorSugerido,
                      };
                      let resultEmail = enviarEmail(formDataEmail);
                      if (await resultEmail) {
                        document.location.href = "/sucessoprocedimento";
                      } else {
                        document.location.href = "/algodeuerrado";
                      }
                    }

                    break;
                  case 2:
                  case 3:
                  case 4:
                    openNotificationWithIcon("error", "ErrosGerais");
                    break;
                }
              }

              break;
            case 6:
              //rejeito
              openNotificationWithIcon("error", "PrincipalNaoPertube");
              break;
            case 7:
              //rejeito e não pertube
              switch (valueRadio2Fracao) {
                case 2:
                  //confirmo e delego
                  break;
                case 3:
                  //confirmo
                  break;
                case 4:
                  //novo valor
                  break;
                case 5:
                  //fracione
                  break;
                case 6:
                  //rejeito
                  break;
                case 7:
                  //rejeito e não pertube
                  let resultado = atualizarConfirmo(
                    tipoEmail,
                    "naoPertube",
                    periodoUsuarioIdPrincipal,
                    2
                  );
                  if (await resultado) {
                    let resultado1 = atualizarConfirmo(
                      tipoEmail,
                      "naoPertube",
                      periodoUsuarioId1Fracao,
                      2
                    );
                    if (await resultado1) {
                      let resultado2 = atualizarConfirmo(
                        tipoEmail,
                        "naoPertube",
                        periodoUsuarioId2Fracao,
                        2
                      );
                      if (await resultado2) {
                        let resultToken = desativarToken();
                        if (resultToken) {
                          let formDataEmail = {
                            tipoEmail: 15,
                            valorPrincipal: valorPrincipal,
                            valor1Fracao: valor1Fracao,
                            valor2Fracao: valor2Fracao,
                            periodoUsuarioId: periodoUsuarioIdPrincipal,
                            periodoUsuarioId1Fracao: periodoUsuarioId1Fracao,
                            periodoUsuarioId2Fracao: periodoUsuarioId2Fracao,
                            valorSugeridoPrincipal:
                              periodoUsuarioData.valorSugerido,
                            valorSugerido1Fracao:
                              periodoUsuarioDataPrimeiroPeriodo.valorSugerido,
                            valorSugerido2Fracao:
                              periodoUsuarioDataSegundoPeriodo.valorSugerido,
                          };
                          let resultEmail = enviarEmail(formDataEmail);

                          if (await resultEmail) {
                            document.location.href = "/sucessoprocedimento";
                          } else {
                            document.location.href = "/algodeuerrado";
                          }
                        } else {
                          openNotificationWithIcon("error", "ErrosGerais");
                        }
                      }
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }
                  break;
                case 8:
                  //já reservei
                  break;
                case 9:
                  //já utilizei
                  break;
              }
              break;
            case 8:
              //já reservei
              openNotificationWithIcon(
                "error",
                "SelecionarReservadoUtilizadoEmParte"
              );
              break;
            case 9:
              //já utilizei
              openNotificationWithIcon(
                "error",
                "SelecionarReservadoUtilizadoEmParte"
              );
              break;
          }
          break;
        case 7:
          //já utilizei ou reservei parte
          switch (valueRadio1Fracao) {
            case 2:
              //confirmo e delego
              switch (valueRadio2Fracao) {
                case 2:
                  //confirmo e delego
                  openNotificationWithIcon(
                    "error",
                    "UmPeriodoAoMenosReservadoOuUtilizado"
                  );
                  break;
                case 3:
                  //confirmo
                  openNotificationWithIcon(
                    "error",
                    "UmPeriodoAoMenosReservadoOuUtilizado"
                  );
                  break;
                case 4:
                  //novo valor
                  openNotificationWithIcon(
                    "error",
                    "UmPeriodoAoMenosReservadoOuUtilizado"
                  );
                  break;
                case 5:
                  //fracione
                  openNotificationWithIcon(
                    "error",
                    "UmPeriodoAoMenosReservadoOuUtilizado"
                  );
                  break;
                case 6:
                  //rejeito
                  openNotificationWithIcon(
                    "error",
                    "UmPeriodoAoMenosReservadoOuUtilizado"
                  );
                  break;
                case 7:
                  //rejeito e não pertube
                  openNotificationWithIcon(
                    "error",
                    "UmPeriodoAoMenosReservadoOuUtilizado"
                  );
                  break;
                case 8:
                  //já reservei
                  let resultado728 = atualizarSituacao(
                    1,
                    periodoUsuarioIdPrincipal,
                    true
                  );
                  if (await resultado728) {
                    let resultado1 = atualizarConfirmo(
                      tipoEmail,
                      "delegado",
                      periodoUsuarioId1Fracao,
                      1
                    );
                    if (await resultado1) {
                      let resultado2 = atualizarSituacao(
                        3,
                        periodoUsuarioId2Fracao,
                        true
                      );
                      if (await resultado2) {
                        let resultToken = desativarToken();

                        if (await resultToken) {
                          document.location.href = "/sucessoprocedimento";
                        } else {
                          document.location.href = "/algodeuerrado";
                        }
                      }
                    }
                  }
                  break;
                case 9:
                  //já utilizei
                  let resultado729 = atualizarSituacao(
                    1,
                    periodoUsuarioIdPrincipal,
                    true
                  );
                  if (await resultado729) {
                    let resultado1 = atualizarConfirmo(
                      tipoEmail,
                      "delegado",
                      periodoUsuarioId1Fracao,
                      1
                    );
                    if (await resultado1) {
                      let resultado2 = atualizarSituacao(
                        2,
                        periodoUsuarioId2Fracao,
                        true
                      );
                      if (await resultado2) {
                        let resultToken = desativarToken();

                        if (await resultToken) {
                          document.location.href = "/sucessoprocedimento";
                        } else {
                          document.location.href = "/algodeuerrado";
                        }
                      }
                    }
                  }
                  break;
              }
              break;
            case 3:
              //confirmo
              switch (valueRadio2Fracao) {
                case 2:
                  //confirmo e delego
                  openNotificationWithIcon(
                    "error",
                    "UmPeriodoAoMenosReservadoOuUtilizado"
                  );
                  break;
                case 3:
                  //confirmo
                  openNotificationWithIcon(
                    "error",
                    "UmPeriodoAoMenosReservadoOuUtilizado"
                  );
                  break;
                case 4:
                  //novo valor
                  openNotificationWithIcon(
                    "error",
                    "UmPeriodoAoMenosReservadoOuUtilizado"
                  );
                  break;
                case 5:
                  //fracione
                  openNotificationWithIcon(
                    "error",
                    "UmPeriodoAoMenosReservadoOuUtilizado"
                  );
                  break;
                case 6:
                  //rejeito
                  openNotificationWithIcon(
                    "error",
                    "UmPeriodoAoMenosReservadoOuUtilizado"
                  );
                  break;
                case 7:
                  //rejeito e não pertube
                  openNotificationWithIcon(
                    "error",
                    "UmPeriodoAoMenosReservadoOuUtilizado"
                  );
                  break;
                case 8:
                  //já reservei
                  let resultado728 = atualizarSituacao(
                    1,
                    periodoUsuarioIdPrincipal,
                    true
                  );
                  if (await resultado728) {
                    let resultado1 = atualizarConfirmo(
                      tipoEmail,
                      "confirmado",
                      periodoUsuarioId1Fracao,
                      1
                    );
                    if (await resultado1) {
                      let resultado2 = atualizarSituacao(
                        3,
                        periodoUsuarioId2Fracao,
                        true
                      );
                      if (await resultado2) {
                        let resultToken = desativarToken();

                        if (await resultToken) {
                          document.location.href = "/sucessoprocedimento";
                        } else {
                          document.location.href = "/algodeuerrado";
                        }
                      }
                    }
                  }
                  break;
                case 9:
                  //já utilizei ou reservei parte - confirmo - utilizar
                  let resultado739 = atualizarSituacao(
                    1,
                    periodoUsuarioIdPrincipal,
                    true
                  );
                  if (await resultado739) {
                    let resultado1 = atualizarConfirmo(
                      tipoEmail,
                      "confirmado",
                      periodoUsuarioId1Fracao,
                      1
                    );
                    if (await resultado1) {
                      let resultado2 = atualizarSituacao(
                        2,
                        periodoUsuarioId2Fracao,
                        true
                      );
                      if (await resultado2) {
                        let resultToken = desativarToken();

                        if (await resultToken) {
                          document.location.href = "/sucessoprocedimento";
                        } else {
                          document.location.href = "/algodeuerrado";
                        }
                      }
                    }
                  }
                  break;
              }
              break;
            case 4:
              //novo valor
              switch (valueRadio2Fracao) {
                case 2:
                  //confirmo e delego
                  openNotificationWithIcon(
                    "error",
                    "UmPeriodoAoMenosReservadoOuUtilizado"
                  );
                  break;
                case 3:
                  //confirmo
                  openNotificationWithIcon(
                    "error",
                    "UmPeriodoAoMenosReservadoOuUtilizado"
                  );
                  break;
                case 4:
                  //novo valor
                  openNotificationWithIcon(
                    "error",
                    "UmPeriodoAoMenosReservadoOuUtilizado"
                  );
                  break;
                case 5:
                  //fracione
                  openNotificationWithIcon(
                    "error",
                    "UmPeriodoAoMenosReservadoOuUtilizado"
                  );
                  break;
                case 6:
                  //rejeito
                  openNotificationWithIcon(
                    "error",
                    "UmPeriodoAoMenosReservadoOuUtilizado"
                  );
                  break;
                case 7:
                  //rejeito e não pertube
                  openNotificationWithIcon(
                    "error",
                    "UmPeriodoAoMenosReservadoOuUtilizado"
                  );
                  break;
                case 8:
                  //já reservei
                  let resultado748 = atualizarSituacao(
                    1,
                    periodoUsuarioIdPrincipal,
                    true
                  );
                  if (await resultado748) {
                    let resultado1 = atualizarNovoValor(
                      tipoEmail,
                      inputNovoValor1Fracao,
                      periodoUsuarioId1Fracao
                    );
                    if (await resultado1) {
                      let resultado2 = atualizarSituacao(
                        3,
                        periodoUsuarioId2Fracao,
                        true
                      );
                      if (await resultado2) {
                        let resultToken = desativarToken();

                        if (await resultToken) {
                          document.location.href = "/sucessoprocedimento";
                        } else {
                          document.location.href = "/algodeuerrado";
                        }
                      }
                    }
                  }
                  break;
                case 9:
                  //já utilizei
                  let resultado749 = atualizarSituacao(
                    1,
                    periodoUsuarioIdPrincipal,
                    true
                  );
                  if (await resultado749) {
                    let resultado2 = atualizarNovoValor(
                      tipoEmail,
                      inputNovoValor1Fracao,
                      periodoUsuarioId1Fracao
                    );
                    if (await resultado2) {
                      let resultado1 = atualizarSituacao(
                        2,
                        periodoUsuarioId2Fracao,
                        true
                      );
                      if (await resultado1) {
                        let resultToken = desativarToken();

                        if (await resultToken) {
                          document.location.href = "/sucessoprocedimento";
                        } else {
                          document.location.href = "/algodeuerrado";
                        }
                      } else {
                        openNotificationWithIcon("error", "ErrosGerais");
                      }
                    } else {
                      openNotificationWithIcon("error", "ErrosGerais");
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }
                  break;
              }
              break;
            case 5:
              //fracione
              openNotificationWithIcon("warning", "DeveFracionar");

              break;
            case 6:
              //rejeito
              switch (valueRadio2Fracao) {
                case 2:
                  //confirmo e delego
                  openNotificationWithIcon(
                    "error",
                    "UmPeriodoAoMenosReservadoOuUtilizado"
                  );
                  break;
                case 3:
                  //confirmo
                  openNotificationWithIcon(
                    "error",
                    "UmPeriodoAoMenosReservadoOuUtilizado"
                  );
                  break;
                case 4:
                  //novo valor
                  openNotificationWithIcon(
                    "error",
                    "UmPeriodoAoMenosReservadoOuUtilizado"
                  );
                  break;
                case 5:
                  //fracione
                  openNotificationWithIcon(
                    "error",
                    "UmPeriodoAoMenosReservadoOuUtilizado"
                  );
                  break;
                case 6:
                  //rejeito
                  openNotificationWithIcon(
                    "error",
                    "UmPeriodoAoMenosReservadoOuUtilizado"
                  );
                  break;
                case 7:
                  //rejeito e não pertube
                  openNotificationWithIcon(
                    "error",
                    "UmPeriodoAoMenosReservadoOuUtilizado"
                  );
                  break;
                case 8:
                  //já reservei
                  let resultado768 = atualizarSituacao(
                    1,
                    periodoUsuarioIdPrincipal,
                    false
                  );
                  if (await resultado768) {
                    let resultado1 = atualizarConfirmo(
                      tipoEmail,
                      "rejeitado",
                      periodoUsuarioId1Fracao,
                      0
                    );
                    if (await resultado1) {
                      let resultado2 = atualizarSituacao(
                        3,
                        periodoUsuarioId2Fracao,
                        false
                      );
                      if (await resultado2) {
                        let resultToken = desativarToken();
                        if (resultToken) {
                          if (
                            periodoUsuarioData.divulgado === 1 ||
                            periodoUsuarioDataPrimeiroPeriodo.divulgado === 1 ||
                            periodoUsuarioDataSegundoPeriodo.divulgado === 1
                          ) {
                            document.location.href = "/sucessoprocedimento";
                          } else {
                            let formDataEmail = {
                              tipoEmail: 15,
                              valorPrincipal: valorPrincipal,
                              valor1Fracao: valor1Fracao,
                              valor2Fracao: valor2Fracao,
                              periodoUsuarioId: periodoUsuarioIdPrincipal,
                              periodoUsuarioId1Fracao: periodoUsuarioId1Fracao,
                              periodoUsuarioId2Fracao: periodoUsuarioId2Fracao,
                              valorSugeridoPrincipal:
                                periodoUsuarioData.valorSugerido,
                              valorSugerido1Fracao:
                                periodoUsuarioDataPrimeiroPeriodo.valorSugerido,
                              valorSugerido2Fracao:
                                periodoUsuarioDataSegundoPeriodo.valorSugerido,
                            };
                            let resultEmail = enviarEmail(formDataEmail);
                            if (await resultEmail) {
                              document.location.href = "/sucessoprocedimento";
                            } else {
                              document.location.href = "/algodeuerrado";
                            }
                          }
                        } else {
                          openNotificationWithIcon("error", "ErrosGerais");
                        }
                      }
                    }
                  }
                  break;
                case 9:
                  //já utilizei
                  let resultado769 = atualizarSituacao(
                    1,
                    periodoUsuarioIdPrincipal,
                    false
                  );
                  if (await resultado769) {
                    let resultado2 = atualizarConfirmo(
                      tipoEmail,
                      "rejeitado",
                      periodoUsuarioId1Fracao,
                      0
                    );
                    if (await resultado2) {
                      let resultado1 = atualizarSituacao(
                        2,

                        periodoUsuarioId2Fracao,
                        false
                      );
                      if (await resultado1) {
                        let resultToken = desativarToken();

                        if (
                          periodoUsuarioData.divulgado === 1 ||
                          periodoUsuarioDataPrimeiroPeriodo.divulgado === 1 ||
                          periodoUsuarioDataSegundoPeriodo.divulgado === 1
                        ) {
                          if (await resultToken) {
                            document.location.href = "/sucessoprocedimento";
                          } else {
                            document.location.href = "/algodeuerrado";
                          }
                        } else {
                          let formDataEmail = {
                            tipoEmail: 15,
                            valorPrincipal: valorPrincipal,
                            valor1Fracao: valor1Fracao,
                            valor2Fracao: valor2Fracao,
                            periodoUsuarioId: periodoUsuarioIdPrincipal,
                            periodoUsuarioId1Fracao: periodoUsuarioId1Fracao,
                            periodoUsuarioId2Fracao: periodoUsuarioId2Fracao,
                            valorSugeridoPrincipal:
                              periodoUsuarioData.valorSugerido,
                            valorSugerido1Fracao:
                              periodoUsuarioDataPrimeiroPeriodo.valorSugerido,
                            valorSugerido2Fracao:
                              periodoUsuarioDataSegundoPeriodo.valorSugerido,
                          };
                          let resultEmail = enviarEmail(formDataEmail);
                          if (await resultEmail) {
                            document.location.href = "/sucessoprocedimento";
                          } else {
                            document.location.href = "/algodeuerrado";
                          }
                        }
                      } else {
                        openNotificationWithIcon("error", "ErrosGerais");
                      }
                    } else {
                      openNotificationWithIcon("error", "ErrosGerais");
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }
                  break;
              }
              break;
            case 7:
              //rejeito e não pertube
              switch (valueRadio2Fracao) {
                case 2:
                  //confirmo e delego
                  openNotificationWithIcon(
                    "error",
                    "UmPeriodoAoMenosReservadoOuUtilizado"
                  );
                  break;
                case 3:
                  //confirmo
                  openNotificationWithIcon(
                    "error",
                    "UmPeriodoAoMenosReservadoOuUtilizado"
                  );
                  break;
                case 4:
                  //novo valor
                  openNotificationWithIcon(
                    "error",
                    "UmPeriodoAoMenosReservadoOuUtilizado"
                  );
                  break;
                case 5:
                  //fracione
                  openNotificationWithIcon(
                    "error",
                    "UmPeriodoAoMenosReservadoOuUtilizado"
                  );
                  break;
                case 6:
                  //rejeito
                  openNotificationWithIcon(
                    "error",
                    "UmPeriodoAoMenosReservadoOuUtilizado"
                  );
                  break;
                case 7:
                  //rejeito e não pertube
                  openNotificationWithIcon(
                    "error",
                    "UmPeriodoAoMenosReservadoOuUtilizado"
                  );
                  break;
                case 8:
                  //já reservei
                  let resultado778 = atualizarSituacao(
                    1,
                    periodoUsuarioIdPrincipal,
                    false
                  );
                  if (await resultado778) {
                    let resultado1 = atualizarConfirmo(
                      tipoEmail,
                      "naoPertube",
                      periodoUsuarioId1Fracao,
                      0
                    );
                    if (await resultado1) {
                      let resultado2 = atualizarSituacao(
                        3,
                        periodoUsuarioId2Fracao,
                        false
                      );
                      if (await resultado2) {
                        let resultToken = desativarToken();
                        if (resultToken) {
                          if (
                            periodoUsuarioData.divulgado === 1 ||
                            periodoUsuarioDataPrimeiroPeriodo.divulgado === 1 ||
                            periodoUsuarioDataSegundoPeriodo.divulgado === 1
                          ) {
                            document.location.href = "/sucessoprocedimento";
                          } else {
                            let formDataEmail = {
                              tipoEmail: 15,
                              valorPrincipal: valorPrincipal,
                              valor1Fracao: valor1Fracao,
                              valor2Fracao: valor2Fracao,
                              periodoUsuarioId: periodoUsuarioIdPrincipal,
                              periodoUsuarioId1Fracao: periodoUsuarioId1Fracao,
                              periodoUsuarioId2Fracao: periodoUsuarioId2Fracao,
                              valorSugeridoPrincipal:
                                periodoUsuarioData.valorSugerido,
                              valorSugerido1Fracao:
                                periodoUsuarioDataPrimeiroPeriodo.valorSugerido,
                              valorSugerido2Fracao:
                                periodoUsuarioDataSegundoPeriodo.valorSugerido,
                            };
                            let resultEmail = enviarEmail(formDataEmail);
                            if (await resultEmail) {
                              document.location.href = "/sucessoprocedimento";
                            } else {
                              document.location.href = "/algodeuerrado";
                            }
                          }
                        } else {
                          openNotificationWithIcon("error", "ErrosGerais");
                        }
                      }
                    }
                  }
                  break;
                case 9:
                  //já utilizei
                  let resultado779 = atualizarSituacao(
                    1,
                    periodoUsuarioIdPrincipal,
                    false
                  );
                  if (await resultado779) {
                    let resultado2 = atualizarConfirmo(
                      tipoEmail,
                      "naoPertube",
                      periodoUsuarioId1Fracao,
                      0
                    );
                    if (await resultado2) {
                      let resultado1 = atualizarSituacao(
                        2,

                        periodoUsuarioId2Fracao,
                        false
                      );
                      if (await resultado1) {
                        let resultToken = desativarToken();

                        if (
                          periodoUsuarioData.divulgado === 1 ||
                          periodoUsuarioDataPrimeiroPeriodo.divulgado === 1 ||
                          periodoUsuarioDataSegundoPeriodo.divulgado === 1
                        ) {
                          if (await resultToken) {
                            document.location.href = "/sucessoprocedimento";
                          } else {
                            document.location.href = "/algodeuerrado";
                          }
                        } else {
                          let formDataEmail = {
                            tipoEmail: 15,
                            valorPrincipal: valorPrincipal,
                            valor1Fracao: valor1Fracao,
                            valor2Fracao: valor2Fracao,
                            periodoUsuarioId: periodoUsuarioIdPrincipal,
                            periodoUsuarioId1Fracao: periodoUsuarioId1Fracao,
                            periodoUsuarioId2Fracao: periodoUsuarioId2Fracao,
                            valorSugeridoPrincipal:
                              periodoUsuarioData.valorSugerido,
                            valorSugerido1Fracao:
                              periodoUsuarioDataPrimeiroPeriodo.valorSugerido,
                            valorSugerido2Fracao:
                              periodoUsuarioDataSegundoPeriodo.valorSugerido,
                          };
                          let resultEmail = enviarEmail(formDataEmail);
                          if (await resultEmail) {
                            document.location.href = "/sucessoprocedimento";
                          } else {
                            document.location.href = "/algodeuerrado";
                          }
                        }
                      } else {
                        openNotificationWithIcon("error", "ErrosGerais");
                      }
                    } else {
                      openNotificationWithIcon("error", "ErrosGerais");
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }
                  break;
              }
              break;
            case 8:
              //já reservei
              switch (valueRadio2Fracao) {
                case 2:
                  //confirmo e delego
                  let resultado782 = atualizarSituacao(
                    1,
                    periodoUsuarioIdPrincipal,
                    true
                  );
                  if (await resultado782) {
                    let resultado1 = atualizarSituacao(
                      3,
                      periodoUsuarioId1Fracao,
                      true
                    );

                    if (await resultado1) {
                      let resultado2 = atualizarConfirmo(
                        tipoEmail,
                        "delegado",
                        periodoUsuarioId2Fracao,
                        1
                      );
                      if (await resultado2) {
                        let resultToken = desativarToken();

                        if (await resultToken) {
                          document.location.href = "/sucessoprocedimento";
                        } else {
                          document.location.href = "/algodeuerrado";
                        }
                      }
                    }
                  }
                  break;
                case 3:
                  //confirmo
                  let resultado783 = atualizarSituacao(
                    1,
                    periodoUsuarioIdPrincipal,
                    true
                  );
                  if (await resultado783) {
                    let resultado1 = atualizarSituacao(
                      3,
                      periodoUsuarioId1Fracao,
                      true
                    );

                    if (await resultado1) {
                      let resultado2 = atualizarConfirmo(
                        tipoEmail,
                        "confirmado",
                        periodoUsuarioId2Fracao,
                        1
                      );
                      if (await resultado2) {
                        let resultToken = desativarToken();

                        if (await resultToken) {
                          document.location.href = "/sucessoprocedimento";
                        } else {
                          document.location.href = "/algodeuerrado";
                        }
                      }
                    }
                  }
                  break;
                case 4:
                  //novo valor
                  let resultado784 = atualizarSituacao(
                    1,
                    periodoUsuarioIdPrincipal,
                    true
                  );
                  if (await resultado784) {
                    let resultado1 = atualizarSituacao(
                      3,
                      periodoUsuarioId1Fracao,
                      true
                    );

                    if (await resultado1) {
                      let resultado2 = atualizarNovoValor(
                        tipoEmail,
                        inputNovoValor2Fracao,
                        periodoUsuarioId2Fracao
                      );

                      if (await resultado2) {
                        let resultToken = desativarToken();

                        if (await resultToken) {
                          document.location.href = "/sucessoprocedimento";
                        } else {
                          document.location.href = "/algodeuerrado";
                        }
                      }
                    }
                  }
                  break;
                case 5:
                  //fracione
                  openNotificationWithIcon("error", "DeveFracionar");
                  break;
                case 6:
                  //rejeito
                  let resultado786 = atualizarSituacao(
                    1,
                    periodoUsuarioIdPrincipal,
                    false
                  );
                  if (await resultado786) {
                    let resultado1 = atualizarSituacao(
                      3,
                      periodoUsuarioId1Fracao,
                      false
                    );

                    if (await resultado1) {
                      let resultado2 = atualizarConfirmo(
                        tipoEmail,
                        "rejeitado",
                        periodoUsuarioId2Fracao,
                        0
                      );

                      if (await resultado2) {
                        let resultToken = desativarToken();
                        if (resultToken) {
                          if (
                            periodoUsuarioData.divulgado === 1 ||
                            periodoUsuarioDataPrimeiroPeriodo.divulgado === 1 ||
                            periodoUsuarioDataSegundoPeriodo.divulgado === 1
                          ) {
                            document.location.href = "/sucessoprocedimento";
                          } else {
                            let formDataEmail = {
                              tipoEmail: 15,
                              valorPrincipal: valorPrincipal,
                              valor1Fracao: valor1Fracao,
                              valor2Fracao: valor2Fracao,
                              periodoUsuarioId: periodoUsuarioIdPrincipal,
                              periodoUsuarioId1Fracao: periodoUsuarioId1Fracao,
                              periodoUsuarioId2Fracao: periodoUsuarioId2Fracao,
                              valorSugeridoPrincipal:
                                periodoUsuarioData.valorSugerido,
                              valorSugerido1Fracao:
                                periodoUsuarioDataPrimeiroPeriodo.valorSugerido,
                              valorSugerido2Fracao:
                                periodoUsuarioDataSegundoPeriodo.valorSugerido,
                            };
                            let resultEmail = enviarEmail(formDataEmail);
                            if (await resultEmail) {
                              document.location.href = "/sucessoprocedimento";
                            } else {
                              document.location.href = "/algodeuerrado";
                            }
                          }
                        } else {
                          openNotificationWithIcon("error", "ErrosGerais");
                        }
                      }
                    }
                  }
                  break;
                case 7:
                  //rejeito e não pertube
                  let resultado787 = atualizarSituacao(
                    1,
                    periodoUsuarioIdPrincipal,
                    false
                  );
                  if (await resultado787) {
                    let resultado1 = atualizarSituacao(
                      3,
                      periodoUsuarioId1Fracao,
                      false
                    );

                    if (await resultado1) {
                      let resultado2 = atualizarConfirmo(
                        tipoEmail,
                        "naoPertube",
                        periodoUsuarioId2Fracao,
                        0
                      );

                      if (await resultado2) {
                        let resultToken = desativarToken();
                        if (resultToken) {
                          if (
                            periodoUsuarioData.divulgado === 1 ||
                            periodoUsuarioDataPrimeiroPeriodo.divulgado === 1 ||
                            periodoUsuarioDataSegundoPeriodo.divulgado === 1
                          ) {
                            document.location.href = "/sucessoprocedimento";
                          } else {
                            let formDataEmail = {
                              tipoEmail: 15,
                              valorPrincipal: valorPrincipal,
                              valor1Fracao: valor1Fracao,
                              valor2Fracao: valor2Fracao,
                              periodoUsuarioId: periodoUsuarioIdPrincipal,
                              periodoUsuarioId1Fracao: periodoUsuarioId1Fracao,
                              periodoUsuarioId2Fracao: periodoUsuarioId2Fracao,
                              valorSugeridoPrincipal:
                                periodoUsuarioData.valorSugerido,
                              valorSugerido1Fracao:
                                periodoUsuarioDataPrimeiroPeriodo.valorSugerido,
                              valorSugerido2Fracao:
                                periodoUsuarioDataSegundoPeriodo.valorSugerido,
                            };
                            let resultEmail = enviarEmail(formDataEmail);
                            if (await resultEmail) {
                              document.location.href = "/sucessoprocedimento";
                            } else {
                              document.location.href = "/algodeuerrado";
                            }
                          }
                        } else {
                          openNotificationWithIcon("error", "ErrosGerais");
                        }
                      }
                    }
                  }
                  break;
                case 8:
                  //já reservei
                  let resultado788 = atualizarSituacao(
                    1,
                    periodoUsuarioIdPrincipal,
                    false
                  );
                  if (await resultado788) {
                    let resultado2 = atualizarSituacao(
                      3,
                      periodoUsuarioId1Fracao,
                      false
                    );
                    if (await resultado2) {
                      let resultado1 = atualizarSituacao(
                        3,
                        periodoUsuarioId2Fracao,
                        false
                      );
                      if (await resultado1) {
                        let resultToken = desativarToken();
                        if (
                          periodoUsuarioData.divulgado === 1 ||
                          periodoUsuarioDataPrimeiroPeriodo.divulgado === 1 ||
                          periodoUsuarioDataSegundoPeriodo.divulgado === 1
                        ) {
                          if (await resultToken) {
                            document.location.href = "/sucessoprocedimento";
                          } else {
                            document.location.href = "/algodeuerrado";
                          }
                        } else {
                          let formDataEmail = {
                            tipoEmail: 15,
                            valorPrincipal: valorPrincipal,
                            valor1Fracao: valor1Fracao,
                            valor2Fracao: valor2Fracao,
                            periodoUsuarioId: periodoUsuarioIdPrincipal,
                            periodoUsuarioId1Fracao: periodoUsuarioId1Fracao,
                            periodoUsuarioId2Fracao: periodoUsuarioId2Fracao,
                          };
                          let resultEmail = enviarEmail(formDataEmail);
                          if (await resultEmail) {
                            document.location.href = "/sucessoprocedimento";
                          } else {
                            document.location.href = "/algodeuerrado";
                          }
                        }
                      } else {
                        openNotificationWithIcon("error", "ErrosGerais");
                      }
                    } else {
                      openNotificationWithIcon("error", "ErrosGerais");
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }
                  break;
                case 9:
                  //já utilizei
                  let resultado789 = atualizarSituacao(
                    1,
                    periodoUsuarioIdPrincipal,
                    false
                  );
                  if (await resultado789) {
                    let resultado2 = atualizarSituacao(
                      3,
                      periodoUsuarioId1Fracao,
                      false
                    );
                    if (await resultado2) {
                      let resultado1 = atualizarSituacao(
                        2,
                        periodoUsuarioId2Fracao,
                        false
                      );
                      if (await resultado1) {
                        let resultToken = desativarToken();
                        if (
                          periodoUsuarioData.divulgado === 1 ||
                          periodoUsuarioDataPrimeiroPeriodo.divulgado === 1 ||
                          periodoUsuarioDataSegundoPeriodo.divulgado === 1
                        ) {
                          if (await resultToken) {
                            document.location.href = "/sucessoprocedimento";
                          } else {
                            document.location.href = "/algodeuerrado";
                          }
                        } else {
                          let formDataEmail = {
                            tipoEmail: 15,
                            valorPrincipal: valorPrincipal,
                            valor1Fracao: valor1Fracao,
                            valor2Fracao: valor2Fracao,
                            periodoUsuarioId: periodoUsuarioIdPrincipal,
                            periodoUsuarioId1Fracao: periodoUsuarioId1Fracao,
                            periodoUsuarioId2Fracao: periodoUsuarioId2Fracao,
                          };
                          let resultEmail = enviarEmail(formDataEmail);
                          if (await resultEmail) {
                            document.location.href = "/sucessoprocedimento";
                          } else {
                            document.location.href = "/algodeuerrado";
                          }
                        }
                      } else {
                        openNotificationWithIcon("error", "ErrosGerais");
                      }
                    } else {
                      openNotificationWithIcon("error", "ErrosGerais");
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }
                  break;
              }
              break;
            case 9:
              //já utilizei
              switch (valueRadio2Fracao) {
                case 2:
                  //confirmo e delego
                  let resultado792 = atualizarSituacao(
                    1,
                    periodoUsuarioIdPrincipal,
                    true
                  );
                  if (await resultado792) {
                    let resultado1 = atualizarSituacao(
                      2,
                      periodoUsuarioId1Fracao,
                      true
                    );

                    if (await resultado1) {
                      let resultado2 = atualizarConfirmo(
                        tipoEmail,
                        "delegado",
                        periodoUsuarioId2Fracao,
                        1
                      );

                      if (await resultado2) {
                        let resultToken = desativarToken();

                        if (await resultToken) {
                          document.location.href = "/sucessoprocedimento";
                        } else {
                          document.location.href = "/algodeuerrado";
                        }
                      }
                    }
                  }
                  break;
                case 3:
                  //confirmo
                  let resultado793 = atualizarSituacao(
                    1,
                    periodoUsuarioIdPrincipal,
                    true
                  );
                  if (await resultado793) {
                    let resultado2 = atualizarSituacao(
                      2,
                      periodoUsuarioId1Fracao,
                      true
                    );
                    if (await resultado2) {
                      let resultado1 = atualizarConfirmo(
                        tipoEmail,
                        "confirmado",
                        periodoUsuarioId2Fracao,
                        1
                      );
                      if (await resultado1) {
                        let resultToken = desativarToken();
                        if (await resultToken) {
                          document.location.href = "/sucessoprocedimento";
                        } else {
                          document.location.href = "/algodeuerrado";
                        }
                      } else {
                        openNotificationWithIcon("error", "ErrosGerais");
                      }
                    } else {
                      openNotificationWithIcon("error", "ErrosGerais");
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }
                  break;
                case 4:
                  //novo valor
                  let resultado794 = atualizarSituacao(
                    1,
                    periodoUsuarioIdPrincipal,
                    true
                  );
                  if (await resultado794) {
                    let resultado2 = atualizarSituacao(
                      2,
                      periodoUsuarioId1Fracao,
                      true
                    );
                    if (await resultado2) {
                      let resultado1 = atualizarNovoValor(
                        tipoEmail,
                        inputNovoValor2Fracao,
                        periodoUsuarioId2Fracao
                      );
                      if (await resultado1) {
                        let resultToken = desativarToken();

                        if (await resultToken) {
                          document.location.href = "/sucessoprocedimento";
                        } else {
                          document.location.href = "/algodeuerrado";
                        }
                      } else {
                        openNotificationWithIcon("error", "ErrosGerais");
                      }
                    } else {
                      openNotificationWithIcon("error", "ErrosGerais");
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }
                  break;
                case 5:
                  //fracione
                  openNotificationWithIcon("warning", "DeveFracionar");
                  break;
                case 6:
                  //rejeito
                  let resultado796 = atualizarSituacao(
                    1,
                    periodoUsuarioIdPrincipal,
                    false
                  );
                  if (await resultado796) {
                    let resultado2 = atualizarSituacao(
                      2,

                      periodoUsuarioId1Fracao,
                      false
                    );

                    if (await resultado2) {
                      let resultado1 = atualizarConfirmo(
                        tipoEmail,
                        "rejeitado",
                        periodoUsuarioId2Fracao,
                        0
                      );

                      if (await resultado1) {
                        let resultToken = desativarToken();

                        if (
                          periodoUsuarioData.divulgado === 1 ||
                          periodoUsuarioDataPrimeiroPeriodo.divulgado === 1 ||
                          periodoUsuarioDataSegundoPeriodo.divulgado === 1
                        ) {
                          if (await resultToken) {
                            document.location.href = "/sucessoprocedimento";
                          } else {
                            document.location.href = "/algodeuerrado";
                          }
                        } else {
                          let formDataEmail = {
                            tipoEmail: 15,
                            valorPrincipal: valorPrincipal,
                            valor1Fracao: valor1Fracao,
                            valor2Fracao: valor2Fracao,
                            periodoUsuarioId: periodoUsuarioIdPrincipal,
                            periodoUsuarioId1Fracao: periodoUsuarioId1Fracao,
                            periodoUsuarioId2Fracao: periodoUsuarioId2Fracao,
                            valorSugeridoPrincipal:
                              periodoUsuarioData.valorSugerido,
                            valorSugerido1Fracao:
                              periodoUsuarioDataPrimeiroPeriodo.valorSugerido,
                            valorSugerido2Fracao:
                              periodoUsuarioDataSegundoPeriodo.valorSugerido,
                          };
                          let resultEmail = enviarEmail(formDataEmail);
                          if (await resultEmail) {
                            document.location.href = "/sucessoprocedimento";
                          } else {
                            document.location.href = "/algodeuerrado";
                          }
                        }
                      } else {
                        openNotificationWithIcon("error", "ErrosGerais");
                      }
                    } else {
                      openNotificationWithIcon("error", "ErrosGerais");
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }
                  break;
                case 7:
                  //rejeito e não pertube
                  let resultado797 = atualizarSituacao(
                    1,
                    periodoUsuarioIdPrincipal,
                    false
                  );
                  if (await resultado797) {
                    let resultado2 = atualizarSituacao(
                      2,

                      periodoUsuarioId1Fracao,
                      false
                    );

                    if (await resultado2) {
                      let resultado1 = atualizarConfirmo(
                        tipoEmail,
                        "naoPertube",
                        periodoUsuarioId2Fracao,
                        0
                      );

                      if (await resultado1) {
                        let resultToken = desativarToken();

                        if (
                          periodoUsuarioData.divulgado === 1 ||
                          periodoUsuarioDataPrimeiroPeriodo.divulgado === 1 ||
                          periodoUsuarioDataSegundoPeriodo.divulgado === 1
                        ) {
                          if (await resultToken) {
                            document.location.href = "/sucessoprocedimento";
                          } else {
                            document.location.href = "/algodeuerrado";
                          }
                        } else {
                          let formDataEmail = {
                            tipoEmail: 15,
                            valorPrincipal: valorPrincipal,
                            valor1Fracao: valor1Fracao,
                            valor2Fracao: valor2Fracao,
                            periodoUsuarioId: periodoUsuarioIdPrincipal,
                            periodoUsuarioId1Fracao: periodoUsuarioId1Fracao,
                            periodoUsuarioId2Fracao: periodoUsuarioId2Fracao,
                            valorSugeridoPrincipal:
                              periodoUsuarioData.valorSugerido,
                            valorSugerido1Fracao:
                              periodoUsuarioDataPrimeiroPeriodo.valorSugerido,
                            valorSugerido2Fracao:
                              periodoUsuarioDataSegundoPeriodo.valorSugerido,
                          };
                          let resultEmail = enviarEmail(formDataEmail);
                          if (await resultEmail) {
                            document.location.href = "/sucessoprocedimento";
                          } else {
                            document.location.href = "/algodeuerrado";
                          }
                        }
                      } else {
                        openNotificationWithIcon("error", "ErrosGerais");
                      }
                    } else {
                      openNotificationWithIcon("error", "ErrosGerais");
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }
                  break;
                case 8:
                  //já reservei
                  let resultado798 = atualizarSituacao(
                    1,
                    periodoUsuarioIdPrincipal,
                    false
                  );
                  if (await resultado798) {
                    let resultado2 = atualizarSituacao(
                      2,
                      periodoUsuarioId1Fracao,
                      false
                    );

                    if (await resultado2) {
                      let resultado1 = atualizarSituacao(
                        3,
                        periodoUsuarioId2Fracao,
                        false
                      );

                      if (await resultado1) {
                        let resultToken = desativarToken();
                        if (
                          periodoUsuarioData.divulgado === 1 ||
                          periodoUsuarioDataPrimeiroPeriodo.divulgado === 1 ||
                          periodoUsuarioDataSegundoPeriodo.divulgado === 1
                        ) {
                          if (await resultToken) {
                            document.location.href = "/sucessoprocedimento";
                          } else {
                            document.location.href = "/algodeuerrado";
                          }
                        } else {
                          let formDataEmail = {
                            tipoEmail: 15,
                            valorPrincipal: valorPrincipal,
                            valor1Fracao: valor1Fracao,
                            valor2Fracao: valor2Fracao,
                            periodoUsuarioId: periodoUsuarioIdPrincipal,
                            periodoUsuarioId1Fracao: periodoUsuarioId1Fracao,
                            periodoUsuarioId2Fracao: periodoUsuarioId2Fracao,
                          };
                          let resultEmail = enviarEmail(formDataEmail);
                          if (await resultEmail) {
                            document.location.href = "/sucessoprocedimento";
                          } else {
                            document.location.href = "/algodeuerrado";
                          }
                        }
                      } else {
                        openNotificationWithIcon("error", "ErrosGerais");
                      }
                    } else {
                      openNotificationWithIcon("error", "ErrosGerais");
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }
                  break;
                case 9:
                  //já utilizei
                  let resultado799 = atualizarSituacao(
                    1,
                    periodoUsuarioIdPrincipal,
                    false
                  );
                  if (await resultado799) {
                    let resultado2 = atualizarSituacao(
                      2,
                      periodoUsuarioId1Fracao,
                      false
                    );

                    if (await resultado2) {
                      let resultado1 = atualizarSituacao(
                        2,
                        periodoUsuarioId2Fracao,
                        false
                      );

                      if (await resultado1) {
                        let resultToken = desativarToken();
                        if (
                          periodoUsuarioData.divulgado === 1 ||
                          periodoUsuarioDataPrimeiroPeriodo.divulgado === 1 ||
                          periodoUsuarioDataSegundoPeriodo.divulgado === 1
                        ) {
                          if (await resultToken) {
                            document.location.href = "/sucessoprocedimento";
                          } else {
                            document.location.href = "/algodeuerrado";
                          }
                        } else {
                          let formDataEmail = {
                            tipoEmail: 15,
                            valorPrincipal: valorPrincipal,
                            valor1Fracao: valor1Fracao,
                            valor2Fracao: valor2Fracao,
                            periodoUsuarioId: periodoUsuarioIdPrincipal,
                            periodoUsuarioId1Fracao: periodoUsuarioId1Fracao,
                            periodoUsuarioId2Fracao: periodoUsuarioId2Fracao,
                          };
                          let resultEmail = enviarEmail(formDataEmail);
                          if (await resultEmail) {
                            document.location.href = "/sucessoprocedimento";
                          } else {
                            document.location.href = "/algodeuerrado";
                          }
                        }
                      } else {
                        openNotificationWithIcon("error", "ErrosGerais");
                      }
                    } else {
                      openNotificationWithIcon("error", "ErrosGerais");
                    }
                  } else {
                    openNotificationWithIcon("error", "ErrosGerais");
                  }
                  break;
              }
              break;
          }
          break;
        case 8:
          //já reservei
          let resultado8 = atualizarSituacao(
            3,
            periodoUsuarioIdPrincipal,
            false
          );
          if (await resultado8) {
            let result35 = naoFracione(
              periodoUsuarioIdPrincipal,
              periodoUsuarioData.divulgado,
              periodoUsuarioDataPrimeiroPeriodo.divulgado,
              periodoUsuarioDataSegundoPeriodo.divulgado,
              false
            );

            switch (await result35) {
              case 1:
                let resultToken = desativarToken();
                if (
                  periodoUsuarioData.divulgado === 1 ||
                  periodoUsuarioDataPrimeiroPeriodo.divulgado === 1 ||
                  periodoUsuarioDataSegundoPeriodo.divulgado === 1
                ) {
                  if (await resultToken) {
                    document.location.href = "/sucessoprocedimento";
                  } else {
                    document.location.href = "/algodeuerrado";
                  }
                } else {
                  let formDataEmail = {
                    tipoEmail: 15,
                    valorPrincipal: valorPrincipal,
                    valor1Fracao: valor1Fracao,
                    valor2Fracao: valor2Fracao,
                    periodoUsuarioId: periodoUsuarioIdPrincipal,
                    valorSugeridoPrincipal: periodoUsuarioData.valorSugerido,
                  };
                  let resultEmail = enviarEmail(formDataEmail);
                  if (await resultEmail) {
                    document.location.href = "/sucessoprocedimento";
                  } else {
                    document.location.href = "/algodeuerrado";
                  }
                }

                break;
              case 2:
              case 3:
              case 4:
                openNotificationWithIcon("error", "ErrosGerais");
                break;
            }
          }
          break;
        case 9:
          //já utilizei
          let resultado9 = atualizarSituacao(
            2,
            periodoUsuarioIdPrincipal,
            false
          );
          if (await resultado9) {
            let result35 = naoFracione(
              periodoUsuarioIdPrincipal,
              periodoUsuarioData.divulgado,
              periodoUsuarioDataPrimeiroPeriodo.divulgado,
              periodoUsuarioDataSegundoPeriodo.divulgado,
              false
            );

            switch (await result35) {
              case 1:
                let resultToken = desativarToken();
                if (
                  periodoUsuarioData.divulgado === 1 ||
                  periodoUsuarioDataPrimeiroPeriodo.divulgado === 1 ||
                  periodoUsuarioDataSegundoPeriodo.divulgado === 1
                ) {
                  if (await resultToken) {
                    document.location.href = "/sucessoprocedimento";
                  } else {
                    document.location.href = "/algodeuerrado";
                  }
                } else {
                  let formDataEmail = {
                    tipoEmail: 15,
                    valorPrincipal: valorPrincipal,
                    valor1Fracao: valor1Fracao,
                    valor2Fracao: valor2Fracao,
                    periodoUsuarioId: periodoUsuarioIdPrincipal,
                    valorSugeridoPrincipal: periodoUsuarioData.valorSugerido,
                  };
                  let resultEmail = enviarEmail(formDataEmail);
                  if (await resultEmail) {
                    document.location.href = "/sucessoprocedimento";
                  } else {
                    document.location.href = "/algodeuerrado";
                  }
                }

                break;
              case 2:
              case 3:
              case 4:
                openNotificationWithIcon("error", "ErrosGerais");
                break;
            }
          }

          break;
        case 10:
          //cota vendida
          let resultToken = desativarToken();
          // let resultToken =1;

          if (resultToken) {
            let resultCota = venderCota(false, periodoUsuarioData.id, 0);

            if ((await resultCota) === 1) {
              document.location.href = "/sucessoprocedimento";
            } else {
              document.location.href = "/algodeuerrado";
            }
          } else {
            openNotificationWithIcon("error", "ErrosGerais");
          }
          break;
      }
    }
  };
  const onSubmitPeriodoUnico = async () => {
    if (
      (nTipoEmail.tipoEmail === 3 || nTipoEmail.tipoEmail === 4) &&
      valueRadioPeriodoUnico === 1
    ) {
      openNotificationWithIcon("warning", "EscolherOpcao");
    } else {
      if (inputReservaPeriodoUnico === "" && valueRadioPeriodoUnico === 7) {
        openNotificationWithIcon("warning", "PreencherValor");
      } else {
        if (valueRadioPeriodoUnico === 4) {
          let valor = tratamentoValoresInput(inputNovoValorPeriodoUnico);
          if (valor) {
            if (nTipoEmail.tipoEmail) {
              atualizarPeriodoUsuarioPeloTipo(
                nTipoEmail.tipoEmail,
                true,
                valueRadioPeriodoUnico,
                valueRadio1Fracao,
                valueRadio2Fracao
              );
            }
          } else {
            openNotificationWithIcon("error", "ErroNoValor");
          }
        } else {
          if (valueRadioPeriodoUnico === 7) {
            let valor = tratamentoValoresInput(inputReservaPeriodoUnico);
            if (valor) {
              if (nTipoEmail.tipoEmail) {
                atualizarPeriodoUsuarioPeloTipo(
                  nTipoEmail.tipoEmail,
                  true,
                  valueRadioPeriodoUnico,
                  valueRadio1Fracao,
                  valueRadio2Fracao
                );
              }
            } else {
              openNotificationWithIcon("error", "ErroNoValor");
            }
          } else {
            if (nTipoEmail.tipoEmail) {
              atualizarPeriodoUsuarioPeloTipo(
                nTipoEmail.tipoEmail,
                true,
                valueRadioPeriodoUnico,
                valueRadio1Fracao,
                valueRadio2Fracao
              );
            }
          }
        }
      }
    }
  };

  const steps = ["Período principal", "1º fração", "2º fração"];
  const stepsFracao = ["1º fração", "2º fração"];
  // const items = steps.map((item) => ({ key: item.title, title: item.title }));

  const periodoUnico = (
    <Box sx={{ width: "100%", height: "100%" }}>
      <React.Fragment>
        <Box>
          <Typography sx={{ mt: 3, mb: 1 }}>
            <Container>
              <Space
                direction="vertical"
                size="large"
                style={{ display: "flex", minHeight: 40 }}
                align="center"
              >
                {periodoUsuarioData.status === "AGUARDANDO_SUGESTAO" ? (
                  <>
                    <Card
                      title="Atualização de período"
                      style={{ width: 500, marginTop: 10 }}
                    >
                      <p>
                        A Multicotas sugere que o período de{" "}
                        <span
                          style={{
                            fontWeight: "bold",
                            textDecoration: "underline",
                          }}
                        >
                          {formatarData(periodoUsuarioData.checkIn)} a{" "}
                          {formatarData(periodoUsuarioData.checkOut)}
                          <br />
                          do {periodoUsuarioData.nome}{" "}
                        </span>
                        seja alterado{" "}
                        {periodoUsuarioData.valorMin
                          ? `de R$${exibirMoeda(periodoUsuarioData.valorMin)} `
                          : ""}
                        para o valor de{" "}
                        <span
                          style={{
                            fontWeight: "bold",
                            textDecoration: "underline",
                          }}
                        >
                          R$
                          {exibirMoeda(periodoUsuarioData.valorSugerido)}.
                        </span>
                      </p>

                      <Radio.Group
                        onChange={onChangePeriodoUnico}
                        defaultValue={1}
                        value={valueRadioPeriodoUnico}
                      >
                        <Space direction="vertical">
                          <Radio value={1}>
                            Selecione uma das opções e clique no botão abaixo:
                          </Radio>
                          <Radio value={2}>
                            Confirmo as atualizações propostas e gostaria que,
                            nas próximas sugestões DESTE PERÍODO (SOMENTE
                            DESTE), a Multicotas decida qual a melhor opção, sem
                            precisar me consultar. (RECOMENDADO)
                          </Radio>
                          <Radio value={3}>
                            Confirmo as atualizações propostas e gostaria de
                            continuar decidindo se as próximas sugestões, caso
                            ocorram, são válidas.
                          </Radio>

                          <Radio value={4}>
                            Gostaria de incluir um novo valor{" "}
                            {valueRadioPeriodoUnico === 4 ? (
                              <Input
                                required
                                onChange={onChangeInputNovoValorPeriodoUnico}
                                style={{ width: 100, marginLeft: 10 }}
                              />
                            ) : null}
                          </Radio>
                          <Radio value={5}>
                            Rejeito as atualizações propostas, quero que deixe
                            do jeito que está.
                          </Radio>
                          <Radio value={6}>
                            Rejeito as atualizações propostas, e não quero mais
                            receber sugestões para ESTE PERÍODO (SOMENTE ESTE
                            PERÍODO).
                          </Radio>
                          <Radio value={7}>
                            Não quero mais alugar esse período, pois já reservei
                            por outros meios.
                            {valueRadioPeriodoUnico === 7 ? (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <Typography variant="body2">
                                  Valor reservado:{" "}
                                </Typography>
                                <Input
                                  required
                                  onChange={onChangeInputReservaPeriodoUnico}
                                  style={{
                                    width: 100,
                                    marginLeft: 5,
                                  }}
                                />
                              </div>
                            ) : null}
                          </Radio>
                          <Radio value={8}>
                            Não quero mais alugar esse período, pois decidi que
                            vou utilizar.
                          </Radio>
                          <Radio value={9}>
                            Não quero mais alugar esse período, pois não tenho
                            mais a propriedade.
                          </Radio>
                        </Space>
                      </Radio.Group>
                      <br />
                    </Card>

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        marginBottom: 2,
                      }}
                    >
                      {/* <Box sx={{ flex: "1 1" }} /> */}

                      <Button
                        onClick={onSubmitPeriodoUnico}
                        style={{
                          marginLeft: 50,
                          marginRight: 50,
                          backgroundColor: "#0984e3",
                          color: "#fff",
                        }}
                      >
                        Atualizar
                      </Button>
                    </Box>
                  </>
                ) : (
                  <>
                    <Card
                      title="Atualização de período"
                      style={{ width: 500, marginTop: 10 }}
                    >
                      <p>
                        Você nos solicitou uma atualização no período de{" "}
                        <span
                          style={{
                            fontWeight: "bold",
                            textDecoration: "underline",
                          }}
                        >
                          {formatarData(periodoUsuarioData.checkIn)} a{" "}
                          {formatarData(periodoUsuarioData.checkOut)} do{" "}
                          {periodoUsuarioData.nome}{" "}
                        </span>
                        para que seja alterado{" "}
                        {periodoUsuarioData.valorMin
                          ? `de R$${exibirMoeda(periodoUsuarioData.valorMin)} `
                          : ""}
                        para o valor de{" "}
                        <span
                          style={{
                            fontWeight: "bold",
                            textDecoration: "underline",
                          }}
                        >
                          R$
                          {exibirMoeda(periodoUsuarioData.valorSugerido)}.
                        </span>
                      </p>

                      <Radio.Group
                        onChange={onChangePeriodoUnico}
                        defaultValue={1}
                        value={valueRadioPeriodoUnico}
                      >
                        <Space direction="vertical">
                          <Radio value={1}>
                            Selecione uma das opções e clique no botão abaixo:
                          </Radio>
                          <Radio value={2}>
                            Confirmo as atualizações propostas e gostaria que,
                            nas próximas sugestões DESTE PERÍODO (SOMENTE
                            DESTE), a Multicotas decida qual a melhor opção, sem
                            precisar me consultar. (RECOMENDADO)
                          </Radio>
                          <Radio value={3}>
                            Confirmo as atualizações propostas e gostaria de
                            continuar decidindo se as próximas sugestões, caso
                            ocorram, são válidas.
                          </Radio>
                          <Radio value={4}>
                            Gostaria de incluir um novo valor{" "}
                            {valueRadioPeriodoUnico === 4 ? (
                              <Input
                                required
                                onChange={onChangeInputNovoValorPeriodoUnico}
                                style={{ width: 100, marginLeft: 10 }}
                              />
                            ) : null}
                          </Radio>
                          <Radio value={5}>
                            Rejeito as atualizações propostas, quero que deixe
                            do jeito que está.
                          </Radio>
                          <Radio value={6}>
                            Rejeito as atualizações propostas, e não quero mais
                            receber sugestões para ESTE PERÍODO (SOMENTE ESTE
                            PERÍODO).
                          </Radio>

                          <Radio value={7}>
                            Não quero mais alugar esse período, pois já reservei
                            por outros meios.
                            {valueRadioPeriodoUnico === 7 ? (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <Typography variant="body2">
                                  Valor reservado:{" "}
                                </Typography>
                                <Input
                                  required
                                  onChange={onChangeInputReservaPeriodoUnico}
                                  style={{
                                    width: 100,
                                    marginLeft: 5,
                                  }}
                                />
                              </div>
                            ) : null}
                          </Radio>
                          <Radio value={8}>
                            Não quero mais alugar esse período, pois decidi que
                            vou utilizar.
                          </Radio>
                          <Radio value={9}>
                            Não quero mais alugar esse período, pois não tenho
                            mais a propriedade.
                          </Radio>
                        </Space>
                      </Radio.Group>
                      <br />
                    </Card>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        marginBottom: 2,
                      }}
                    >
                      {/* <Box sx={{ flex: "1 1" }} /> */}

                      <Button
                        onClick={onSubmitPeriodoUnico}
                        style={{
                          marginLeft: 50,
                          marginRight: 50,
                          backgroundColor: "#0984e3",
                          color: "#fff",
                        }}
                      >
                        Atualizar
                      </Button>
                    </Box>
                  </>
                )}
              </Space>
            </Container>
          </Typography>
        </Box>
      </React.Fragment>
    </Box>
  );

  const periodoPrincipal = (
    <Container>
      <Space
        direction="vertical"
        size="large"
        style={{
          display: "flex",
          minHeight: 40,
          marginBottom: 20,
        }}
        align="center"
      >
        {periodoUsuarioData.status === "AGUARDANDO_SUGESTAO" ? (
          <>
            <Card
              title="Atualização do período principal"
              style={{ width: 500, marginTop: 10 }}
            >
              <p>
                A Multicotas sugere que o período de{" "}
                <span
                  style={{ fontWeight: "bold", textDecoration: "underline" }}
                >
                  {formatarData(periodoUsuarioData.checkIn)} a{" "}
                  {formatarData(periodoUsuarioData.checkOut)}
                  <br />
                  do {periodoUsuarioData.nome}
                </span>{" "}
                seja alterado{" "}
                {periodoUsuarioData.valorMin
                  ? `de R$${exibirMoeda(periodoUsuarioData.valorMin)} `
                  : ""}
                para o valor de{" "}
                <span
                  style={{ fontWeight: "bold", textDecoration: "underline" }}
                >
                  R$ {exibirMoeda(periodoUsuarioData.valorSugerido)}
                </span>
                .
              </p>

              <Radio.Group
                onChange={onChangePeriodoPrincipal}
                defaultValue={1}
                value={valueRadioPeriodoPrincipal}
              >
                <Space direction="vertical">
                  <Radio value={1}>
                    Selecione uma das opções e clique no botão abaixo:
                  </Radio>
                  <Radio value={2}>
                    Confirmo as atualizações propostas e gostaria que, nas
                    próximas sugestões DESTE PERÍODO (SOMENTE DESTE), a
                    Multicotas decida qual a melhor opção, sem precisar me
                    consultar. (RECOMENDADO)
                  </Radio>
                  <Radio value={3}>
                    Confirmo as atualizações propostas e gostaria de continuar
                    decidindo se as próximas sugestões, caso ocorram, são
                    válidas.
                  </Radio>

                  <Radio value={4}>
                    Gostaria de incluir um novo valor{" "}
                    {valueRadioPeriodoPrincipal === 4 ? (
                      <Input
                        required
                        onChange={onChangeInputNovoValorPeriodoPrincipal}
                        style={{
                          width: 100,
                          marginLeft: 10,
                        }}
                      />
                    ) : null}
                  </Radio>
                  <Radio value={5}>
                    Rejeito as atualizações propostas, quero que deixe do jeito
                    que está.
                  </Radio>
                  <Radio value={6}>
                    Rejeito as atualizações propostas, e não quero mais receber
                    sugestões para ESTE PERÍODO (SOMENTE ESTE PERÍODO).
                  </Radio>
                  <Radio value={7}>
                    Já utilizei ou reservei apenas uma parte do período.
                  </Radio>
                  <Radio value={8}>
                    Não quero mais alugar esse período, pois já reservei por
                    outros meios.
                    {valueRadioPeriodoPrincipal === 8 ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="body2">
                          Valor reservado:{" "}
                        </Typography>
                        <Input
                          required
                          onChange={onChangeInputReservaPeriodoPrincipal}
                          style={{
                            width: 100,
                            marginLeft: 5,
                          }}
                        />
                      </div>
                    ) : null}
                  </Radio>
                  <Radio value={9}>
                    Não quero mais alugar esse período, pois decidi que vou
                    utilizar.
                  </Radio>
                  <Radio value={10}>
                    Não quero mais alugar esse período, pois não tenho mais a
                    propriedade.
                  </Radio>
                </Space>
              </Radio.Group>
              <br />
            </Card>
            <Space align="end">
              {/* <Button onClick={onSubmit} type="primary">
                        Atualizar
                      </Button> */}
            </Space>
          </>
        ) : (
          <>
            <Card
              title="Atualização do período principal"
              style={{ width: 500, marginTop: 10 }}
            >
              <p>
                Você nos solicitou uma atualização no período de{" "}
                <span
                  style={{ fontWeight: "bold", textDecoration: "underline" }}
                >
                  {formatarData(periodoUsuarioData.checkIn)} a{" "}
                  {formatarData(periodoUsuarioData.checkOut)} do{" "}
                  {periodoUsuarioData.nome}
                </span>{" "}
                para que seja alterado{" "}
                {periodoUsuarioData.valorMin
                  ? `de R$${exibirMoeda(periodoUsuarioData.valorMin)} `
                  : ""}
                para o valor de{" "}
                <span
                  style={{ fontWeight: "bold", textDecoration: "underline" }}
                >
                  R$
                  {exibirMoeda(periodoUsuarioData.valorSugerido)}.
                </span>
              </p>

              <Radio.Group
                onChange={onChangePeriodoPrincipal}
                defaultValue={1}
                value={valueRadioPeriodoPrincipal}
              >
                <Space direction="vertical">
                  <Radio value={1}>
                    Selecione uma das opções e clique no botão abaixo:
                  </Radio>

                  <Radio value={2}>
                    Confirmo as atualizações propostas e gostaria que, nas
                    próximas sugestões DESTE PERÍODO (SOMENTE DESTE), a
                    Multicotas decida qual a melhor opção, sem precisar me
                    consultar. (RECOMENDADO)
                  </Radio>
                  <Radio value={3}>
                    Confirmo as atualizações propostas e gostaria de continuar
                    decidindo se as próximas sugestões, caso ocorram, são
                    válidas.
                  </Radio>
                  <Radio value={4}>
                    Gostaria de incluir um novo valor{" "}
                    {valueRadioPeriodoPrincipal === 4 ? (
                      <Input
                        required
                        onChange={onChangeInputNovoValorPeriodoPrincipal}
                        style={{
                          width: 100,
                          marginLeft: 10,
                        }}
                      />
                    ) : null}
                  </Radio>
                  <Radio value={5}>
                    Rejeito as atualizações propostas, quero que deixe do jeito
                    que está.
                  </Radio>
                  <Radio value={6}>
                    Rejeito as atualizações propostas, e não quero mais receber
                    sugestões para ESTE PERÍODO (SOMENTE ESTE PERÍODO).
                  </Radio>
                  <Radio value={7}>
                    Já utilizei ou reservei apenas uma parte do período.
                  </Radio>
                  <Radio value={8}>
                    Não quero mais alugar esse período, pois já reservei por
                    outros meios.
                    {valueRadioPeriodoPrincipal === 8 ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="body2">
                          Valor reservado:{" "}
                        </Typography>
                        <Input
                          required
                          onChange={onChangeInputReservaPeriodoPrincipal}
                          style={{
                            width: 100,
                            marginLeft: 5,
                          }}
                        />
                      </div>
                    ) : null}
                  </Radio>
                  <Radio value={9}>
                    Não quero mais alugar esse período, pois decidi que vou
                    utilizar.
                  </Radio>
                  <Radio value={10}>
                    Não quero mais alugar esse período, pois não tenho mais a
                    propriedade.
                  </Radio>
                </Space>
              </Radio.Group>
              <br />
            </Card>
            <Space align="end"></Space>
          </>
        )}
      </Space>
    </Container>
  );
  const primeiraFracao = (
    <Container>
      <Space
        direction="vertical"
        size="large"
        style={{
          display: "flex",
          minHeight: 40,
          marginBottom: 20,
        }}
        align="center"
      >
        {periodoUsuarioDataPrimeiroPeriodo.status === "AGUARDANDO_SUGESTAO" ? (
          <>
            <Card
              title="Atualização da 1º fração"
              style={{ width: 500, marginTop: 10 }}
            >
              <p>
                A Multicotas sugere que o período de{" "}
                <span
                  style={{ fontWeight: "bold", textDecoration: "underline" }}
                >
                  {formatarData(periodoUsuarioDataPrimeiroPeriodo.checkIn)} a{" "}
                  {formatarData(periodoUsuarioDataPrimeiroPeriodo.checkOut)}
                  <br />
                  do {periodoUsuarioDataPrimeiroPeriodo.nome}{" "}
                </span>{" "}
                seja alterado{" "}
                {periodoUsuarioDataPrimeiroPeriodo.valorMin
                  ? `de R$${exibirMoeda(
                      periodoUsuarioDataPrimeiroPeriodo.valorMin
                    )} `
                  : ""}
                para o valor de{" "}
                <span
                  style={{ fontWeight: "bold", textDecoration: "underline" }}
                >
                  R$
                  {exibirMoeda(periodoUsuarioDataPrimeiroPeriodo.valorSugerido)}
                  .
                </span>
              </p>

              <Radio.Group
                onChange={onChange1Fracao}
                defaultValue={1}
                value={valueRadio1Fracao}
              >
                <Space direction="vertical">
                  <Radio value={1}>Selecione uma das opções abaixo:</Radio>
                  <Radio value={2}>
                    Confirmo as atualizações propostas e gostaria que, nas
                    próximas sugestões DESTE PERÍODO (SOMENTE DESTE), a
                    Multicotas decida qual a melhor opção, sem precisar me
                    consultar. (RECOMENDADO)
                  </Radio>
                  <Radio value={3}>
                    Confirmo as atualizações propostas e gostaria de continuar
                    decidindo se as próximas sugestões, caso ocorram, são
                    válidas.
                  </Radio>

                  <Radio value={4}>
                    Gostaria de incluir um novo valor{" "}
                    {valueRadio1Fracao === 4 ? (
                      <Input
                        required
                        onChange={onChangeInputNovoValor1Fracao}
                        style={{
                          width: 100,
                          marginLeft: 10,
                        }}
                      />
                    ) : null}
                  </Radio>
                  <Radio value={5}>
                    Não gostaria de fracionar o período principal.
                  </Radio>
                  <Radio value={6}>
                    Mantenha o período fracionado, mas rejeito as atualizações
                    propostas, quero que deixe do jeito que está.
                  </Radio>
                  <Radio value={7}>
                    Mantenha o período fracionado, mas rejeito as atualizações
                    propostas, e não quero mais receber sugestões para ESTE
                    PERÍODO (SOMENTE ESTE PERÍODO).
                  </Radio>
                  <Radio value={8}>
                    Não quero mais alugar esse período fracionado, pois já
                    reservei por outros meios.
                    {valueRadio1Fracao === 8 ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="body2">
                          Valor reservado:{" "}
                        </Typography>
                        <Input
                          required
                          onChange={onChangeInputReserva1Fracao}
                          style={{
                            width: 100,
                            marginLeft: 5,
                          }}
                        />
                      </div>
                    ) : null}
                  </Radio>
                  <Radio value={9}>
                    Não quero mais alugar esse período fracionado, pois decidi
                    que vou utilizar.
                  </Radio>
                </Space>
              </Radio.Group>
              <br />
            </Card>
            <Space align="end">
              {/* <Button onClick={onSubmit} type="primary">
  Atualizar
</Button> */}
            </Space>
          </>
        ) : (
          <>
            <Card
              title="Atualização da 1º fração"
              style={{ width: 500, marginTop: 10 }}
            >
              <p>
                Você nos solicitou uma atualização no período de{" "}
                <span
                  style={{ fontWeight: "bold", textDecoration: "underline" }}
                >
                  {formatarData(periodoUsuarioDataPrimeiroPeriodo.checkIn)} a{" "}
                  {formatarData(periodoUsuarioDataPrimeiroPeriodo.checkOut)} do{" "}
                  {periodoUsuarioDataPrimeiroPeriodo.nome}{" "}
                </span>{" "}
                para que seja alterado{" "}
                {periodoUsuarioDataPrimeiroPeriodo.valorMin
                  ? `de R$${exibirMoeda(
                      periodoUsuarioDataPrimeiroPeriodo.valorMin
                    )} `
                  : ""}
                para o valor de{" "}
                <span
                  style={{ fontWeight: "bold", textDecoration: "underline" }}
                >
                  R$
                  {exibirMoeda(periodoUsuarioDataPrimeiroPeriodo.valorSugerido)}
                  .
                </span>
              </p>

              <Radio.Group
                onChange={onChange1Fracao}
                defaultValue={1}
                value={valueRadio1Fracao}
              >
                <Space direction="vertical">
                  <Radio value={1}>Selecione uma das opções abaixo:</Radio>
                  <Radio value={2}>
                    Confirmo as atualizações propostas e gostaria que, nas
                    próximas sugestões DESTE PERÍODO (SOMENTE DESTE), a
                    Multicotas decida qual a melhor opção, sem precisar me
                    consultar. (RECOMENDADO)
                  </Radio>
                  <Radio value={3}>
                    Confirmo as atualizações propostas e gostaria de continuar
                    decidindo se as próximas sugestões, caso ocorram, são
                    válidas.
                  </Radio>
                  <Radio value={4}>
                    Gostaria de incluir um novo valor{" "}
                    {valueRadio1Fracao === 4 ? (
                      <Input
                        required
                        onChange={onChangeInputNovoValor1Fracao}
                        style={{
                          width: 100,
                          marginLeft: 10,
                        }}
                      />
                    ) : null}
                  </Radio>
                  <Radio value={5}>
                    Não gostaria de fracionar o período principal.
                  </Radio>
                  <Radio value={6}>
                    Mantenha o período fracionado, mas rejeito as atualizações
                    propostas, quero que deixe do jeito que está.
                  </Radio>
                  <Radio value={7}>
                    Mantenha o período fracionado, mas rejeito as atualizações
                    propostas, e não quero mais receber sugestões para ESTE
                    PERÍODO (SOMENTE ESTE PERÍODO).
                  </Radio>
                  <Radio value={8}>
                    Não quero mais alugar esse período fracionado, pois já
                    reservei por outros meios.
                    {valueRadio1Fracao === 8 ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="body2">
                          Valor reservado:{" "}
                        </Typography>
                        <Input
                          required
                          onChange={onChangeInputReserva1Fracao}
                          style={{
                            width: 100,
                            marginLeft: 5,
                          }}
                        />
                      </div>
                    ) : null}
                  </Radio>
                  <Radio value={9}>
                    Não quero mais alugar esse período fracionado, pois decidi
                    que vou utilizar.
                  </Radio>
                </Space>
              </Radio.Group>
              <br />
            </Card>
            <Space align="end">
              {/* <Button onClick={onSubmit} type="primary">
  Atualizar
</Button> */}
            </Space>
          </>
        )}
      </Space>
    </Container>
  );

  const segundaFracao = (
    <Container>
      <Space
        direction="vertical"
        size="large"
        style={{
          display: "flex",
          minHeight: 40,
          marginBottom: 20,
        }}
        align="center"
      >
        {periodoUsuarioDataSegundoPeriodo.status === "AGUARDANDO_SUGESTAO" ? (
          <>
            <Card
              title="Atualização da 2º fração"
              style={{ width: 500, marginTop: 10 }}
            >
              <p>
                A Multicotas sugere que o período de{" "}
                <span
                  style={{ fontWeight: "bold", textDecoration: "underline" }}
                >
                  {formatarData(periodoUsuarioDataSegundoPeriodo.checkIn)} a{" "}
                  {formatarData(periodoUsuarioDataSegundoPeriodo.checkOut)}
                  <br />
                  do {periodoUsuarioDataSegundoPeriodo.nome}
                </span>{" "}
                seja alterado{" "}
                {periodoUsuarioDataSegundoPeriodo.valorMin
                  ? `de R$${exibirMoeda(
                      periodoUsuarioDataSegundoPeriodo.valorMin
                    )} `
                  : ""}
                para o valor de{" "}
                <span
                  style={{ fontWeight: "bold", textDecoration: "underline" }}
                >
                  R$
                  {exibirMoeda(periodoUsuarioDataSegundoPeriodo.valorSugerido)}.
                </span>
              </p>

              <Radio.Group
                onChange={onChange2Fracao}
                defaultValue={1}
                value={valueRadio2Fracao}
              >
                <Space direction="vertical">
                  <Radio value={1}>Selecione uma das opções abaixo:</Radio>
                  <Radio value={2}>
                    Confirmo as atualizações propostas e gostaria que, nas
                    próximas sugestões DESTE PERÍODO (SOMENTE DESTE), a
                    Multicotas decida qual a melhor opção, sem precisar me
                    consultar. (RECOMENDADO)
                  </Radio>
                  <Radio value={3}>
                    Confirmo as atualizações propostas e gostaria de continuar
                    decidindo se as próximas sugestões, caso ocorram, são
                    válidas.
                  </Radio>

                  <Radio value={4}>
                    Gostaria de incluir um novo valor{" "}
                    {valueRadio2Fracao === 4 ? (
                      <Input
                        required
                        onChange={onChangeInputNovoValor2Fracao}
                        style={{
                          width: 100,
                          marginLeft: 10,
                        }}
                      />
                    ) : null}
                  </Radio>
                  <Radio value={5}>
                    Não gostaria de fracionar o período principal.
                  </Radio>
                  <Radio value={6}>
                    Mantenha o período fracionado, mas rejeito as atualizações
                    propostas, quero que deixe do jeito que está.
                  </Radio>
                  <Radio value={7}>
                    Mantenha o período fracionado, mas rejeito as atualizações
                    propostas, e não quero mais receber sugestões para ESTE
                    PERÍODO (SOMENTE ESTE PERÍODO).
                  </Radio>
                  <Radio value={8}>
                    Não quero mais alugar esse período fracionado, pois já
                    reservei por outros meios.
                    {valueRadio2Fracao === 8 ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="body2">
                          Valor reservado:{" "}
                        </Typography>
                        <Input
                          required
                          onChange={onChangeInputReserva2Fracao}
                          style={{
                            width: 100,
                            marginLeft: 5,
                          }}
                        />
                      </div>
                    ) : null}
                  </Radio>
                  <Radio value={9}>
                    Não quero mais alugar esse período fracionado, pois decidi
                    que vou utilizar.
                  </Radio>
                </Space>
              </Radio.Group>
              <br />
            </Card>
            <Space align="end">
              {/* <Button onClick={onSubmit} type="primary">
  Atualizar
</Button> */}
            </Space>
          </>
        ) : (
          <>
            <Card
              title="Atualização da 2º fração"
              style={{ width: 500, marginTop: 10 }}
            >
              <p>
                Você nos solicitou uma atualização no período de{" "}
                <span
                  style={{ fontWeight: "bold", textDecoration: "underline" }}
                >
                  {formatarData(periodoUsuarioDataSegundoPeriodo.checkIn)} a{" "}
                  {formatarData(periodoUsuarioDataSegundoPeriodo.checkOut)} do{" "}
                  {periodoUsuarioDataSegundoPeriodo.nome}{" "}
                </span>
                para que seja alterado{" "}
                {periodoUsuarioDataSegundoPeriodo.valorMin
                  ? `de R$${exibirMoeda(
                      periodoUsuarioDataSegundoPeriodo.valorMin
                    )} `
                  : ""}
                para o valor de{" "}
                <span
                  style={{ fontWeight: "bold", textDecoration: "underline" }}
                >
                  R$
                  {exibirMoeda(periodoUsuarioDataSegundoPeriodo.valorSugerido)}.
                </span>
              </p>

              <Radio.Group
                onChange={onChange2Fracao}
                defaultValue={1}
                value={valueRadio2Fracao}
              >
                <Space direction="vertical">
                  <Radio value={1}>Selecione uma das opções abaixo:</Radio>
                  <Radio value={2}>
                    Confirmo as atualizações propostas e gostaria que, nas
                    próximas sugestões DESTE PERÍODO (SOMENTE DESTE), a
                    Multicotas decida qual a melhor opção, sem precisar me
                    consultar. (RECOMENDADO)
                  </Radio>
                  <Radio value={3}>
                    Confirmo as atualizações propostas e gostaria de continuar
                    decidindo se as próximas sugestões, caso ocorram, são
                    válidas.
                  </Radio>
                  <Radio value={4}>
                    Gostaria de incluir um novo valor{" "}
                    {valueRadio2Fracao === 4 ? (
                      <Input
                        required
                        onChange={onChangeInputNovoValor2Fracao}
                        style={{
                          width: 100,
                          marginLeft: 10,
                        }}
                      />
                    ) : null}
                  </Radio>
                  <Radio value={5}>
                    Não gostaria de fracionar o período principal.
                  </Radio>
                  <Radio value={6}>
                    Mantenha o período fracionado, mas rejeito as atualizações
                    propostas, quero que deixe do jeito que está.
                  </Radio>
                  <Radio value={7}>
                    Mantenha o período fracionado, mas rejeito as atualizações
                    propostas, e não quero mais receber sugestões para ESTE
                    PERÍODO (SOMENTE ESTE PERÍODO).
                  </Radio>
                  <Radio value={8}>
                    Não quero mais alugar esse período fracionado, pois já
                    reservei por outros meios.
                    {valueRadio2Fracao === 8 ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="body2">
                          Valor reservado:{" "}
                        </Typography>
                        <Input
                          required
                          onChange={onChangeInputReserva2Fracao}
                          style={{
                            width: 100,
                            marginLeft: 5,
                          }}
                        />
                      </div>
                    ) : null}
                  </Radio>
                  <Radio value={9}>
                    Não quero mais alugar esse período fracionado, pois decidi
                    que vou utilizar.
                  </Radio>
                </Space>
              </Radio.Group>
              <br />
            </Card>
          </>
        )}
      </Space>
    </Container>
  );

  return (
    <>
      {contextHolder}
      {isLoading ? (
        <Skeleton active />
      ) : (
        <>
          {nTipoEmail.tipoEmail === 3 || nTipoEmail.tipoEmail === 4 ? (
            periodoUnico
          ) : nTipoEmail.tipoEmail === 7 || nTipoEmail.tipoEmail === 8 ? (
            <>
              <Box sx={{ width: "100%", height: "100%" }}>
                <Stepper
                  style={{ marginTop: 20, marginLeft: 50, marginRight: 50 }}
                  activeStep={activeStep}
                >
                  {stepsFracao.map((label, index) => {
                    const stepProps: { completed?: boolean } = {};
                    const labelProps: {
                      optional?: React.ReactNode;
                    } = {};

                    if (isStepSkipped(index)) {
                      stepProps.completed = false;
                    }

                    return (
                      <Step {...stepProps}>
                        <StepLabel {...labelProps}>{label}</StepLabel>
                      </Step>
                    );
                  })}
                </Stepper>
                {activeStep === stepsFracao.length ? (
                  <>
                    <React.Fragment>
                      <ContainerSucess>
                        <Collapse in={openSucess}>
                          <>
                            <Alert
                              severity="success"
                              onClose={() => setOpenSucess(false)}
                            >
                              A Multicotas agradece pelas informações prestadas.
                              Em breve você receberá um e-mail com a comprovação
                              da sua escolha. Somente após o recebimento desse
                              as informações prestadas serão consideradas
                              válidas. Até lá, permanecerão as informações
                              antigas.
                            </Alert>
                          </>
                        </Collapse>
                      </ContainerSucess>

                      <Box
                        sx={{ display: "flex", flexDirection: "row", pt: 2 }}
                      >
                        <Box sx={{ flex: "1 1 auto" }} />
                      </Box>
                    </React.Fragment>
                  </>
                ) : (
                  <>
                    <React.Fragment>
                      <Box>
                        <Typography sx={{ mt: 1, mb: 1 }}>
                          {activeStep === 0 ? primeiraFracao : segundaFracao}
                        </Typography>

                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            pt: 2,
                          }}
                        >
                          <Button
                            color="inherit"
                            disabled={activeStep === 0}
                            onClick={handleBack}
                            sx={{ mr: 1 }}
                            style={{
                              marginLeft: 50,
                              marginRight: 50,
                            }}
                          >
                            Voltar
                          </Button>
                          <Box sx={{ flex: "1 1" }} />

                          <Button
                            onClick={handleNext}
                            style={{
                              marginLeft: 50,
                              marginRight: 50,
                              backgroundColor: "#0984e3",
                              color: "#fff",
                            }}
                          >
                            {activeStep === stepsFracao.length - 1
                              ? "Finalizar"
                              : "Próximo"}
                          </Button>
                        </Box>
                      </Box>
                    </React.Fragment>
                  </>
                )}
              </Box>
            </>
          ) : (
            <Box sx={{ width: "100%", height: "100%" }}>
              <Stepper
                style={{ marginTop: 20, marginLeft: 50, marginRight: 50 }}
                activeStep={activeStep}
              >
                {steps.map((label, index) => {
                  const stepProps: { completed?: boolean } = {};
                  const labelProps: {
                    optional?: React.ReactNode;
                  } = {};

                  if (isStepSkipped(index)) {
                    stepProps.completed = false;
                  }

                  return (
                    <Step {...stepProps}>
                      <StepLabel {...labelProps}>{label}</StepLabel>
                    </Step>
                  );
                })}
              </Stepper>
              {activeStep === steps.length || openSucess === true ? (
                <>
                  <React.Fragment>
                    <ContainerSucess>
                      <Collapse in={openSucess}>
                        <>
                          <Alert
                            severity="success"
                            onClose={() => setOpenSucess(false)}
                          >
                            Período atualizado com sucesso. Muito obrigado!
                          </Alert>
                        </>
                      </Collapse>
                    </ContainerSucess>

                    <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                      <Box sx={{ flex: "1 1 auto" }} />
                    </Box>
                  </React.Fragment>
                </>
              ) : (
                <>
                  <React.Fragment>
                    <Box>
                      <Typography sx={{ mt: 1, mb: 1 }}>
                        {activeStep === 0
                          ? periodoPrincipal
                          : activeStep === 1
                          ? primeiraFracao
                          : segundaFracao}
                      </Typography>

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          pt: 2,
                        }}
                      >
                        <Button
                          color="inherit"
                          disabled={activeStep === 0}
                          onClick={handleBack}
                          sx={{ mr: 1 }}
                          style={{
                            marginLeft: 50,
                            marginRight: 50,
                          }}
                        >
                          Voltar
                        </Button>
                        <Box sx={{ flex: "1 1" }} />

                        <Button
                          onClick={handleNext}
                          // disabled={emPreparo.current}
                          style={{
                            marginLeft: 50,
                            marginRight: 50,
                            backgroundColor: "#0984e3",
                            color: "#fff",
                          }}
                        >
                          {activeStep === steps.length - 1
                            ? "Finalizar"
                            : "Próximo"}
                        </Button>
                      </Box>
                    </Box>
                  </React.Fragment>
                </>
              )}
            </Box>
          )}
        </>
      )}
      ;
    </>
  );
}
